var _style, _polygon, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfcLogoSli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 778.9 392.3",
    style: {
      enableBackground: "new 0 0 778.9 392.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000106835777028090103630000015707196575637656198_);}\n\t.st2{fill:url(#SVGID_00000065056964555625910210000001739826229886998918_);}\n\t.st3{fill:url(#SVGID_00000036229683999421752260000003530451932712940691_);}\n\t.st4{fill:url(#SVGID_00000067942392604810918340000002968547379728731318_);}\n\t.st5{fill:url(#SVGID_00000081611982235531253480000008158801786496121734_);}\n\t.st6{fill:url(#SVGID_00000139286671829390379520000005716213679313896367_);}\n\t.st7{fill:url(#SVGID_00000016777167453361001190000010260158310733668789_);}\n\t.st8{fill:url(#SVGID_00000132054159490428735100000015657317432928448643_);}\n\t.st9{fill:url(#SVGID_00000147195979719397222780000015741015268911559054_);}\n\t.st10{fill:url(#SVGID_00000034776083083665021740000012411740263047981727_);}\n\t.st11{fill:url(#SVGID_00000005237397786684957860000013208238968301857682_);}\n\t.st12{fill:url(#SVGID_00000161617763058591025820000002740419306977568959_);}\n\t.st13{fill:url(#SVGID_00000157299681151819020180000012985950767255104146_);}\n\t.st14{fill:url(#SVGID_00000129906471556361343060000006427052660983504303_);}\n\t.st15{fill:url(#SVGID_00000150801888435982730780000003360635308181458071_);}\n\t.st16{fill:url(#SVGID_00000083050253570168912490000006182833322793561533_);}\n\t.st17{fill:url(#SVGID_00000124140194299995801880000001251019655866568893_);}\n\t.st18{fill:url(#SVGID_00000007410463780891330950000017209300977199566218_);}\n\t.st19{fill:url(#SVGID_00000066473772979527500220000014482668560494371478_);}\n\t.st20{fill:url(#SVGID_00000139273189111429323370000013140847383367264393_);}\n\t.st21{fill:url(#SVGID_00000061437998725852566960000003510927040203954350_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 684.7674,
    y1: 46.9171,
    x2: 684.7674,
    y2: 46.915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "684.8,46.9 684.8,46.9 684.8,46.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151522500752402385090000000734479608730705580_",
    gradientUnits: "userSpaceOnUse",
    x1: 569.3784,
    y1: 74.7531,
    x2: 569.3784,
    y2: 74.5613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151522500752402385090000000734479608730705580_)"
    },
    d: "M568.7,74.8c0.4-0.1,0.9-0.1,1.3-0.2 c-0.4,0-0.9,0-1.3,0C568.7,74.6,568.7,74.7,568.7,74.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157281448655196335130000007314458053987098271_",
    gradientUnits: "userSpaceOnUse",
    x1: 700.6511,
    y1: 113.1633,
    x2: 700.6511,
    y2: 113.1137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157281448655196335130000007314458053987098271_)"
    },
    d: "M700.7,113.1 C700.6,113.2,700.6,113.2,700.7,113.1L700.7,113.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116230565835854952190000018268300418128531895_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.5123,
    y1: 46.1198,
    x2: 634.5123,
    y2: 46.0672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116230565835854952190000018268300418128531895_)"
    },
    d: "M634.5,46.1 C634.5,46.1,634.5,46.1,634.5,46.1C634.5,46.1,634.5,46.1,634.5,46.1C634.5,46.1,634.5,46.1,634.5,46.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005258896544083779660000013787753575295925174_",
    gradientUnits: "userSpaceOnUse",
    x1: 612.0902,
    y1: 220.0711,
    x2: 612.0902,
    y2: 9.8828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005258896544083779660000013787753575295925174_)"
    },
    d: "M510.5,113.2c-0.3,1.2-0.5,1.8-0.7,2.4 c0.1,0,0.2,0.1,0.3,0.1c0.5-1,1-1.9,1.6-3.1c0.2,0.8,0.4,1.3,0.6,1.9c0.7-1.7,1.3-3.2,2.2-5.2c0.4,1.1,0.5,1.7,0.7,2.3 c0-0.6-0.1-1.1-0.1-1.9c0.4,0.6,0.7,0.9,1,1.3c0.4-1,0.6-1.7,0.9-2.5c0.3,0.6,0.5,1.2,0.7,1.7c0.1,0,0.2,0,0.2-0.1 c-0.1-0.5-0.2-1-0.3-1.6c0.6,0.3,1,0.5,1,0.5c0.9-1.1,1.6-2.2,2.7-3.5c0,1.2,0,2,0,2.6c0.7-0.5,1.5-1,2.3-1.6 c0,0.6-0.1,1.2-0.1,1.7c0.1,0,0.2,0,0.3,0c0.4-1.1,0.9-2.2,1.3-3.4c3,3.2,3.1-0.6,4.6-2.1c-0.4,1.4-0.7,2.5-0.9,3.6 c0.2-0.1,0.4-0.2,0.7-0.3c0.4,0.5,0.7,1.1,1.1,1.6c0.8-1.1,2-3,3.6-1.4c2.2,2.2,3,0.6,4.2-0.8c1-1.2,2.1-2.4,3.1-3.6 c0.1,0.1,0.3,0.2,0.4,0.4c-1,1.3-2.1,2.7-3.4,4.3c1.2-0.5,1.9-0.8,2.6-1.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1,0 c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.2,0.2-0.3,0.3-0.5c0,0.2,0.1,0.3,0.1,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.8,0.1,1.7,0.1,2.5,0.2 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0.1,0.5,0.2,0.7,0.4 c1.6-0.1,3.2-0.2,4.9-0.2c0.1,0,0.2,0.1,0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0,0,0,0c-0.1,0.1-0.3,0.3-0.4,0.4c0,0,0,0,0,0 c0,0.1-0.1,0.3-0.1,0.4c0.6,0.9,1.3,1.8,2.6,1.1c1.1-0.6,2.2-1.2,3.5-1.8c-0.1,0.5-0.1,0.8-0.2,1.3c2.4-1.7,4.6-3.3,6.8-5 c0.1,0.1,0.2,0.2,0.3,0.4c-2.4,2-4.8,3.9-7.2,5.9c0.1,0.1,0.2,0.3,0.3,0.4c3.2-2.5,6.3-5.1,9.5-7.6c-2.3,3.5-5.3,6-9,7.8 c-0.6,0.3-1.1,0.8-1.6,1.2c0.1,0.2,0.2,0.4,0.3,0.5c1.3-0.6,2.5-1.1,3.8-1.7c0.1,0.2,0.2,0.3,0.3,0.5c-0.6,0.5-1.3,1-1.8,1.6 c-1.1,1.2-2,2.4-3,3.7c0.1,0.1,0.3,0.2,0.4,0.3c1.3-0.9,2.6-1.7,3.9-2.5c-2.5,5.5-5.1,11-7.6,16.6c0.2,0.1,0.4,0.2,0.6,0.3 c0.4-0.6,0.9-1.3,1.3-2c0.1,0.9,0.1,1.7,0.2,2.9c0.5-1.7,0.9-2.8,1.3-3.9c0.1,0,0.2,0,0.3,0.1c-0.1,1-0.2,2-0.3,3.1 c0.1,0,0.1,0,0.2,0c0.4-1.6,0.7-3.1,1.2-5c0.2,0.7,0.3,1,0.4,1.6c0.1-0.8,0.2-1.2,0.3-2.1c0.2,0.8,0.3,1.2,0.5,1.8 c0.1-0.8,0.2-1.3,0.3-1.9c0.1,0,0.1,0,0.2,0c0.1,0.5,0.2,0.9,0.3,1.3c0.2-1,0.5-2.1,0.8-3.4c0.2,0.5,0.3,0.7,0.4,0.9 c0-0.1,0-0.3,0-0.4c0.2-0.9-0.9-2.1,0.5-2.8c0.1-0.1,0.1-0.4,0.2-1.1c0.3,2,0.5,3.4,0.8,5c0.9-3.1,1.7-6,2.7-9.2 c-0.2,2.5-0.3,4.7-0.4,6.9c0,0,0.1,0,0.1,0c0.9-4.6,1.8-9.1,2.7-13.7c0.2,0,0.3,0.1,0.5,0.1c-0.3,1.7-0.6,3.4-0.9,5.2 c0.1,0,0.2,0,0.2,0c0.6-2,1.2-4,1.9-6.1c0.1,0,0.1,0,0.2,0.1c-0.1,1.2-0.2,2.4-0.3,3.7c0.1,0,0.1,0,0.2,0c0.6-2,1.2-4,1.9-6 c0.1,0,0.2,0.1,0.4,0.1c-0.4,4.3-0.8,8.6-1.3,13.4c0.9-4.7,1.6-8.9,2.4-13.1c0.2,0,0.4,0.1,0.7,0.1c-0.3,3.5-0.6,7-0.9,10.5 c0.1,0,0.2,0,0.3,0c0.6-3.6,1.2-7.3,1.8-11.1c1.2,3.5,2.3,6.7,3.4,9.9c0.1,0,0.3-0.1,0.4-0.1c-0.7-2.9-1.4-5.8-2.2-8.6 c0.2-0.1,0.4-0.1,0.6-0.2c1,3,2,6,3,9c0.1,0,0.2-0.1,0.3-0.1c-1-3.5-2-6.9-3-10.4c0.2-0.1,0.4-0.1,0.5-0.2c1.3,2.8,2.5,5.6,3.8,8.4 c0.1,0,0.2-0.1,0.2-0.1c-0.5-1.6-0.9-3.1-1.5-4.8c0.8,0.2,1.5,0.3,1.7,0.6c1.3,2.7,2.4,5.5,3.6,8.3c0.1,0,0.2-0.1,0.3-0.1 c-1.2-3.9-2.5-7.7-3.9-12c0.7,0.9,1.1,1.4,1.4,1.8c0-1.3,0-2.6,0-3.9c0.2,0,0.4-0.1,0.6-0.1c0.9,3.3,1.9,6.5,2.8,9.9 c0.1-0.6,0.2-1.1,0.4-2.1c0.6,3.3,1,6.1,1.5,8.8c0.1,0,0.2,0,0.3,0c-0.3-2.6-0.6-5.1-0.9-8.1c0.8,2.1,1.5,3.7,2.1,5.4 c0.3-1.2,0.4-2.4,0.3-3.5c-0.1-1.2-0.3-2.4-0.4-3.5c0.1,0,0.2,0,0.3-0.1c0.5,1.6,1,3.1,1.5,4.8c0.1-0.3,0.3-0.6,0.4-0.8 c0.6,0.7,1.2,1.3,2,2.3c-0.4-1.7-0.7-3-1-4.5c1.1,1.7,2,3.2,2.9,4.8c0.1-0.1,0.2-0.1,0.4-0.2c-0.5-1.7-1.1-3.5-1.6-5.2 c0.1,0,0.2-0.1,0.3-0.1c1.3,2.9,2.6,5.8,3.9,8.7c0.2-0.1,0.3-0.1,0.5-0.2c-1.4-3.5-2.8-7-4.2-10.6c3.6,3.8,4.8,8.7,6.7,13.3 c-0.2-1.2-0.5-2.4-0.7-3.6c0.1,0,0.2,0,0.3-0.1c0.7,1.7,1.4,3.4,2.2,5.3c-1,0-1.7,0-2.4,0c-6.8-0.4-13.4,0.2-20,2 c-3.9,1.1-7.7,2.7-11.7,3.7c-15.9,4-31.2,9.5-44.8,19.1c-0.4,0.3-0.7,0.6-1.5,1.2c1.2-0.4,1.8-0.7,2.5-0.9c0,0.1,0.1,0.1,0.1,0.2 c-2.9,2.2-5.8,4.5-8.7,6.7c0.1,0.1,0.2,0.2,0.3,0.4c0.8-0.4,1.6-0.8,2.3-1.3c0.1,0.1,0.1,0.2,0.2,0.2c-1.4,1.3-2.8,2.6-4.2,4 c0.1,0.1,0.1,0.1,0.2,0.2c1.2-0.9,2.5-1.9,3.7-2.8c0,0.1,0.1,0.1,0.1,0.2c-2.4,2.8-4.7,5.7-7.1,8.5c0,0,0.1,0.1,0.1,0.1 c1.3-1.2,2.6-2.3,3.9-3.5c0.1,0.1,0.1,0.2,0.2,0.2c-1.1,1.3-2.3,2.6-3.4,3.8c0.6,0.1,1.2,0.4,1.6,0.2c0.6-0.3,1.1-1,1.7-1.5 c0.1,0.1,0.1,0.1,0.2,0.2c-0.9,1.3-1.8,2.7-3,4.5c0.8-0.5,1-0.6,1.6-1c-0.9,1.5-1.5,2.6-2.1,3.7c0.1,0,0.1,0.1,0.2,0.1 c0.5-0.4,1-0.9,1.8-1.7c-0.8,1.6-1.3,2.8-1.9,4c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.4,0.6-0.9,0.9-1.3c0.1,0.1,0.2,0.2,0.3,0.3 c-0.4,1.1-0.8,2.2-1.2,3.3c0.1,0,0.2,0.1,0.2,0.1c0.3-0.4,0.6-0.8,1.1-1.5c0.2,1.9,0.4,3.4,0.5,4.9c0,0,0.1,0,0.1,0 c0.1-0.9,0.1-1.7,0.2-2.6c0.1,0,0.2,0,0.3,0c0.2,0.6,0.4,1.2,0.8,2.3c0-1.7,0-2.9,0-4.4c0.3,0.6,0.5,0.9,0.7,1.2 c0.1-0.6,0.1-1.1,0.2-1.6c1,0.8,1.7,0.8,2-0.5c0.1-0.6,0.6-1.2,1-2.2c0.2,0.7,0.2,1,0.3,1.4c0.3-0.6,0.5-1.1,0.8-1.7 c0.2,0.5,0.3,0.7,0.4,1c0.1,0,0.2-0.1,0.3-0.1c-0.1-1.4-0.3-2.8-0.4-4.3c0.1,0,0.2,0,0.3,0c0.2,0.9,0.4,1.8,0.7,2.8 c0.2-0.4,0.3-0.7,0.5-1.1c0.1,0.5,0.2,0.8,0.3,1.1c0.2-1,0-1.9,0-2.9c0-0.9,0.2-1.8,0.2-2.7c0.1,0,0.2,0,0.3,0 c0.1,0.3,0.2,0.7,0.4,1.2c0.3-0.6,0.5-1,0.8-1.5c0.1,0.6,0.2,0.8,0.3,1.2c0.3-1.8,0.5-3.6,0.8-5.3c0.1,0,0.2,0,0.3,0.1 c0.3,1.3,0.6,2.6,1.1,4.5c0-2.1,0-3.7,0-5.3c0.1,0,0.2,0,0.4,0c0.1,0.4,0.2,0.8,0.3,1.4c0.4-0.9,0.7-1.7,1.1-3 c0.1,1.2,0.2,1.9,0.3,3c3-2.3,0.3-5.2,1.5-7.5c0.1,0.7,0.2,1.2,0.2,1.6c0.1-0.2,0.3-0.4,0.5-0.7c0.1,1.1,0.2,1.9,0.3,3.2 c0.3-2.4,0.6-4.3,0.9-6.5c0.2,0.8,0.3,1.3,0.3,1.3c0.2-1,0.6-2.3,0.9-3.7c0.1,0,0.3,0,0.4,0.1c0.1,1.5,0.1,3,0.2,4.6 c0.1,0,0.1,0,0.2,0c0.1-1.2,0.2-2.4,0.2-3.6c0.1,0,0.2,0,0.2,0c0.1,0.7,0.1,1.3,0.2,2c0,0,0.1,0,0.1,0c0.1-1.1,0.1-2.1,0.2-3.2 c0.1,0,0.2,0,0.3,0c0.1,1.1,0.2,2.2,0.2,3.3c0.1,0,0.2,0,0.3,0c0-2,0-4,0-6c0.1,0,0.2,0,0.3,0c0.2,2.2,0.4,4.4,0.7,6.7 c0.1,0,0.2,0,0.3,0c0-1.3,0-2.5,0-3.8c0.1,0,0.1,0,0.2,0c0.1,1.7,0.3,3.5,0.4,5.2c0.1,0,0.1,0,0.2,0c0.5-2.8,1-5.6,1.5-8.6 c0.1,1.4,0.1,2.6,0.2,3.7c0.1,0,0.1,0,0.2,0c0.1-1,0.2-2,0.3-2.9c0.1,0,0.2,0,0.3,0c0,1.2,0,2.3,0,3.5c0.1,0,0.1,0,0.2,0 c0.3-1.8,0.5-3.6,0.8-5.3c0.1,0,0.2,0,0.2,0c0,1.3,0,2.6,0,4c0.1,0,0.1,0,0.2,0c0.2-2,0.5-3.9,0.8-6.3c0.3,1.9,0.5,3.5,0.8,5.4 c0.3-2.3,0.6-4.1,0.8-5.9c0.1,0,0.2,0,0.3,0c0,2.2,0,4.4,0,6.7c0.9-2.5,1.7-4.9,2.5-7.2c0-0.1,0.1-0.2,0.3-0.4 c0.2,0.3,0.5,0.5,0.7,0.8c0.7-1.1,1.4-2.2,2-3c0.5,0.8,1,1.7,1.6,2.6c0.4-0.5,0.8-1.2,1.3-1.9c0.1,0.6,0.2,1,0.4,1.6 c0.1-0.8,0.2-1.5,0.3-2.1c0.1,0,0.1,0,0.2,0c0.1,0.6,0.1,1.2,0.2,2.1c0.3-0.5,0.4-0.8,0.5-1.1c-0.1,3.1-3,4.4-4.3,6.9 c0.6-0.3,1-0.5,1.7-0.9c-2.1,3.5-3.6,7-7.5,8.6c0.1,0.1,0.3,0.3,0.4,0.4c1.9-1.1,3.8-2.2,5.6-3.4c0.1,0.2,0.3,0.5,0.4,0.7 c-4.8,3.2-9.7,6.3-14.8,9.7c0.8-0.1,1.2-0.2,1.6-0.2c0,0.1,0.1,0.2,0.1,0.3c-1.3,0.9-2.5,1.8-4.2,3c0.9-0.2,1.4-0.3,2.3-0.5 c-1.2,1.1-2.1,1.9-2.9,2.7c-0.9,0.8-1.9,1.5-2.7,2.4c-0.7,0.7-2.1,1-1.4,2.5c0.5-0.2,1-0.5,1.9-0.9c-2.3,2.4-4.4,4.5-6.4,6.6 c0.1,0.1,0.3,0.3,0.4,0.4c0.4-0.1,0.8-0.3,1.4-0.5c-0.4,1.5-1.7,1.9-2,3.5c-0.5,2.5-2.2,4.7-3.3,7c-0.1,0.2-0.1,0.4-0.2,0.7 c0.4,0.1,0.8,0.2,1.4,0.4c-0.8,2.4-1.5,4.7-2.3,7c-0.3,0.9-0.7,1.7-1,2.6c-0.1,0.4,0.1,0.8,0.2,1.5c0.5-0.9,0.8-1.5,1.1-2.1 c0.3,0.4,0.5,0.7,0.7,1c0.8-1.4,1.5-2.7,2.2-4.1c0.1,0.4,0.2,0.6,0.3,0.9c0.3-1.4,0.5-2.6,0.8-3.9c0.2,0,0.4,0,0.5,0 c0.2,1.2,0.4,2.3,0.7,3.7c0.4-3.1,0.7-6,1.1-8.8c0.1,0,0.1,0,0.2,0c0.1,0.7,0.2,1.4,0.2,2c0.4-1.6,0.8-3.3,1.3-5.4 c0.1,2,0.2,3.6,0.3,4.9c0.2-1.1,0.5-2.5,0.8-3.8c0.1,0,0.2,0,0.4,0.1c0.1,0.5,0.1,1,0.1,1.2c0-0.2,0.1-0.7,0.2-1.2 c0.1,0,0.2,0,0.2,0c0.1,1.2,0.3,2.4,0.4,3.5c0.1-1.4,0.2-3,0.4-5.1c0.2,1.7,0.3,2.8,0.4,3.3c0.3-2.4,0.8-5.4,1.2-8.4 c0.1,0,0.2,0,0.2,0c0,2.5,0,5,0,7.5c0.1,0,0.2,0,0.3,0c0.5-3.1,1.1-6.1,1.6-9.2c0.1,0,0.2,0,0.4,0c0,2.2,0,4.4,0,6.6 c0.1,0,0.2,0,0.3,0c0.1-0.5,0.2-1.1,0.4-2.1c0.2,1.2,0.3,1.8,0.4,2.1c0.5-2.1,1-4.3,1.5-6.6c0.1-0.3,0.1-0.7,0.2-1.6 c0.2,1.1,0.3,1.6,0.5,2.6c0.1-1.1,0.2-1.7,0.3-2.3c0.1,0,0.3,0,0.4,0c-0.1,2.9-0.3,5.7-0.4,8.6c0,0,0.1,0,0.1,0 c0.5-3.6,1-7.3,1.6-10.9c0.1,0,0.2,0,0.3,0c-0.1,2.4-0.2,4.9-0.4,7.3c0.1,0,0.2,0,0.4,0c0.5-2.7,0.9-5.5,1.4-8.2c0.1,0,0.1,0,0.2,0 c0.2,2.8,0.5,5.6,0.6,7.5c0.4-1.4,0.9-3.5,1.7-6.2c0.2,1,0.3,1.5,0.4,1.7c0.2-2.1,0.4-4.6,0.7-7.3c0.3,1.2,0.5,2.1,0.8,3.3 c0.5-1.9,0.8-3.4,1.2-4.9c0.1,0,0.2,0,0.3,0c-0.5,4.2-1,8.4-1.6,12.5c0.1,0,0.1,0,0.2,0c0.8-3.5,1.5-7,2.3-10.6c0.1,0,0.2,0,0.3,0 c-0.1,1.2-0.3,2.5-0.4,3.7c0.1,0,0.1,0,0.2,0c0.4-1.5,0.8-3,1.1-4.5c0,0,0.1,0,0.1,0c-0.2,2.5-0.3,5.1-0.5,7.6c0.1,0,0.3,0,0.4,0 c0.2-1,0.5-2,0.8-3.2c0.2,0.4,0.2,0.5,0.3,0.7c0,0,0.1,0.1,0.1,0.1c0.3-1,0.5-2,0.8-2.9c0.1,0,0.2,0,0.2,0c0,0.6,0.1,1.2,0.1,2.3 c0.2-1,0.3-1.3,0.4-1.8c0.2,0.4,0.3,0.7,0.5,1.1c0.5-2.3,1-4.4,1.5-6.5c0.1,0,0.2,0,0.3,0c-0.3,2-0.5,4.1-0.8,6.1 c0.1,0,0.1,0,0.2,0c0.3-1,0.5-2,0.8-3c0.1,0,0.2,0,0.3,0.1c-0.2,1.6-0.3,3.3-0.5,4.9c0.1,0,0.2,0,0.2,0c0.4-1.6,0.7-3.2,1.1-4.8 c0.1,0,0.2,0,0.3,0c-0.1,1.1-0.2,2.3-0.3,3.9c0.5-1.8,0.9-3.1,1.3-4.4c0.1,0,0.2,0,0.3,0c-0.1,1.3-0.3,2.5-0.4,3.8 c0.1,0,0.1,0,0.2,0c1-3,1.9-6,2.9-8.9c0.1,0,0.1,0,0.2,0c-0.1,1.7-0.3,3.5-0.4,5.2c0,0,0.1,0,0.1,0c0.4-2.1,0.8-4.3,1.1-6.4 c0.1,0,0.2,0,0.3,0c-0.1,1.7-0.2,3.4-0.4,5.6c0.4-1.4,0.7-2.3,0.9-3.2c0.1,0,0.2,0,0.3,0.1c-0.2,2-0.3,4-0.5,6c0.1,0,0.2,0,0.2,0 c0.5-3.1,1-6.1,1.5-9.2c0.1,0,0.2,0,0.4,0c0,1.5,0,3,0,4.5c0.1,0,0.1,0,0.2,0c0.4-3,0.7-6,1.1-9c0.1,0,0.2,0,0.3,0c0,1.7,0,3.3,0,5 c0.1,0,0.2,0,0.2,0c0.2-1.1,0.5-2.3,0.8-3.5c0,3.8,0,7.5,0,11.2c0,0,0.1,0,0.1,0c0.3-3.5,0.7-6.9,1-10.4c0.1,0,0.2,0,0.3,0 c0,2,0,4,0,5.9c0,0,0.1,0,0.1,0c0.3-2.6,0.6-5.2,0.9-7.9c0.3,2.7,0.5,5.2,0.8,7.6c0.5-2,0.9-4,1.4-6c0.1,0,0.2,0,0.3,0 c0.1,0.8,0.2,1.7,0.3,2.5c0.1,0,0.2,0,0.3,0c0-1.2,0-2.4,0-3.6c0.1,0,0.2,0,0.2,0c0.1,0.7,0.2,1.4,0.3,2.2c0.4-1.2,0.9-2.3,1.3-3.6 c0.1,0.8,0.2,1.6,0.3,2.3c0.1-0.7,0.2-1.5,0.3-2.3c1.1,3.7,2.5,7.2,1,11.1c-0.9,2.5-1.2,5.3-1.7,8c0.2,0,0.3,0.1,0.5,0.1 c0.7-3.1,1.5-6.1,2.2-9.2c0.1,0,0.3,0.1,0.4,0.1c-0.5,2.9-1,5.9-1.6,8.8c0.2,0,0.4,0.1,0.5,0.1c0.9-4,1.8-7.9,2.7-12.4 c0.6,2.2,1.1,3.9,1.6,5.6c0.1,0,0.2,0,0.3-0.1c-0.3-1.7-0.6-3.3-0.9-5.1c0.4,0.2,0.6,0.3,0.9,0.4c-0.2-0.9-0.3-1.5-0.4-2.1 c0.1-0.1,0.2-0.1,0.3-0.2c0.8,1,1.6,2,2.4,3c-0.2-0.9-0.5-2-0.7-3c0.1,0,0.2,0,0.3-0.1c0.4,0.8,0.7,1.5,1.1,2.3 c0-0.9-0.2-1.6-0.4-2.4c-0.2-0.8-0.3-1.6-0.5-2.3c0.9,3.2,5.1,6.4,0,9.6c0.5,0.1,0.8,0.1,1.1,0.2c-0.3,0.4-0.6,0.7-0.9,1.2 c1.1-0.2,1.8-0.3,2.6-0.4c0,0.1,0,0.2,0,0.2c-1.8,0.7-3.6,1.5-5.4,2.2c0,0.1,0.1,0.2,0.1,0.3c2.7-0.8,5.4-1.6,8.1-2.5 c0,0.1,0.1,0.3,0.1,0.4c-2.2,0.9-4.4,1.7-6.6,2.6c0,0.1,0.1,0.2,0.1,0.3c2.8-0.9,5.5-1.9,8.3-2.8c0,0.1,0,0.1,0.1,0.2 c-3.7,1.8-7.4,3.6-11.1,5.4c0.1,0.1,0.1,0.2,0.2,0.4c4.6-1.7,9.2-3.4,13.9-5c0.1,0.2,0.1,0.3,0.2,0.5c-2.6,1.9-5.2,3.8-7.7,5.8 c-4.4,3.5-5.7,4.9-6.4,6.7c3.4-2.9,6.9-5.8,10.4-8.8c0.2,0.2,0.4,0.4,0.5,0.6c-2.1,2-4.4,4-6.4,6.1c-2,2.2-3.7,4.6-4.5,7.5 c4.2-7.5,10.9-12.1,18.1-16.3c0.1,0.8,0.1,1.8,0.3,1.8c2,0.4,1.6,2.2,2.2,3.4c0.9,1.8,1.6,3.6,2.4,5.4c0.1-0.3,0.2-0.5,0.3-0.8 c-0.7-1.8-1.4-3.6-2.1-5.4c0.1-0.1,0.3-0.1,0.4-0.2c0.7,1.4,1.5,2.8,2.3,4.3c0.2-0.4,0.4-0.7,0.6-1.1c-0.3-1.2-0.5-2.4-0.8-3.5 c0.1,0,0.2-0.1,0.3-0.1c0.5,0.7,1.1,1.4,1.6,2.2c0.1-0.1,0.3-0.3,0.4-0.4c-0.4-1.5-0.9-3-1.3-4.7c0.8,0.9,1.4,1.8,2.4,3 c-0.4-1.3-0.7-2.1-0.9-2.9c1.1,1.2,1.8,2.6,2.7,3.9c4.1,1.9,7.6,5.4,10.2,9c-1-2.1-1.9-4.2-0.9-7.1c0.5,0.8,1,1.4,1.4,2.1 c0.1-0.1,0.2-0.1,0.3-0.2c-0.6-1.2-1.2-2.3-1.9-3.5c0.2-0.1,0.4-0.2,0.6-0.2c1.1,1.4,2.3,2.7,3.4,4.1c0.1-0.1,0.2-0.1,0.2-0.2 c-0.6-1-1.3-2-1.9-2.9c0.1,0,0.2-0.1,0.2-0.1c0.4,0.3,0.8,0.6,1.3,0.9c-1.1-2-2.1-3.9-3.3-6c0.6,0.3,0.9,0.5,1.2,0.6 c-0.6-1.2-1.1-2.3-1.7-3.5c0.2-0.1,0.3-0.2,0.5-0.3c1.2,1.2,2.5,2.3,3.7,3.5c-0.8-1.5-1.9-2.7-2.9-4c-0.4-0.5-0.8-1-0.8-1.5 c0-2.1,0.1-4.3,0.3-6.9c0.3,0.8,0.4,1.2,0.6,1.7c0.1-0.6,0.2-0.9,0.4-1.6c0.5,2.7,0.8,4.9,1.2,7.1c0.1,0,0.2,0,0.3,0 c-0.3-3.2-0.6-6.5-0.9-9.7c0.1,0,0.1,0,0.2,0c0.3,0.9,0.5,1.9,0.8,2.8c0.1,0,0.2,0,0.3,0c-0.4-3.2-0.8-6.3-1.2-9.5 c0.1,0,0.2,0,0.3-0.1c0.9,3.6,1.8,7.2,2.6,10.8c0.1,0,0.2,0,0.2,0c-0.3-1.7-0.5-3.4-0.8-5.1c0.1,0,0.1,0,0.2,0 c0.4,1,0.7,1.9,1.1,2.9c0.1,0,0.2,0,0.3-0.1c-0.3-1.9-0.6-3.9-0.9-5.8c0.1,0,0.2,0,0.3-0.1c0.6,2.2,1.2,4.4,1.9,6.7 c0.1,0,0.1,0,0.2,0c-0.1-0.8-0.2-1.7-0.3-2.5c0.1,0,0.2,0,0.2,0c0.2,0.5,0.5,1.1,0.9,2c-0.1-1.3-0.2-2.3-0.3-3.2c0.1,0,0.1,0,0.2,0 c0.4,0.9,0.7,1.8,1.2,3c0.1-0.8,0.1-1.2,0.2-1.6c1.8,1.4,1.5,2.7,0.2,4.2c-0.8,0.9-1.5,2-2.2,3c0.1,0.1,0.2,0.1,0.3,0.2 c2-2.1,4-4.2,6-6.4c0.1,0.1,0.1,0.1,0.2,0.2c-2.9,4.1-5.8,8.1-8.7,12.2c3.7-4.5,7.2-9.2,12.1-12.6c-2.6,3.9-5.4,7.7-8,11.6 c-1.3,1.9-2.1,4.1-3.1,6.2c0.1,0,0.1,0.1,0.2,0.1c3.4-3.9,6.8-7.9,10.3-11.8c-1.2,2.3-2.6,4.3-4.1,6.4c-3.4,4.8-3.4,4.8-3.3,6.7 c2.1-2.3,4.2-4.6,6.2-6.9c0.1,0.1,0.2,0.2,0.3,0.3c-1.8,2.5-3.5,4.9-5.3,7.4c0.1,0.1,0.2,0.1,0.3,0.2c2.9-3.4,5.8-6.9,8.7-10.3 c0.1,0.1,0.3,0.2,0.4,0.3c-2.6,4.3-5.2,8.6-7.8,12.9c0.1,0.1,0.2,0.1,0.3,0.2c0.7-0.8,1.3-1.6,2-2.3c0.1,0.1,0.1,0.1,0.2,0.2 c-0.8,1.3-1.6,2.6-2.3,3.9c0.1,0.1,0.2,0.1,0.3,0.2c2.9-4,5.7-8,8.6-12c0.1,0.1,0.3,0.1,0.4,0.2c-2.2,4.3-4.4,8.6-6.5,12.9 c0.1,0.1,0.3,0.2,0.4,0.2c2.2-3.8,4.4-7.5,6.6-11.3c0.1,0,0.2,0.1,0.3,0.1c-1.1,3.3-2.2,6.6-3.4,9.9c0.1,0,0.2,0.1,0.3,0.1 c1.8-4.1,3.6-8.3,5.4-12.5c1.7,2.4-1.1,3.9-0.9,6.1c0.5-0.6,0.9-1.1,1.3-1.7c0.1,0.1,0.2,0.1,0.3,0.2c-2.4,4.8-4.8,9.5-7.2,14.3 c0.1,0,0.2,0.1,0.3,0.1c1.4-2.3,2.8-4.7,4.2-7c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,1.4-1.4,2.9-2.1,4.3c0.1,0,0.2,0.1,0.3,0.1 c0.9-1.5,1.7-3,2.6-4.5c0.2,0.1,0.3,0.1,0.5,0.2c-0.4,1.8-0.8,3.5-1.2,5.5c0.5-0.8,0.9-1.4,1.1-1.9c0.4,0.3,0.7,0.6,1.1,0.9 c-0.6,1.3-1.2,2.7-1.8,4c0.1,0,0.2,0.1,0.3,0.1c1.5-2.5,3-5.1,4.6-7.6c0.1,0.1,0.2,0.1,0.4,0.2c-1.1,2.5-2.2,4.9-3.2,7.4 c0.1,0,0.1,0.1,0.2,0.1c0.6-0.9,1.3-1.7,1.9-2.6c0.1,0.1,0.2,0.1,0.3,0.2c-1.1,2.1-2.2,4.3-3.4,6.5c1.3-1.3,2.5-2.5,3.7-3.6 c0.1,0.1,0.3,0.2,0.4,0.3c-0.4,0.8-0.8,1.6-1.2,2.3c0.1,0,0.1,0.1,0.2,0.1c0.4-0.5,0.8-0.9,1.2-1.4c0.1,0.1,0.2,0.1,0.2,0.2 c-0.6,1.2-1.1,2.3-1.7,3.5c0.1,0,0.2,0.1,0.3,0.1c0.5-0.7,1-1.4,1.7-2.3c-0.2,1.7-0.4,3.2-0.6,4.8c0.5-0.6,0.9-1.1,1.4-1.6 c0.1,0.1,0.3,0.2,0.4,0.2c-1,1.9-2,3.7-3.1,5.9c0.6-0.4,0.8-0.6,1.5-1.1c-0.6,1.2-1,1.9-1.4,2.6c0.1,0.1,0.2,0.1,0.3,0.2 c0.8-1.1,1.6-2.1,2.3-3.2c0.1,0,0.2,0.1,0.3,0.1c-1.2,3.1-2.4,6.1-3.8,9.6c1-1.5,1.8-2.6,2.8-4c-0.8,2.6-1.4,4.8-2.1,6.8 c2.9,0.4,0,3,1.6,3.9c2.8-6,3.2-12.6,4.3-19.4c0.4,0.8,0.7,1.3,1,1.7c1.4-16.9-3.2-32.5-11.4-47c3.4-2.9,6.4-5.6,9.5-8.2 c0.1,0.1,0.2,0.2,0.2,0.3c-1.4,1.5-2.9,3.1-4.3,4.6c0.1,0.1,0.1,0.1,0.2,0.2c1.3-1.2,2.7-2.4,4-3.6c0,0.1,0.1,0.1,0.1,0.2 c-0.6,0.7-1.2,1.5-1.8,2.2c0.1,0.1,0.2,0.2,0.3,0.2c1.9-1.7,3.8-3.5,5.6-5.2c0.1,0.1,0.2,0.2,0.2,0.2c-1.3,1.6-2.6,3.1-3.9,4.7 c0.1,0.1,0.2,0.2,0.3,0.3c0.8-0.7,1.5-1.5,2.3-2.2c0.1,0.1,0.1,0.1,0.2,0.2c-1.3,1.6-2.6,3.3-3.9,4.9c0.1,0.1,0.2,0.1,0.2,0.2 c1.8-2,3.7-4,5.5-6c0.1,0.1,0.2,0.2,0.3,0.3c-0.8,1.2-1.7,2.4-2.5,3.6c0.1,0,0.1,0.1,0.2,0.1c0.4-0.4,0.8-0.7,1.2-1.1 c0.1,0.1,0.1,0.1,0.2,0.2c-0.6,1-1.2,2.1-1.7,3.1c0.2,0.1,0.4,0.3,0.5,0.4c0.8-0.9,1.6-1.9,2.6-2.7c0.7-0.6,1.6-1,2.5-1.5 c0.1,0.1,0.2,0.3,0.3,0.4c-1.1,1.7-2.2,3.3-3.2,5c0.1,0.1,0.2,0.1,0.3,0.2c1.8-2.4,3.6-4.8,5.4-7.2c0.1,0.1,0.3,0.2,0.4,0.3 c-1.2,2.5-2.5,5-3.7,7.5c0.1,0.1,0.2,0.1,0.3,0.2c1.1-1.8,2.3-3.7,3.4-5.5c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,1.6-1.4,3.2-2,4.8 c0.1,0,0.2,0.1,0.2,0.1c0.9-1.6,1.7-3.1,2.6-4.7c0.1,0.1,0.3,0.1,0.4,0.2c-1.4,3.6-2.8,7.1-4.2,10.7c0.1,0,0.2,0.1,0.3,0.1 c2.1-4.5,4.2-9.1,6.2-13.6c0.1,0.1,0.3,0.1,0.4,0.2c-0.5,2.6-0.9,5.2-1.5,8.2c0.8-0.9,1.2-1.4,1.8-2.1c-0.1,1.4-0.3,2.5-0.4,3.6 c0.1,0,0.2,0,0.3,0c0.5-1.7,0.9-3.4,1.5-5.5c0.2,0.8,0.2,1.2,0.4,1.8c0.3-1.1,0.5-1.9,0.8-2.8c0.8,3.3,1.5,6.4,2.4,9.9 c0.2-0.9,0.3-1.4,0.5-2.5c0.6,1.1,0.9,1.8,1.4,2.8c0.3-1,0.4-1.7,0.7-2.7c0.2,2.1,0.4,3.9,0.7,5.9c0.3-1.8,0.5-3.3,0.8-4.8 c0.1,0,0.2,0,0.3,0c0,0.9,0,1.8,0,2.7c0.1,0,0.1,0,0.2,0c0.1-0.5,0.2-1,0.4-1.8c0.3,1.5,0.5,2.7,0.7,4.2c0.3-1.3,0.6-2.2,0.8-3.2 c0.1,0,0.2,0,0.3,0c-0.1,1.4-0.3,2.7-0.4,4.3c0.3-0.4,0.4-0.6,0.7-1c0.1,0.6,0.2,1.1,0.4,2c0.7-1.4,1.2-2.3,1.6-3.1 c1.2,2.3-0.9,5.5,1.7,8c0.4-1,0.7-1.9,1.1-3c0.6,3,1.2,5.7,1.8,8.5c0.1,0,0.2,0,0.2-0.1c0.1-0.5,0.2-1,0.3-2c0.3,1,0.4,1.5,0.6,2 c0.1,0,0.2,0,0.3,0c0.1-1.5,0.2-3,0.3-4.5c0.1,0,0.1,0,0.2,0c0.1,1.9,0.3,3.9,0.4,5.8c0.2,0.1,0.5,0.1,0.7,0.2 c0.9-2.1,1.8-4.3,2.7-6.6c0.1,1.2,0,2.1,0.2,3c0.4,1.6,0.9,3.2,1.2,4.5c0.2-0.5,0.6-1.5,1.3-2.9c0.2,1.6-0.7,3.4,1.2,3.5 c0.5-0.7,0.9-1.3,1.3-2c0.1,0,0.3,0.1,0.4,0.1c0,1.1,0,2.2,0,3.4c0.1,0,0.3,0,0.4,0c0.2-0.3,0.3-0.5,0.4-0.7c0.3,0.9,0.7,1.7,1,2.6 c0.1,0,0.2-0.1,0.4-0.1c0-0.4,0-0.8-0.1-1.2c0.4,0.7,0.3,1.5,0.4,2.3c0.1,0.6,0.1,1.5,0.5,1.7c0.7,0.3,1.6,0.3,2.5,0.4 c0,0.6-0.1,1.7-0.1,2.7c0.1,0,0.3,0,0.4,0c0.3-0.7,0.5-1.3,0.8-2.2c0.6,1.5,1.2,2.9,1.9,4.6c-0.3-1.5-0.6-2.8-0.8-4 c0.1,0,0.3-0.1,0.4-0.1c0.7,2.1,1.4,4.3,2.1,6.4c0.3-0.4,0.5-0.7,0.9-1.3c0.1,1.6,0.2,2.9,0.3,4.3c0.1-1.6,0.2-3,0.3-4.4 c0.1,0,0.2,0,0.3,0c0.6,1.8,1.2,3.6,1.8,5.5c0.1,0,0.1,0,0.2,0c-0.3-1.4-0.5-2.7-0.8-4.1c0.1,0,0.2-0.1,0.3-0.1 c0.5,1,1.1,1.9,1.8,3.2c-0.8-2.7-1.5-5-2-7.3c-0.1-0.4,0.4-1,0.8-1.9c-1.2-3.6-5.2-6.3-5.7-11c2.9,2.9,5.8,5.8,8.7,8.7 c0.1-0.1,0.2-0.1,0.3-0.2c-1.2-1.4-2.4-2.8-3.6-4.2c0.2-0.1,0.3-0.3,0.5-0.4c1.2,1.4,2.4,2.7,3.6,4.1c0.1-0.1,0.1-0.1,0.2-0.2 c-1.3-1.9-2.6-3.7-3.9-5.6c0.1-0.1,0.3-0.3,0.4-0.4c1.2,0.9,2.4,1.7,3.6,2.6c0.1-0.1,0.1-0.2,0.2-0.3c-1.3-1.2-2.6-2.3-3.6-3.2 c0.3-0.8,0.4-1.3,0.6-1.8c0.7,0.3,1.5,0.5,2.2,0.8c-4-2.2-3.7-6.8-6.2-9.7c0.2-0.2,0.4-0.3,0.5-0.5c0.8,1,1.7,2,2.5,3 c0.1-0.1,0.3-0.3,0.4-0.4c-3.4-3.4-6.9-6.8-10.3-10.2c0.1-0.1,0.1-0.2,0.2-0.3c3.3,1.6,6.6,3.3,9.9,4.9c0.1-0.1,0.1-0.2,0.2-0.3 c-2.4-1.4-4.8-2.8-7.3-4.2c0-0.1,0.1-0.2,0.1-0.3c2,0.8,3.9,1.7,5.9,2.5c0.1-0.2,0.2-0.4,0.2-0.5c-2.8-1.3-5.6-2.9-8.6-3.9 c-4.7-1.5-7-5.5-10.2-8.7c1.2,1,2.3,2,3.5,3c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-1-0.4-2-0.5-2.9c0.9,0.8,2,1.7,3,2.5 c0.1-0.1,0.3-0.3,0.4-0.4c-1.1-1.3-2-2.7-3.2-3.8c-2.9-2.4-5.9-4.7-8.8-7.1c-0.7-0.6-1.3-1.4-1.9-2c0.1-0.1,0.2-0.2,0.3-0.4 c3.6,2.3,7.2,4.6,10.8,6.9c-3.4-2.9-7.1-5.3-10.8-7.8c-0.6-0.4-1.1-1.1-1.6-1.6c0.1-0.1,0.2-0.2,0.4-0.3c0.6,0.3,1.1,0.5,1.7,0.8 c0-0.1,0.1-0.1,0.1-0.2c-1.5-1.3-3-2.7-4.4-4c0.1-0.2,0.3-0.4,0.4-0.6c2,1.3,4,2.7,6.1,4.1c-0.4-0.6-0.8-1.1-1.5-2 c3.2,1.6,5.8,2.9,8.4,4.2c-3.7-2.8-8-4.5-11.8-7.1c-0.1,0.2-0.2,0.5-0.3,0.7c-2.1-0.8-4.2-1.7-6.2-2.5c0.1-0.2,0.1-0.4,0.2-0.6 c2.1,0.8,4.2,1.5,6.2,2.3c-0.7-0.4-1.3-0.9-1.9-1.4c-2-1.5-5.2-1.3-7.9-2c-1.2-0.3-2.6-0.6-3.4-1.3c-3.3-3.1-6.5-6.4-9.7-9.5 c-0.8-0.7-1.2-1.2-0.9-2.4c0.5-2.3,0.1-4.4-2-5.7c-1.5-0.9-2-2.2-2.2-3.8c-0.3-2-0.7-3.9-1.2-6c0.3,0.5,0.6,0.8,0.9,1.2 c0.1-0.4,0.2-0.6,0.4-1.3c0.6,2.6,1.1,4.7,1.6,6.7c0.1,0,0.1,0,0.2,0c-0.4-2.5-0.8-5-1.2-7.5c0.2,0,0.3-0.1,0.5-0.1 c0.6,2.6,1.2,5.3,1.7,7.9c0.1,0,0.1,0,0.2,0c0-2.2,0-4.4,0-6.5c0.1,0,0.2-0.1,0.3-0.1c0.7,2,1.3,3.9,2,5.8c0-0.6,0.1-1.3,0.1-2.1 c0.3,0.4,0.6,0.7,1,1.3c0.1-1.3,0.1-2.2,0.2-3.6c0.6,1.7,1,3,1.3,4.2c0.2,0,0.4,0,0.6,0c0.2-1.5,0.3-3.1,0.5-4.5 c0.7,0.9,1.4,1.9,2.2,2.8c0-1.3,0-2.5,0-3.8c2.6,2.7,2.5,6.3,4.2,9.9c-0.7-3.8-1.3-7-1.8-10.2c0.2,0,0.3-0.1,0.5-0.1 c0.2,0.5,0.5,1,0.7,1.5c0.2,0,0.3-0.1,0.5-0.1c-0.5-2-0.9-4-1.4-6.3c0.5,0.6,0.7,1,1.3,1.7c-1-3.1-1-3.1,0.4-3.7 c1.3,2.7,2.7,5.4,3.8,8.2c1.1,2.8,1.7,5.7,2.6,8.5c0.1,0,0.3-0.1,0.4-0.1c-1.2-4.4-2.4-8.9-3.5-13c2.4,2.8,3.2,7.1,5.9,10.1 c0.2-0.1,0.4-0.2,0.7-0.3c-1-2.5-2-5-3.1-7.5c0.1,0,0.2-0.1,0.3-0.1c1.3,2.1,2.6,4.1,3.9,6.2c0.2-0.1,0.4-0.2,0.6-0.3 c-1.1-2.2-2.1-4.4-3.2-6.6c0.1-0.1,0.2-0.1,0.3-0.2c1,1.5,2,3.1,3,4.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.4-0.9-0.8-1.7-1.2-2.6 c0.1,0,0.2-0.1,0.3-0.1c1.3,1.8,2.5,3.7,3.8,5.5c0.1,0,0.2-0.1,0.3-0.1c-0.6-1.4-1.3-2.7-2.1-4.5c1.5,1.7,2.6,3,3.8,4.3 c0.2-0.1,0.3-0.1,0.5-0.2c-1.8-2.1,0.8-2.8,1-4.6c0.7,2.2,1.3,4,2.1,6.2c0.2-1.7,0.4-2.9,0.7-4.6c0.4,1.6,0.6,2.7,0.9,3.8 c0.1-0.3,0.2-0.6,0.4-1.3c0.7,1.3,1.3,2.3,1.8,3.3c0.2-0.5,0.4-0.9,0.7-1.3c0.2-0.4,0.6-0.7,0.9-1c0.1,0.5,0.4,0.9,0.4,1.4 c0.1,1.3,0,2.6,0,3.9c0.2-0.1,0.5-0.2,0.7-0.3c1,1.4,2.1,2.7,3,3.9c0,0,0,0,0,0c0-0.1,0.1-0.2,0.1-0.3c0,0,0.1,0,0.3,0.1 c-0.1,1.3-0.2,2.6-0.4,3.9c0.1,0,0.2,0,0.3,0c0.3-2.1,0.5-4.3,0.8-6.4c0.1,0,0.2,0,0.4,0c0.2,1.8,0.3,3.6,0.5,5.4 c0.1-1.4,0.3-2.8,0.5-4.6c0.7,1.7,1.2,3,1.7,4.3c0.1,0,0.1,0,0.2,0c-0.2-1-0.4-2-0.7-3c1-0.1,1-0.1,0-4.9c1,1.7,1.7,3,2.5,4.3 c0.1,0,0.1-0.1,0.2-0.1c-0.4-1.1-0.7-2.1-1.1-3.1c0.5-0.2,1-0.5,1.4-0.7c-0.4-0.7-0.7-1.3-1.2-2.1c0.7,0.1,1.2,0.1,2.1,0.2 c-1.1-1.4-2-2.5-2.8-3.6c0.1-0.1,0.2-0.2,0.3-0.2c0.9,0.8,1.8,1.6,2.8,2.5c0.2-0.2,0.3-0.4,0.5-0.6c-1.6-1.5-3.2-2.9-4.8-4.4 c0-0.1,0.1-0.1,0.1-0.2c0.6,0.4,1.2,0.7,1.9,1.2c0-0.3,0.1-0.5,0.1-0.7c0-0.2-0.1-0.4-0.3-0.9c1.9,0.5,3.4,0.9,5.4,1.4 c-2.6-1.6-4.8-3-7.1-4.4c0-0.1,0.1-0.2,0.1-0.3c2.2,0.7,4.4,1.5,6.6,2.2c0.1-0.1,0.1-0.2,0.2-0.4c-2.3-1.2-4.5-2.4-6.8-3.6 c0-0.1,0.1-0.2,0.1-0.3c1.2,0.4,2.5,0.8,3.7,1.2c0-0.1,0.1-0.2,0.1-0.3c-2.1-0.9-4.1-1.7-6.2-2.6c0-0.1,0.1-0.2,0.1-0.3 c2.7,0.8,5.4,1.6,8.1,2.5c0-0.1,0.1-0.2,0.1-0.3c-0.9-0.4-1.7-0.8-2.6-1.1c0-0.1,0.1-0.2,0.1-0.2c1.1,0.3,2.1,0.5,3.2,0.8 c0-0.1,0.1-0.2,0.1-0.3c-2.8-1-5.7-2-8.5-3.1c0-0.1,0.1-0.2,0.1-0.4c3.6,1.2,7.3,2.4,10.9,3.6c0-0.1,0.1-0.3,0.1-0.4 c-2.6-1-5.1-2-7.7-2.9c0-0.1,0-0.2,0.1-0.3c1.9,0.4,3.8,0.8,5.6,1.3c0-0.1,0.1-0.2,0.1-0.3c-1.9-0.6-3.8-1.2-5.7-1.8 c0-0.1,0-0.2,0.1-0.3c1.9,0.4,3.9,0.8,5.8,1.1c0-0.1,0.1-0.3,0.1-0.4c-4.2-1-8.3-2-12.5-3c0.1-0.3,0.1-0.5,0.2-0.8 c1.7,0.3,3.4,0.7,5.1,1c0-0.1,0-0.2,0.1-0.2c-1.8-0.6-3.6-1.2-5.4-1.8c0.1-0.2,0.1-0.4,0.2-0.6c0.8,0.2,1.6,0.4,2.9,0.7 c-1.7-1.1-3.6-1.2-3.4-3.4c0-0.1-1-0.5-1.6-0.5c-2.5,0.2-4.6-0.7-5.2-1.9c-1.1-0.4-2-0.5-2.7-1.1c-0.9-0.8-1.5-0.7-2.5-0.2 c-0.9,0.5-2.4,1.2-3,0.8c-1.5-1.1-2.3,0-3.3,0.6c-0.5,0.3-1.3,1-1.5,0.9c-1.6-1.1-2.3,0.4-3.3,1c-1.5,0.8-2.8,1.8-4.2,2.7 c-10.2,6.4-20.5,12.8-30.7,19.3c-0.8,0.5-1.5,1-2.4,1.5c-0.8-1.8-1.5-3.3-2.2-4.9c0.1-0.1,0.2-0.1,0.3-0.2c0.4,0.6,0.9,1.2,1.3,1.8 c-0.5-1.7-0.9-3.5-1.4-5.2c0.1-0.1,0.3-0.1,0.4-0.2c0.7,0.9,1.5,1.9,2.2,2.9c-0.1-0.7-0.2-1.2-0.3-1.9c0.7,0.3,1.1,0.5,1.8,0.8 c-0.2-0.6-0.3-1.2-0.6-2.1c0.7,0.6,1.1,1,1.5,1.3c0.1-0.1,0.1-0.1,0.2-0.2c-0.6-1-1.3-1.9-1.9-2.9c0.1-0.1,0.2-0.1,0.3-0.2 c1.5,1.7,3,3.4,4.5,5.1c0.1-0.1,0.2-0.1,0.2-0.2c-0.6-1-1.2-1.9-1.9-2.9c0.7,0.3,1.1,0.7,1.6,1.1c0.4,0.4,0.8,0.7,1.2,1 c-1.2-1.9-2.4-3.8-3.5-5.7c0.1-0.1,0.2-0.1,0.3-0.2c0.9,0.5,1.7,1.1,2.6,1.6c0.1-0.1,0.2-0.3,0.3-0.4c-1.6-2-3.2-4-4.9-6 c0.1-0.1,0.2-0.2,0.3-0.3c1.4,1,2.8,2.1,4.2,3.1c0.2-0.2,0.4-0.5,0.6-0.7c-1.3-0.9-2.6-1.9-3.9-2.8c0.3-0.3,0.6-0.7,0.9-1 c2.8,1.3,3.7,5.2,7,5.7c-0.8-1.4-1.7-2.8-2.5-4.3c0.3-0.2,0.5-0.3,0.8-0.5c1.4,1.8,2.7,3.7,4.1,5.5c0.1-0.1,0.2-0.1,0.3-0.2 c-1.1-1.9-2.2-3.7-3.5-5.9c0.7,0.4,1,0.6,1.6,1c-0.8-1.2-1.3-1.9-1.9-2.7c0.1-0.1,0.2-0.1,0.2-0.2c1.4,1.2,2.9,2.5,4.4,3.8 c-0.8-1.5-1.5-2.8-2.4-4.5c1.9,0.8,3.4,1.5,5,2.2c-2.3-1.7-5.2-2.6-6.1-5.8c2.5,1.5,4.9,3,7.4,4.6c0.1-0.1,0.1-0.2,0.2-0.3 c-1.4-1-2.7-2-4.1-3c0.1-0.1,0.1-0.2,0.2-0.3c1.7,0.9,3.4,1.8,5.1,2.7c0.1-0.2,0.2-0.3,0.2-0.5c-2.8-1.5-5.6-3-8.5-4.6 c2-0.7,3.8-1.3,5.7-1.9c0-0.1,0-0.2-0.1-0.3c-1.3,0.3-2.7,0.6-4,0.9c0-0.2-0.1-0.3-0.1-0.5c4.5-1.4,9-2.9,13.5-4.3 c0-0.1-0.1-0.2-0.1-0.3c-3.6,0.9-7.2,1.8-10.8,2.6c0-0.1,0-0.1-0.1-0.2c0.9-0.5,1.9-1,2.8-1.5c0-0.1-0.1-0.1-0.1-0.2 c-1.1,0.4-2.2,0.8-3.3,1.1c-0.1-0.1-0.2-0.3-0.3-0.4c0.7-0.6,1.4-1.5,2.2-1.9c3.7-1.7,7.5-3.3,11.6-5c-1.1,0.2-1.9,0.3-2.7,0.4 c0-0.1,0-0.2-0.1-0.3c1.6-0.5,3.3-1,4.9-1.5c-0.4-0.1-0.8-0.2-1.4-0.4c4-1.1,7.8-2,11.1-2.9c-0.7-0.1-1.9-0.3-3.7-0.6 c1-0.3,1.4-0.4,1.6-0.5c-1.1-0.1-2.4-0.2-3.7-0.3c0-0.1,0-0.1,0-0.2c2.5-0.3,5-0.5,7.6-0.8c0,0,0-0.1,0-0.1c-1.7,0-3.3,0-5,0 c0-0.1,0-0.2,0-0.3c2-0.3,4-0.6,5.5-0.8c-0.8,0-2.2-0.1-3.5-0.2c0-0.1,0-0.2,0-0.3c3.5-0.2,7.1-0.5,10.6-0.7c0-1.1,0.2-2.1,2.2-1.6 c1.6,0.4,3.2,0.5,4.8,0.7c-0.4-0.4-0.8-0.7-1.2-1.1c0-0.1,0.1-0.2,0.1-0.3c1.3,0.4,2.7,0.8,4,1.3c0-0.1,0.1-0.2,0.1-0.2 c-0.4-0.2-0.9-0.5-1.4-0.8c0.5-0.1,0.9-0.2,1.2-0.3c-1.9-0.8-3.7-1.5-5.2-2.1c0.1-0.3,0.2-0.8,0.2-0.8c-1.8-0.7-3.6-1.9-5.2-1.8 c-2.3,0.3-2.6-1.7-3.9-2.4c-0.4,0-0.8,0-1.3,0c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.4-0.3 c-1.1,0.5-2.3,1-3.9,1.7c1.3-1.1,2.2-1.9,3-2.7c0-0.1-0.1-0.2-0.1-0.2c-1.6,0.7-3.2,1.3-5,2c0.4-0.6,0.7-1.1,1-1.6 c-0.1,0-0.1-0.1-0.2-0.1c-1.2,1.1-2.4,2.1-3.7,3.2c-0.1-0.1-0.1-0.1-0.2-0.2c0.4-0.6,0.9-1.2,1.3-1.9c0,0-0.1-0.1-0.1-0.1 c-2.6,2.5-5.3,4.9-7.9,7.4c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.7,0.7-1.5,1.2-2.6c-2.2,2.4-3.9,5.1-6.2,6.5c-2.2,1.3-3,3.3-4.4,5 c-3,3.8-6.1,7.5-8.9,11.5c-3,4.1-7,5.9-11.9,6.3c1.2-1,2.4-2.1,3.7-3.2c-0.4-0.2-0.6-0.3-0.9-0.4c1-0.5,1.9-1,2.8-1.5 c0-0.1-0.1-0.2-0.1-0.3c-2.4,1-4.7,2-7.1,3c-0.1-0.2-0.1-0.3-0.2-0.5c3.1-1.6,6.2-3.1,9.4-4.7c0-0.1-0.1-0.2-0.1-0.3 c-1.9,0.8-3.9,1.6-5.8,2.4c0-0.1-0.1-0.1-0.1-0.2c0.4-0.4,0.8-0.7,1.4-1.2c-0.5,0.1-0.9,0.2-1.5,0.3c2.1-1.7,4-3.3,5.9-4.9 c-0.1-0.1-0.2-0.2-0.2-0.3c-1.5,0.8-3,1.6-4.5,2.4c-0.1-0.1-0.1-0.2-0.2-0.3c2.3-1.5,4.6-3,6.8-4.4c-0.1-0.2-0.2-0.5-0.3-0.7 c-2.1,0.9-4.2,1.9-6.6,3c1.7-1.7,4-2.2,5-4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5,0.1-1.1,0.3-1.6,0.4c0-0.1-0.1-0.1-0.1-0.2 c1-0.6,1.9-1.3,2.9-1.9c-0.1-0.2-0.2-0.4-0.3-0.5c-3.3,1.3-6.7,2.6-10,3.8c0-0.1-0.1-0.2-0.1-0.2c2.2-1.2,4.5-2.3,6.7-3.5 c0-0.1-0.1-0.2-0.1-0.3c-3,1.4-6,2.8-9.1,4.1c-0.1-0.2-0.1-0.3-0.2-0.5c3.7-1.9,7.4-3.9,11.1-5.8c0-0.1-0.1-0.2-0.1-0.3 c-2.5,1.1-4.9,2.2-7.4,3.2c0-0.1-0.1-0.1-0.1-0.2c1-0.6,1.9-1.3,2.9-1.9c-0.1-0.1-0.1-0.2-0.2-0.3c-2,1-4,2-5.9,2.9 c0-0.1-0.1-0.1-0.1-0.2c2.1-1.8,4.2-3.5,6.4-5.3c-2.2-2.3,0.8-2.5,1.1-4.1c-2.3,1-4.5,2-6.6,2.9c-0.1-0.1-0.2-0.2-0.3-0.3 c1.2-1.1,2.3-2.3,3.5-3.4c-0.1-0.1-0.1-0.1-0.2-0.2c-2.2,1.8-4.3,3.6-6.5,5.4c-0.1-0.2-0.2-0.3-0.4-0.5c1.6-1.5,3.2-3,4.7-4.5 c0.5-0.5,0.6-1.3,0.9-1.9c0,0,0,0,0,0c0.1-0.6,0.2-1.2,0.4-1.8l0.1,0c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0.1-0.1,0.2-0.2,0.4-0.4c0-0.1,0.1-0.2,0-0.4 c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.4c0.1-0.1,0.2-0.3,0.4-0.4c0-0.1,0-0.2,0-0.4c-0.6,0.3-1.3,0.5-1.9,0.9 c-1.6,1.3-3.1,2.7-4.7,4.1c-0.4-2.5,1.4-3.7,2.7-5.1c1.2-1.4,2.5-2.7,3.8-4.1c-0.2-0.2-0.3-0.3-0.5-0.5c-1.3,1.1-2.6,2.2-4,3.3 c-0.1-0.1-0.1-0.1-0.2-0.2c0.7-0.9,1.3-1.8,2-2.7c-0.1,0-0.1-0.1-0.2-0.1c-0.4,0.3-0.8,0.7-1.2,1c-0.1-0.1-0.3-0.2-0.4-0.3 c0.8-1.3,1.6-2.5,2.4-3.8c-0.3,0.2-0.5,0.3-1.2,0.8c1.7-4.4,3.2-8.3,4.5-12c-0.7-0.4-1.2-0.8-1.8-1.2c-0.2,0.2-0.4,0.6-0.7,0.9 c0.9-1.8,0.1-3.3-1.1-5.3c-0.7,5.6-3.5,9.7-6.7,13.2c0.3-1.3,0.7-2.8,1.1-4.3l0-0.1l-0.1,0c-0.2-0.3-0.4-0.6-0.6-0.9 c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0-0.1,0-0.3,0-0.4c-0.4-0.6-0.9-1.2-1.4-1.9c0.5-1.1,1.2-2.5,1.8-3.8 c-0.1-0.1-0.2-0.1-0.3-0.2c-1.3,2.3-2.6,4.7-3.9,7c-0.1-0.1-0.2-0.1-0.4-0.2c0.8-1.9,1.7-3.8,2.5-5.8c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.8,0.9-1.6,1.8-2.3,2.7c0.3-1.4,0.6-2.9,0.9-4.4c-0.2,0-0.3-0.1-0.5-0.1c-0.8,1.5-1.5,3-2.3,4.6c-0.1,0-0.2-0.1-0.3-0.1 c0.4-1.4,0.8-2.8,1.3-4.1c-0.1,0-0.2-0.1-0.2-0.1c-0.5,0.7-1.1,1.5-1.5,2c-0.3-2.9-0.6-5.8-1-8.8c-0.1,0-0.2,0-0.3,0 c-0.4,1-0.8,2.1-1.1,3.1c-0.1,0-0.2,0-0.3-0.1c0.3-1.7,0.6-3.5,0.9-5.2c0,0-0.1,0-0.1,0c-0.7,1.8-1.3,3.6-2,5.4 c-0.1,0-0.2-0.1-0.3-0.1c0.1-2,0.2-3.9,0.3-5.9c0,0-0.1,0-0.1,0c-0.3,1.5-0.5,3-0.8,4.4c-0.1,0-0.2,0-0.3,0 c-0.1-1.1-0.1-2.2-0.1-2.9c0,0.1-0.1,0.7-0.2,1.2c-0.7-0.6-1.2-1.1-1.5-1.3c-0.3,0.7-0.7,1.3-1.2,2.5c-0.1-1.1-0.2-1.5-0.2-2 c-0.2,0-0.4-0.1-0.6-0.1c-0.7,2.7-1.4,5.4-2,7.9c-0.2-1.6-0.5-3.4-0.7-5.3c-0.1,0-0.2,0-0.3,0c0,1.9,0,3.8,0,6.2 c-0.7-2.8-1.3-5.2-1.8-7.6c-0.1,0-0.2,0-0.3,0.1c0.2,1.7,0.4,3.4,0.6,5.1c-0.1,0-0.2,0-0.3,0.1c-0.5-1.9-1-3.7-1.6-5.9 c-0.1,0.6-0.2,0.8-0.3,1.4c-0.5-1.5-0.8-2.7-1.2-3.9c-0.1,0-0.1,0-0.2,0.1c0.1,0.8,0.2,1.6,0.4,2.4c-0.1,0-0.1,0-0.2,0 c-0.5-1.1-1.1-2.3-1.6-3.4c-0.1,0-0.1,0.1-0.2,0.1c0.4,1.5,0.8,3.1,1.2,4.6c-0.1,0.1-0.2,0.1-0.4,0.2c-1-1.3-1.9-2.6-2.9-3.9 c-0.1,0-0.1,0.1-0.2,0.1c0.6,1.3,1.3,2.5,2,4.1c-1.1-0.7-1.8-1.2-2.9-1.9c1.9,2.2,3.6,4.1,5.2,6c-0.1,0.1-0.3,0.2-0.4,0.4 c-1-0.8-2-1.7-3-2.5c1,1.6,2.1,3.2,3.1,4.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.5-0.4-1-0.7-2-1.5c0.4,0.8,0.6,1.1,0.9,1.7 c-0.7-0.5-1.2-0.9-1.7-1.3c0.3,1.9,1.1,3.6,1.8,5.3c0.1,0.3,0.1,1-0.1,1.2c-1.1,0.9-0.8,1.9-0.2,2.8c0.6,1.1,1.3,2.2,2,3.3 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7-0.9-1.4-1.8-2.1-2.7c-0.1,0-0.1,0.1-0.2,0.1c0.4,1.1,0.9,2.1,1.4,3.4c-1-0.4-1.7-0.6-2.8-1.1 c1.7,2.1,3.1,3.9,4.4,5.6c-0.1,0.1-0.2,0.1-0.2,0.2c-0.9-0.7-1.7-1.4-2.6-2.1c-0.1,0.1-0.1,0.2-0.2,0.3c0.5,0.6,1,1.3,1.5,1.9 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.7-0.6-1.3-1.2-2-1.8c1.7,3.2,4.6,5.7,4.9,9.8c-1-0.8-1.8-1.4-2.7-2.1c1.8,2.9,1.8,2.9,1.7,6 c-4.8-7-6.2-15.9-11.5-22.8c1.2,2.7,2.4,5.4,3.7,8.2c-0.2,0.1-0.4,0.2-0.6,0.3c-1.4-2.7-2.8-5.5-4.2-8.2c-0.1,0.1-0.2,0.1-0.3,0.2 c0.7,1.6,1.3,3.1,2,4.7c-0.1,0.1-0.2,0.1-0.4,0.2c-0.6-0.9-1.2-1.8-1.8-2.7c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.7,0.5,1.4,0.7,2 c-0.9-0.5-1.7-0.9-3-1.6c1.3,2.7,2.5,4.9,3.6,7.2c-1.7-1.3-3.4-2.5-5.2-3.8c-0.2,0.2-0.4,0.5-0.6,0.7c0.6,0.4,1.3,0.8,1.9,1.2 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.5-0.3-1-0.5-1.4-0.8c0,0.1-0.1,0.1-0.1,0.2c0.6,0.5,1.1,1,2.1,1.9c-1.9-0.8-3.2-1.3-4.6-1.9 c2.1,1.6,4.2,3,6.3,4.4c0.4,0.3,1,0.9,0.9,0.9c-1.4,2.1,0.9,1.9,1.7,2.8c-0.9,0.5-1.9,1-2.9,1.5c0,1.3,0,2.6,0,3.9 c-0.1,0-0.1,0-0.2,0c-0.3-1.4-0.5-2.9-0.8-4.7c-0.1,1.4-0.1,2.4-0.2,3.4c-0.1,0-0.2,0-0.2,0c-0.2-1.3-0.5-2.6-0.7-3.9 c-0.1,0-0.2,0-0.2,0c0,1.5,0,2.9,0,4.4c-0.1,0-0.2,0-0.3,0c-0.4-1.9-0.7-3.8-1.1-5.7c-0.1,0-0.1,0-0.2,0c0,0.5-0.1,1-0.2,2 c-0.3-0.8-0.4-1.1-0.5-1.4c-0.2,0.3-0.3,0.5-0.5,0.8c-0.4-1.5-0.7-2.9-1.1-4.3c-0.1,0-0.2,0-0.3,0c0.4,3,0.8,6,1.3,9.2 c-1.3-3.2-2.5-6.1-3.7-9.1c-0.1,0-0.3,0-0.4,0c0.4,2.4,0.9,4.7,1.3,7.1c-0.1,0-0.1,0-0.2,0c-1.4-4.1-2.8-8.3-4.2-12.4 c-0.2,0-0.3,0.1-0.5,0.1c0.4,1.5,0.8,2.9,1.2,4.4c-0.2,0-0.3,0.1-0.5,0.1c-0.8-1.8-1.6-3.6-2.3-5.4c-0.2,0-0.4,0-0.6,0 c-0.1,0.6-0.3,1.2-0.2,1.8c0.2,1,0.7,1.9,1,2.8c1,3,2,6,2.9,9c-2.1-3.3-2.9-7.2-5.2-10.4c-0.2,0.1-0.3,0.1-0.5,0.2 c0.3,0.9,0.6,1.8,0.9,2.8c-2-2.5-4-5-6.1-7.6c1,2.9,1.9,5.6,2.8,8.4c-0.2,0.1-0.4,0.3-0.6,0.4c-1.7-2.3-3.4-4.7-5.1-7 c0,0-0.1,0-0.1,0c0.9,1.7,1.8,3.3,2.6,5c-0.1,0-0.2,0.1-0.3,0.1c-1.2-1.5-2.3-3-3.5-4.5c-0.1,0.1-0.2,0.2-0.3,0.2 c1.7,2.4,3.3,4.8,5,7.2c-0.1,0.1-0.2,0.1-0.3,0.2c-1.9-2-3.8-4.1-5.6-6.1c-0.2,0.2-0.4,0.3-0.6,0.5c1.1,1.6,2.2,3.2,3.5,5.1 c-3.2-2.4-6-4.5-8.8-6.6c-0.1,0.2-0.2,0.3-0.4,0.5c1.6,1.4,3.2,2.8,4.8,4.2c-0.1,0.2-0.3,0.3-0.4,0.5c-2.1-1.1-4.3-2.2-6.4-3.2 c0,0.1-0.1,0.1-0.1,0.2c1.8,1.2,3.6,2.3,5.2,3.4c-3.6,0-7.1,0-10.1,0c1.2,0.4,3,1.1,5.2,1.9c-4.2,1.1-7.9,2-12,3.1 c1.7-0.1,3-0.1,4-0.2c0.1,0.7,0.1,1.2,0.2,1.7c0.1,0.2,0.3,0.3,0.4,0.5c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.2-0.1,0.3 c0.1,0.3,0.2,0.7,0.4,1.1c1.9-0.9,3.7-1.8,5.5-2.7c0,0.1,0.1,0.1,0.1,0.2c-1.1,0.8-2.1,1.6-3.2,2.4c0.1,0.2,0.1,0.3,0.2,0.5 c0.8-0.3,1.7-0.5,2.8-0.8c-0.3,0.5-0.4,0.8-0.6,1c3,1.4,5-1.4,8.1-1.8c-1.7,1-3,1.8-4.2,2.6c0,0.2,0.1,0.4,0.1,0.6c2,0,3.9,0,5.7,0 c-0.6,0.3-1.3,0.6-2.1,1c0,0.1,0,0.1,0.1,0.2c2.1-0.5,4.2-1,6.4-1.6c0,0.1,0.1,0.2,0.1,0.3c-2.5,0.9-5,1.8-7.5,2.7 c0,0.1,0,0.2,0.1,0.2c3.7-0.8,7.3-1.6,11-2.4c0,0.1,0,0.2,0.1,0.3c-3.5,1.1-7.1,2.3-10.6,3.4c0,0.1,0.1,0.2,0.1,0.2 c3.1-0.5,6.2-1.1,9.3-1.6c0,0.1,0,0.3,0.1,0.4c-1.8,0.5-3.7,1-5.5,1.5c0,0.1,0,0.2,0.1,0.3c1.3-0.1,2.6-0.3,3.8-0.4 c0,0.1,0,0.2,0,0.3c-1.4,0.4-2.8,0.7-4.2,1.1c0,0.1,0,0.1,0,0.2c2-0.3,4.1-0.6,6.1-0.8c0,0.1,0,0.2,0,0.4c-2.8,0.6-5.7,1.2-8.5,1.8 c0,0.1,0,0.2,0,0.2c2.6-0.3,5.2-0.6,8.3-0.9c-0.6,0.5-0.8,0.6-0.9,0.7c2.5,0,4.9,0,7.9,0c-3.3,0.4-6,0.7-8.7,1.1c0,0,0,0.1,0,0.1 c3.8,0,7.6,0,11.3,0c0,0.1,0,0.1,0,0.2c-4.1,0.4-8.3,0.7-12.4,1.1c0,0.1,0,0.2,0,0.3c4.1,0,8.2,0,12.3,0c0,0,0,0.1,0,0.1 c-5.1,0.4-10.2,0.8-15.3,1.2c0,0.1,0,0.1,0,0.2c4.2,0,8.4,0,12.7,0c0,0.2,0,0.4,0,0.6c-3,0-6.1,0-9.1,0c0,0.3,0,0.5,0,0.8 c4.6,0,9.1,0,13.7,0c0,0.2,0,0.4,0,0.6c-5,0.2-9.9,0.4-14.9,0.7c0,0.1,0,0.1,0,0.2c5,0.2,10,0.4,15,0.6c0,0.1,0,0.1,0,0.2 c-4.8,0.2-9.6,0.5-14,0.7c7.6,0.2,15.6,0.4,23.7,0.7c-7.5,2.4-15.2,2.4-22.9,2.8c2.8,0.2,5.6,0.4,8.4,0.6c0,0.1,0,0.1,0,0.2 c-1.4,0.2-2.8,0.4-4.2,0.6c5.1,0,10.2,0,15.4,0c0,0.1,0,0.2,0,0.3c-4.7,0.6-9.4,1.2-14,1.8c0,0.1,0,0.1,0,0.2c2.6,0,5.3,0,7.9,0 c-3.3,0.6-6.7,0.9-10,1.1c-1,0.1-2.1-0.3-3-0.7c-2.4-1.4-4.7-2.9-7.2-4.5c0.3,1,0.6,1.6,0.8,2.2c-0.8,0-1.6-0.1-2.4-0.1 c0,0.1-0.1,0.2-0.1,0.3c1.4,1,2.8,1.9,4.2,2.9c-0.1,0.1-0.1,0.2-0.2,0.2c-1.7-0.9-3.5-1.7-5.2-2.6c0,0.1-0.1,0.1-0.1,0.2 c0.5,0.3,1,0.7,1.5,1.1c-0.3,0.1-0.5,0.2-0.8,0.4c0.5,0.4,1.1,0.8,1.8,1.4c-1.1-0.3-1.8-0.5-2.6-0.7c0,0.1-0.1,0.2-0.1,0.3 c3,1.4,5.9,2.9,8.9,4.3c0,0.1-0.1,0.2-0.1,0.2c-4.3-1.1-8.5-2.3-12.8-3.4c0,0.2-0.1,0.4-0.1,0.5c2.9,0.9,5.8,1.8,8.7,2.7 c0,0.1-0.1,0.2-0.1,0.3c-2.5-0.4-5.1-0.8-7.6-1.2c0,0.1,0,0.2,0,0.3c2.1,0.5,4.3,1,6.4,1.5c0,0.1,0,0.2-0.1,0.3 c-1.5-0.1-3-0.3-4.5-0.4c0,0,0,0.1,0,0.1c1.4,0.2,2.9,0.5,4.3,0.7c0,0.1,0,0.1,0,0.2c-3.2,0.2-6.4,0.4-9.9,0.7 c3.5,0.2,6.7,0.4,9.8,0.5c0,0.1,0,0.2,0,0.3c-3.2,0.3-6.4,0.7-9.6,1c0,0.1,0,0.2,0,0.3c2.8-0.2,5.7-0.3,8.5-0.5c0,0.1,0,0.3,0,0.4 c-1.3,0.3-2.6,0.7-3.9,1c0,0.1,0,0.2,0.1,0.2c3.2-0.4,6.4-0.8,9.6-1.2c0,0.2,0.1,0.3,0.1,0.5c-2.3,0.9-4.6,1.8-6.8,2.9 c-1.3,0.6-2.3,0.5-3.6-0.2c-3.6-2-7.4-3.9-11.1-5.7c-1.2-0.6-2.4-1-3.6-1.4c0,0.1-0.1,0.2-0.1,0.3c2.9,1.6,5.7,3.1,8.6,4.7 c-0.1,0.1-0.1,0.2-0.2,0.4c-3.4-1.5-6.9-3.1-10.3-4.6c0,0.3,0,0.5,0,0.8c-0.7,0.1-1.4,0.5-2,0.3c-1.9-0.7-3.7-1.5-5.5-2.3 c0,0.1-0.1,0.2-0.1,0.3c3.8,1.9,7.7,3.8,11.5,5.6c-0.1,0.1-0.1,0.3-0.2,0.4c-4.1-1.7-8.2-3.3-12.3-5c0,0.1-0.1,0.2-0.1,0.3 c1.9,0.9,3.8,1.8,6.1,2.9c-4.3-0.8-8.2-1.5-12-2.2c0,0,0,0,0,0.1c5.4,1.4,10.8,2.9,16.2,4.3c-0.1,0.2-0.1,0.4-0.2,0.6 c-6.2-1.3-12.4-2.6-18.6-3.9c0,0.2-0.1,0.3-0.1,0.5c3.4,0.8,6.9,1.6,10.3,2.3c0,0.1,0,0.2-0.1,0.3c-4.4-0.7-8.7-1.4-13.1-2 c0,0.1,0,0.1,0,0.2c3.2,0.6,6.4,1.3,9.6,1.9c0,0.1,0,0.2-0.1,0.3c-3.3-0.3-6.7-0.6-10-0.9c0,0.1,0,0.2,0,0.3c5,0.7,10,1.5,15.1,2.2 c0,0.2,0,0.3,0,0.5c-5.4-0.2-10.9-0.5-16.3-0.7c0,0,0,0.1,0,0.1c0.6,0.1,1.3,0.2,1.9,0.3c0,0.1,0,0.1,0,0.2 c-0.6,0.1-1.2,0.2-1.8,0.3c1.4,0.1,2.8,0.2,4.2,0.2c0,0.1,0,0.1,0,0.2c-1.2,0.1-2.3,0.2-3.5,0.3c0,0.1,0,0.2,0,0.3 c2.1,0,4.2,0,6.3,0c0,0.1,0,0.2,0,0.3c-2.4,0.2-4.8,0.4-7.2,0.6c0,0.1,0,0.1,0,0.2c2.1,0,4.3,0,6.4,0c0,0.1,0,0.2,0,0.3 c-1.2,0.1-2.4,0.2-4.1,0.3c1.1,0.2,1.7,0.3,2.3,0.4c0,0.1,0,0.1,0,0.2c-0.7,0.1-1.5,0.1-2.2,0.2c0,0.1,0,0.2,0,0.3 c0.8,0,1.7,0,2.5,0c0,0.1,0,0.2,0,0.3c-0.4,0.1-0.7,0.2-1.2,0.3c0.4,0.2,0.7,0.3,1.1,0.4c-1.6,0.4-2.9,0.8-4.4,1.3 c0.3,0.7,0.5,1.2,0.7,1.7c-1.2,1.1-2.5,2.2-3.7,3.4c-0.2,0.2,0.1,0.7,0.1,1.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.7-0.8,1.4-1.2,2.1c0.7,1.7-1.2,2.5-1.5,3.1c0.2,1.9,0.3,3.3,0.4,4.7 C509.3,114.6,509.7,114.1,510.5,113.2z M550.5,148.5c1.6-1.4,3.3-2.8,5-4.3C555.8,145.8,553.9,147.4,550.5,148.5z M597.1,140 c0-1.1,0-1.9,0-2.7c0.2-0.1,0.4-0.2,0.6-0.3c0.5,0.6,1,1.2,1.6,2C598.4,139.3,597.8,139.6,597.1,140z M705.2,166.3 c1.5,1.7,3,3.5,4.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.3c-1.5-1.8-3-3.5-4.5-5.3C705,166.5,705.1,166.4,705.2,166.3z M664.1,120.7 c1.5,1.6,3,3.3,4.5,4.9c0,0-0.1,0.1-0.1,0.1c-1.6-1.6-3.1-3.1-4.7-4.7C663.8,120.9,664,120.8,664.1,120.7z M691.2,79 c0.4-0.1,1.1,0.5,1.6,0.8c-2.5,0.6-4.5,1-6.5,1.5c0-0.1-0.1-0.2-0.1-0.3C687.8,80.3,689.5,79.5,691.2,79z M654.6,121.7 c0.2,0,0.4,0,0.6,0.1c0.1,0.6,0.5,1.5,0.2,1.8c-0.4,0.4-1.2,0.4-1.9,0.6c-0.1-0.2-0.2-0.3-0.3-0.5 C653.7,123,654.1,122.3,654.6,121.7z M642.1,79.6c0.2,0.3,0.4,0.5,0.6,0.8c-2,1.3-4,2.5-6.1,3.8C637.4,81.2,640.3,81.2,642.1,79.6z  M626.7,111.2c-1.6,0.6-2.5,2.3-4.6,1.4c0.6-1.1,1.1-2.2,1.6-3.3C624.8,109.9,625.6,110.5,626.7,111.2z M618.9,107 c1.2-0.4,2.4-0.5,4.3-0.8c-0.9,2.3-1.7,4.3-2.7,6.7c-0.9-1.8-1.7-3.2-2.3-4.6C618.1,108,618.5,107.1,618.9,107z M605,140.7 c-1.5,0-2.9,0-4.3,0C603,138.7,604.4,138.6,605,140.7z M575.2,83.4c-0.6,0.1-1.4-0.5-2-0.8c0-0.2,0.1-0.4,0.1-0.6 c4.8-0.4,9.5-0.8,14.3-1.2c0,0.1,0,0.3,0.1,0.4C583.5,81.9,579.4,82.7,575.2,83.4z M576.4,85c0-0.3,0-0.5-0.1-0.8 c2.3-0.5,4.6-1,6.9-1.5C581,83.7,578.9,85.2,576.4,85z M578.3,86.4c0-0.3-0.1-0.5-0.1-0.8c2.5-0.5,5.1-1,7.6-1.6 c0.1,0.2,0.1,0.5,0.2,0.7C583.4,85.2,581.1,86.8,578.3,86.4z M586,91.4c0-0.2-0.1-0.3-0.1-0.5c2.2-0.6,4.4-1.2,6.6-1.8 c0.1,0.2,0.1,0.4,0.2,0.6C590.4,90.2,588.2,90.8,586,91.4z M592.5,85.5c-3.5,1.4-6.6,2.6-9.7,3.6c-0.6,0.2-1.5-0.6-2.3-0.9 C584.4,86.7,587.8,84.6,592.5,85.5z M570.6,79.9c6.1,0,12.3,0,18.5,0c-5.3,0.5-10.5,1-15.8,1.4c-0.9,0.1-1.9-0.4-2.8-0.6 C570.5,80.4,570.5,80.2,570.6,79.9z M564.5,88.2c0.2,0.7,0.3,1.1,0.4,1.6c0.5-0.3,1.1-0.7,2-1.3c-0.2,1-0.3,1.6-0.4,2.5 c0.7-1,1.2-1.8,1.7-2.5c0.1,0,0.3,0,0.4,0c0,1.4,0,2.8,0,4.1c0.2-0.4,0.5-0.9,1-1.9c0.2,2.1,0.3,3.6,0.5,5.4 c-3.7-1.2-7.2-2.4-11.1-3.7C560.9,90.9,562.6,89.6,564.5,88.2z M542.3,104.4C542.3,104.4,542.3,104.4,542.3,104.4 C542.4,104.4,542.4,104.4,542.3,104.4C542.3,104.4,542.3,104.4,542.3,104.4z M542.4,103.7c0,0.2,0,0.4,0,0.6 C542.4,104.1,542.4,103.9,542.4,103.7C542.4,103.7,542.4,103.7,542.4,103.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145760020931041002370000016130429749809788821_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.2707,
    y1: 105.5308,
    x2: 541.2707,
    y2: 105.3776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145760020931041002370000016130429749809788821_)"
    },
    d: "M541,105.4c0.1,0,0.3,0.1,0.4,0.1 c0,0,0.1-0.1,0.1-0.1C541.4,105.4,541.2,105.4,541,105.4C541.1,105.4,541,105.4,541,105.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139285595851528396690000000159321275041884556_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.2203,
    y1: 131.0854,
    x2: 683.2203,
    y2: 131.0576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139285595851528396690000000159321275041884556_)"
    },
    d: "M683.2,131.1 C683.2,131.1,683.2,131.1,683.2,131.1C683.2,131.1,683.2,131.1,683.2,131.1C683.2,131.1,683.2,131.1,683.2,131.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125594985540726930350000003889502405984080522_",
    gradientUnits: "userSpaceOnUse",
    x1: 684.7674,
    y1: 44.6072,
    x2: 684.7674,
    y2: 44.6051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000125594985540726930350000003889502405984080522_)"
    },
    points: "684.8,44.6 684.8,44.6  684.8,44.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089548925319020703690000007389776640331111861_",
    gradientUnits: "userSpaceOnUse",
    x1: 569.3784,
    y1: 72.4431,
    x2: 569.3784,
    y2: 72.2514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089548925319020703690000007389776640331111861_)"
    },
    d: "M568.7,72.4c0.4-0.1,0.9-0.1,1.3-0.2 c-0.4,0-0.9,0-1.3,0C568.7,72.3,568.7,72.4,568.7,72.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053527720744799375780000011971833730403666053_",
    gradientUnits: "userSpaceOnUse",
    x1: 700.6511,
    y1: 110.8534,
    x2: 700.6511,
    y2: 110.8038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053527720744799375780000011971833730403666053_)"
    },
    d: "M700.7,110.8 C700.6,110.9,700.6,110.9,700.7,110.8L700.7,110.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183229305616861500260000000624023609917571244_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.5123,
    y1: 43.8098,
    x2: 634.5123,
    y2: 43.7572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183229305616861500260000000624023609917571244_)"
    },
    d: "M634.5,43.8 C634.5,43.8,634.5,43.8,634.5,43.8C634.5,43.8,634.5,43.8,634.5,43.8C634.5,43.8,634.5,43.8,634.5,43.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129886696750009486600000013369672063767844992_",
    gradientUnits: "userSpaceOnUse",
    x1: 612.0902,
    y1: 217.7611,
    x2: 612.0902,
    y2: 7.5728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129886696750009486600000013369672063767844992_)"
    },
    d: "M510.5,110.9c-0.3,1.2-0.5,1.8-0.7,2.4 c0.1,0,0.2,0.1,0.3,0.1c0.5-1,1-1.9,1.6-3.1c0.2,0.8,0.4,1.3,0.6,1.9c0.7-1.7,1.3-3.2,2.2-5.2c0.4,1.1,0.5,1.7,0.7,2.3 c0-0.6-0.1-1.1-0.1-1.9c0.4,0.6,0.7,0.9,1,1.3c0.4-1,0.6-1.7,0.9-2.5c0.3,0.6,0.5,1.2,0.7,1.7c0.1,0,0.2,0,0.2-0.1 c-0.1-0.5-0.2-1-0.3-1.6c0.6,0.3,1,0.5,1,0.5c0.9-1.1,1.6-2.2,2.7-3.5c0,1.2,0,2,0,2.6c0.7-0.5,1.5-1,2.3-1.6 c0,0.6-0.1,1.2-0.1,1.7c0.1,0,0.2,0,0.3,0c0.4-1.1,0.9-2.2,1.3-3.4c3,3.2,3.1-0.6,4.6-2.1c-0.4,1.4-0.7,2.5-0.9,3.6 c0.2-0.1,0.4-0.2,0.7-0.3c0.4,0.5,0.7,1.1,1.1,1.6c0.8-1.1,2-3,3.6-1.4c2.2,2.2,3,0.6,4.2-0.8c1-1.2,2.1-2.4,3.1-3.6 c0.1,0.1,0.3,0.2,0.4,0.4c-1,1.3-2.1,2.7-3.4,4.3c1.2-0.5,1.9-0.8,2.6-1.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0.1,0,0.1,0 c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.2,0.2-0.3,0.3-0.5c0,0.2,0.1,0.3,0.1,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.8,0.1,1.7,0.1,2.5,0.2 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0,0.5,0c0.2,0.1,0.5,0.2,0.7,0.4 c1.6-0.1,3.2-0.2,4.9-0.2c0.1,0,0.2,0.1,0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0,0,0,0c-0.1,0.1-0.3,0.3-0.4,0.4c0,0,0,0,0,0 c0,0.1-0.1,0.3-0.1,0.4c0.6,0.9,1.3,1.8,2.6,1.1c1.1-0.6,2.2-1.2,3.5-1.8c-0.1,0.5-0.1,0.8-0.2,1.3c2.4-1.7,4.6-3.3,6.8-5 c0.1,0.1,0.2,0.2,0.3,0.4c-2.4,2-4.8,3.9-7.2,5.9c0.1,0.1,0.2,0.3,0.3,0.4c3.2-2.5,6.3-5.1,9.5-7.6c-2.3,3.5-5.3,6-9,7.8 c-0.6,0.3-1.1,0.8-1.6,1.2c0.1,0.2,0.2,0.4,0.3,0.5c1.3-0.6,2.5-1.1,3.8-1.7c0.1,0.2,0.2,0.3,0.3,0.5c-0.6,0.5-1.3,1-1.8,1.6 c-1.1,1.2-2,2.4-3,3.7c0.1,0.1,0.3,0.2,0.4,0.3c1.3-0.9,2.6-1.7,3.9-2.5c-2.5,5.5-5.1,11-7.6,16.6c0.2,0.1,0.4,0.2,0.6,0.3 c0.4-0.6,0.9-1.3,1.3-2c0.1,0.9,0.1,1.7,0.2,2.9c0.5-1.7,0.9-2.8,1.3-3.9c0.1,0,0.2,0,0.3,0.1c-0.1,1-0.2,2-0.3,3.1 c0.1,0,0.1,0,0.2,0c0.4-1.6,0.7-3.1,1.2-5c0.2,0.7,0.3,1,0.4,1.6c0.1-0.8,0.2-1.2,0.3-2.1c0.2,0.8,0.3,1.2,0.5,1.8 c0.1-0.8,0.2-1.3,0.3-1.9c0.1,0,0.1,0,0.2,0c0.1,0.5,0.2,0.9,0.3,1.3c0.2-1,0.5-2.1,0.8-3.4c0.2,0.5,0.3,0.7,0.4,0.9 c0-0.1,0-0.3,0-0.4c0.2-0.9-0.9-2.1,0.5-2.8c0.1-0.1,0.1-0.4,0.2-1.1c0.3,2,0.5,3.4,0.8,5c0.9-3.1,1.7-6,2.7-9.2 c-0.2,2.5-0.3,4.7-0.4,6.9c0,0,0.1,0,0.1,0c0.9-4.6,1.8-9.1,2.7-13.7c0.2,0,0.3,0.1,0.5,0.1c-0.3,1.7-0.6,3.4-0.9,5.2 c0.1,0,0.2,0,0.2,0c0.6-2,1.2-4,1.9-6.1c0.1,0,0.1,0,0.2,0.1c-0.1,1.2-0.2,2.4-0.3,3.7c0.1,0,0.1,0,0.2,0c0.6-2,1.2-4,1.9-6 c0.1,0,0.2,0.1,0.4,0.1c-0.4,4.3-0.8,8.6-1.3,13.4c0.9-4.7,1.6-8.9,2.4-13.1c0.2,0,0.4,0.1,0.7,0.1c-0.3,3.5-0.6,7-0.9,10.5 c0.1,0,0.2,0,0.3,0c0.6-3.6,1.2-7.3,1.8-11.1c1.2,3.5,2.3,6.7,3.4,9.9c0.1,0,0.3-0.1,0.4-0.1c-0.7-2.9-1.4-5.8-2.2-8.6 c0.2-0.1,0.4-0.1,0.6-0.2c1,3,2,6,3,9c0.1,0,0.2-0.1,0.3-0.1c-1-3.5-2-6.9-3-10.4c0.2-0.1,0.4-0.1,0.5-0.2c1.3,2.8,2.5,5.6,3.8,8.4 c0.1,0,0.2-0.1,0.2-0.1c-0.5-1.6-0.9-3.1-1.5-4.8c0.8,0.2,1.5,0.3,1.7,0.6c1.3,2.7,2.4,5.5,3.6,8.3c0.1,0,0.2-0.1,0.3-0.1 c-1.2-3.9-2.5-7.7-3.9-12c0.7,0.9,1.1,1.4,1.4,1.8c0-1.3,0-2.6,0-3.9c0.2,0,0.4-0.1,0.6-0.1c0.9,3.3,1.9,6.5,2.8,9.9 c0.1-0.6,0.2-1.1,0.4-2.1c0.6,3.3,1,6.1,1.5,8.8c0.1,0,0.2,0,0.3,0c-0.3-2.6-0.6-5.1-0.9-8.1c0.8,2.1,1.5,3.7,2.1,5.4 c0.3-1.2,0.4-2.4,0.3-3.5c-0.1-1.2-0.3-2.4-0.4-3.5c0.1,0,0.2,0,0.3-0.1c0.5,1.6,1,3.1,1.5,4.8c0.1-0.3,0.3-0.6,0.4-0.8 c0.6,0.7,1.2,1.3,2,2.3c-0.4-1.7-0.7-3-1-4.5c1.1,1.7,2,3.2,2.9,4.8c0.1-0.1,0.2-0.1,0.4-0.2c-0.5-1.7-1.1-3.5-1.6-5.2 c0.1,0,0.2-0.1,0.3-0.1c1.3,2.9,2.6,5.8,3.9,8.7c0.2-0.1,0.3-0.1,0.5-0.2c-1.4-3.5-2.8-7-4.2-10.6c3.6,3.8,4.8,8.7,6.7,13.3 c-0.2-1.2-0.5-2.4-0.7-3.6c0.1,0,0.2,0,0.3-0.1c0.7,1.7,1.4,3.4,2.2,5.3c-1,0-1.7,0-2.4,0c-6.8-0.4-13.4,0.2-20,2 c-3.9,1.1-7.7,2.7-11.7,3.7c-15.9,4-31.2,9.5-44.8,19.1c-0.4,0.3-0.7,0.6-1.5,1.2c1.2-0.4,1.8-0.7,2.5-0.9c0,0.1,0.1,0.1,0.1,0.2 c-2.9,2.2-5.8,4.5-8.7,6.7c0.1,0.1,0.2,0.2,0.3,0.4c0.8-0.4,1.6-0.8,2.3-1.3c0.1,0.1,0.1,0.2,0.2,0.2c-1.4,1.3-2.8,2.6-4.2,4 c0.1,0.1,0.1,0.1,0.2,0.2c1.2-0.9,2.5-1.9,3.7-2.8c0,0.1,0.1,0.1,0.1,0.2c-2.4,2.8-4.7,5.7-7.1,8.5c0,0,0.1,0.1,0.1,0.1 c1.3-1.2,2.6-2.3,3.9-3.5c0.1,0.1,0.1,0.2,0.2,0.2c-1.1,1.3-2.3,2.6-3.4,3.8c0.6,0.1,1.2,0.4,1.6,0.2c0.6-0.3,1.1-1,1.7-1.5 c0.1,0.1,0.1,0.1,0.2,0.2c-0.9,1.3-1.8,2.7-3,4.5c0.8-0.5,1-0.6,1.6-1c-0.9,1.5-1.5,2.6-2.1,3.7c0.1,0,0.1,0.1,0.2,0.1 c0.5-0.4,1-0.9,1.8-1.7c-0.8,1.6-1.3,2.8-1.9,4c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.4,0.6-0.9,0.9-1.3c0.1,0.1,0.2,0.2,0.3,0.3 c-0.4,1.1-0.8,2.2-1.2,3.3c0.1,0,0.2,0.1,0.2,0.1c0.3-0.4,0.6-0.8,1.1-1.5c0.2,1.9,0.4,3.4,0.5,4.9c0,0,0.1,0,0.1,0 c0.1-0.9,0.1-1.7,0.2-2.6c0.1,0,0.2,0,0.3,0c0.2,0.6,0.4,1.2,0.8,2.3c0-1.7,0-2.9,0-4.4c0.3,0.6,0.5,0.9,0.7,1.2 c0.1-0.6,0.1-1.1,0.2-1.6c1,0.8,1.7,0.8,2-0.5c0.1-0.6,0.6-1.2,1-2.2c0.2,0.7,0.2,1,0.3,1.4c0.3-0.6,0.5-1.1,0.8-1.7 c0.2,0.5,0.3,0.7,0.4,1c0.1,0,0.2-0.1,0.3-0.1c-0.1-1.4-0.3-2.8-0.4-4.3c0.1,0,0.2,0,0.3,0c0.2,0.9,0.4,1.8,0.7,2.8 c0.2-0.4,0.3-0.7,0.5-1.1c0.1,0.5,0.2,0.8,0.3,1.1c0.2-1,0-1.9,0-2.9c0-0.9,0.2-1.8,0.2-2.7c0.1,0,0.2,0,0.3,0 c0.1,0.3,0.2,0.7,0.4,1.2c0.3-0.6,0.5-1,0.8-1.5c0.1,0.6,0.2,0.8,0.3,1.2c0.3-1.8,0.5-3.6,0.8-5.3c0.1,0,0.2,0,0.3,0.1 c0.3,1.3,0.6,2.6,1.1,4.5c0-2.1,0-3.7,0-5.3c0.1,0,0.2,0,0.4,0c0.1,0.4,0.2,0.8,0.3,1.4c0.4-0.9,0.7-1.7,1.1-3 c0.1,1.2,0.2,1.9,0.3,3c3-2.3,0.3-5.2,1.5-7.5c0.1,0.7,0.2,1.2,0.2,1.6c0.1-0.2,0.3-0.4,0.5-0.7c0.1,1.1,0.2,1.9,0.3,3.2 c0.3-2.4,0.6-4.3,0.9-6.5c0.2,0.8,0.3,1.3,0.3,1.3c0.2-1,0.6-2.3,0.9-3.7c0.1,0,0.3,0,0.4,0.1c0.1,1.5,0.1,3,0.2,4.6 c0.1,0,0.1,0,0.2,0c0.1-1.2,0.2-2.4,0.2-3.6c0.1,0,0.2,0,0.2,0c0.1,0.7,0.1,1.3,0.2,2c0,0,0.1,0,0.1,0c0.1-1.1,0.1-2.1,0.2-3.2 c0.1,0,0.2,0,0.3,0c0.1,1.1,0.2,2.2,0.2,3.3c0.1,0,0.2,0,0.3,0c0-2,0-4,0-6c0.1,0,0.2,0,0.3,0c0.2,2.2,0.4,4.4,0.7,6.7 c0.1,0,0.2,0,0.3,0c0-1.3,0-2.5,0-3.8c0.1,0,0.1,0,0.2,0c0.1,1.7,0.3,3.5,0.4,5.2c0.1,0,0.1,0,0.2,0c0.5-2.8,1-5.6,1.5-8.6 c0.1,1.4,0.1,2.6,0.2,3.7c0.1,0,0.1,0,0.2,0c0.1-1,0.2-2,0.3-2.9c0.1,0,0.2,0,0.3,0c0,1.2,0,2.3,0,3.5c0.1,0,0.1,0,0.2,0 c0.3-1.8,0.5-3.6,0.8-5.3c0.1,0,0.2,0,0.2,0c0,1.3,0,2.6,0,4c0.1,0,0.1,0,0.2,0c0.2-2,0.5-3.9,0.8-6.3c0.3,1.9,0.5,3.5,0.8,5.4 c0.3-2.3,0.6-4.1,0.8-5.9c0.1,0,0.2,0,0.3,0c0,2.2,0,4.4,0,6.7c0.9-2.5,1.7-4.9,2.5-7.2c0-0.1,0.1-0.2,0.3-0.4 c0.2,0.3,0.5,0.5,0.7,0.8c0.7-1.1,1.4-2.2,2-3c0.5,0.8,1,1.7,1.6,2.6c0.4-0.5,0.8-1.2,1.3-1.9c0.1,0.6,0.2,1,0.4,1.6 c0.1-0.8,0.2-1.5,0.3-2.1c0.1,0,0.1,0,0.2,0c0.1,0.6,0.1,1.2,0.2,2.1c0.3-0.5,0.4-0.8,0.5-1.1c-0.1,3.1-3,4.4-4.3,6.9 c0.6-0.3,1-0.5,1.7-0.9c-2.1,3.5-3.6,7-7.5,8.6c0.1,0.1,0.3,0.3,0.4,0.4c1.9-1.1,3.8-2.2,5.6-3.4c0.1,0.2,0.3,0.5,0.4,0.7 c-4.8,3.2-9.7,6.3-14.8,9.7c0.8-0.1,1.2-0.2,1.6-0.2c0,0.1,0.1,0.2,0.1,0.3c-1.3,0.9-2.5,1.8-4.2,3c0.9-0.2,1.4-0.3,2.3-0.5 c-1.2,1.1-2.1,1.9-2.9,2.7c-0.9,0.8-1.9,1.5-2.7,2.4c-0.7,0.7-2.1,1-1.4,2.5c0.5-0.2,1-0.5,1.9-0.9c-2.3,2.4-4.4,4.5-6.4,6.6 c0.1,0.1,0.3,0.3,0.4,0.4c0.4-0.1,0.8-0.3,1.4-0.5c-0.4,1.5-1.7,1.9-2,3.5c-0.5,2.5-2.2,4.7-3.3,7c-0.1,0.2-0.1,0.4-0.2,0.7 c0.4,0.1,0.8,0.2,1.4,0.4c-0.8,2.4-1.5,4.7-2.3,7c-0.3,0.9-0.7,1.7-1,2.6c-0.1,0.4,0.1,0.8,0.2,1.5c0.5-0.9,0.8-1.5,1.1-2.1 c0.3,0.4,0.5,0.7,0.7,1c0.8-1.4,1.5-2.7,2.2-4.1c0.1,0.4,0.2,0.6,0.3,0.9c0.3-1.4,0.5-2.6,0.8-3.9c0.2,0,0.4,0,0.5,0 c0.2,1.2,0.4,2.3,0.7,3.7c0.4-3.1,0.7-6,1.1-8.8c0.1,0,0.1,0,0.2,0c0.1,0.7,0.2,1.4,0.2,2c0.4-1.6,0.8-3.3,1.3-5.4 c0.1,2,0.2,3.6,0.3,4.9c0.2-1.1,0.5-2.5,0.8-3.8c0.1,0,0.2,0,0.4,0.1c0.1,0.5,0.1,1,0.1,1.2c0-0.2,0.1-0.7,0.2-1.2 c0.1,0,0.2,0,0.2,0c0.1,1.2,0.3,2.4,0.4,3.5c0.1-1.4,0.2-3,0.4-5.1c0.2,1.7,0.3,2.8,0.4,3.3c0.3-2.4,0.8-5.4,1.2-8.4 c0.1,0,0.2,0,0.2,0c0,2.5,0,5,0,7.5c0.1,0,0.2,0,0.3,0c0.5-3.1,1.1-6.1,1.6-9.2c0.1,0,0.2,0,0.4,0c0,2.2,0,4.4,0,6.6 c0.1,0,0.2,0,0.3,0c0.1-0.5,0.2-1.1,0.4-2.1c0.2,1.2,0.3,1.8,0.4,2.1c0.5-2.1,1-4.3,1.5-6.6c0.1-0.3,0.1-0.7,0.2-1.6 c0.2,1.1,0.3,1.6,0.5,2.6c0.1-1.1,0.2-1.7,0.3-2.3c0.1,0,0.3,0,0.4,0c-0.1,2.9-0.3,5.7-0.4,8.6c0,0,0.1,0,0.1,0 c0.5-3.6,1-7.3,1.6-10.9c0.1,0,0.2,0,0.3,0c-0.1,2.4-0.2,4.9-0.4,7.3c0.1,0,0.2,0,0.4,0c0.5-2.7,0.9-5.5,1.4-8.2c0.1,0,0.1,0,0.2,0 c0.2,2.8,0.5,5.6,0.6,7.5c0.4-1.4,0.9-3.5,1.7-6.2c0.2,1,0.3,1.5,0.4,1.7c0.2-2.1,0.4-4.6,0.7-7.3c0.3,1.2,0.5,2.1,0.8,3.3 c0.5-1.9,0.8-3.4,1.2-4.9c0.1,0,0.2,0,0.3,0c-0.5,4.2-1,8.4-1.6,12.5c0.1,0,0.1,0,0.2,0c0.8-3.5,1.5-7,2.3-10.6c0.1,0,0.2,0,0.3,0 c-0.1,1.2-0.3,2.5-0.4,3.7c0.1,0,0.1,0,0.2,0c0.4-1.5,0.8-3,1.1-4.5c0,0,0.1,0,0.1,0c-0.2,2.5-0.3,5.1-0.5,7.6c0.1,0,0.3,0,0.4,0 c0.2-1,0.5-2,0.8-3.2c0.2,0.4,0.2,0.5,0.3,0.7c0,0,0.1,0.1,0.1,0.1c0.3-1,0.5-2,0.8-2.9c0.1,0,0.2,0,0.2,0c0,0.6,0.1,1.2,0.1,2.3 c0.2-1,0.3-1.3,0.4-1.8c0.2,0.4,0.3,0.7,0.5,1.1c0.5-2.3,1-4.4,1.5-6.5c0.1,0,0.2,0,0.3,0c-0.3,2-0.5,4.1-0.8,6.1 c0.1,0,0.1,0,0.2,0c0.3-1,0.5-2,0.8-3c0.1,0,0.2,0,0.3,0.1c-0.2,1.6-0.3,3.3-0.5,4.9c0.1,0,0.2,0,0.2,0c0.4-1.6,0.7-3.2,1.1-4.8 c0.1,0,0.2,0,0.3,0c-0.1,1.1-0.2,2.3-0.3,3.9c0.5-1.8,0.9-3.1,1.3-4.4c0.1,0,0.2,0,0.3,0c-0.1,1.3-0.3,2.5-0.4,3.8 c0.1,0,0.1,0,0.2,0c1-3,1.9-6,2.9-8.9c0.1,0,0.1,0,0.2,0c-0.1,1.7-0.3,3.5-0.4,5.2c0,0,0.1,0,0.1,0c0.4-2.1,0.8-4.3,1.1-6.4 c0.1,0,0.2,0,0.3,0c-0.1,1.7-0.2,3.4-0.4,5.6c0.4-1.4,0.7-2.3,0.9-3.2c0.1,0,0.2,0,0.3,0.1c-0.2,2-0.3,4-0.5,6c0.1,0,0.2,0,0.2,0 c0.5-3.1,1-6.1,1.5-9.2c0.1,0,0.2,0,0.4,0c0,1.5,0,3,0,4.5c0.1,0,0.1,0,0.2,0c0.4-3,0.7-6,1.1-9c0.1,0,0.2,0,0.3,0c0,1.7,0,3.3,0,5 c0.1,0,0.2,0,0.2,0c0.2-1.1,0.5-2.3,0.8-3.5c0,3.8,0,7.5,0,11.2c0,0,0.1,0,0.1,0c0.3-3.5,0.7-6.9,1-10.4c0.1,0,0.2,0,0.3,0 c0,2,0,4,0,5.9c0,0,0.1,0,0.1,0c0.3-2.6,0.6-5.2,0.9-7.9c0.3,2.7,0.5,5.2,0.8,7.6c0.5-2,0.9-4,1.4-6c0.1,0,0.2,0,0.3,0 c0.1,0.8,0.2,1.7,0.3,2.5c0.1,0,0.2,0,0.3,0c0-1.2,0-2.4,0-3.6c0.1,0,0.2,0,0.2,0c0.1,0.7,0.2,1.4,0.3,2.2c0.4-1.2,0.9-2.3,1.3-3.6 c0.1,0.8,0.2,1.6,0.3,2.3c0.1-0.7,0.2-1.5,0.3-2.3c1.1,3.7,2.5,7.2,1,11.1c-0.9,2.5-1.2,5.3-1.7,8c0.2,0,0.3,0.1,0.5,0.1 c0.7-3.1,1.5-6.1,2.2-9.2c0.1,0,0.3,0.1,0.4,0.1c-0.5,2.9-1,5.9-1.6,8.8c0.2,0,0.4,0.1,0.5,0.1c0.9-4,1.8-7.9,2.7-12.4 c0.6,2.2,1.1,3.9,1.6,5.6c0.1,0,0.2,0,0.3-0.1c-0.3-1.7-0.6-3.3-0.9-5.1c0.4,0.2,0.6,0.3,0.9,0.4c-0.2-0.9-0.3-1.5-0.4-2.1 c0.1-0.1,0.2-0.1,0.3-0.2c0.8,1,1.6,2,2.4,3c-0.2-0.9-0.5-2-0.7-3c0.1,0,0.2,0,0.3-0.1c0.4,0.8,0.7,1.5,1.1,2.3 c0-0.9-0.2-1.6-0.4-2.4c-0.2-0.8-0.3-1.6-0.5-2.3c0.9,3.2,5.1,6.4,0,9.6c0.5,0.1,0.8,0.1,1.1,0.2c-0.3,0.4-0.6,0.7-0.9,1.2 c1.1-0.2,1.8-0.3,2.6-0.4c0,0.1,0,0.2,0,0.2c-1.8,0.7-3.6,1.5-5.4,2.2c0,0.1,0.1,0.2,0.1,0.3c2.7-0.8,5.4-1.6,8.1-2.5 c0,0.1,0.1,0.3,0.1,0.4c-2.2,0.9-4.4,1.7-6.6,2.6c0,0.1,0.1,0.2,0.1,0.3c2.8-0.9,5.5-1.9,8.3-2.8c0,0.1,0,0.1,0.1,0.2 c-3.7,1.8-7.4,3.6-11.1,5.4c0.1,0.1,0.1,0.2,0.2,0.4c4.6-1.7,9.2-3.4,13.9-5c0.1,0.2,0.1,0.3,0.2,0.5c-2.6,1.9-5.2,3.8-7.7,5.8 c-4.4,3.5-5.7,4.9-6.4,6.7c3.4-2.9,6.9-5.8,10.4-8.8c0.2,0.2,0.4,0.4,0.5,0.6c-2.1,2-4.4,4-6.4,6.1c-2,2.2-3.7,4.6-4.5,7.5 c4.2-7.5,10.9-12.1,18.1-16.3c0.1,0.8,0.1,1.8,0.3,1.8c2,0.4,1.6,2.2,2.2,3.4c0.9,1.8,1.6,3.6,2.4,5.4c0.1-0.3,0.2-0.5,0.3-0.8 c-0.7-1.8-1.4-3.6-2.1-5.4c0.1-0.1,0.3-0.1,0.4-0.2c0.7,1.4,1.5,2.8,2.3,4.3c0.2-0.4,0.4-0.7,0.6-1.1c-0.3-1.2-0.5-2.4-0.8-3.5 c0.1,0,0.2-0.1,0.3-0.1c0.5,0.7,1.1,1.4,1.6,2.2c0.1-0.1,0.3-0.3,0.4-0.4c-0.4-1.5-0.9-3-1.3-4.7c0.8,0.9,1.4,1.8,2.4,3 c-0.4-1.3-0.7-2.1-0.9-2.9c1.1,1.2,1.8,2.6,2.7,3.9c4.1,1.9,7.6,5.4,10.2,9c-1-2.1-1.9-4.2-0.9-7.1c0.5,0.8,1,1.4,1.4,2.1 c0.1-0.1,0.2-0.1,0.3-0.2c-0.6-1.2-1.2-2.3-1.9-3.5c0.2-0.1,0.4-0.2,0.6-0.2c1.1,1.4,2.3,2.7,3.4,4.1c0.1-0.1,0.2-0.1,0.2-0.2 c-0.6-1-1.3-2-1.9-2.9c0.1,0,0.2-0.1,0.2-0.1c0.4,0.3,0.8,0.6,1.3,0.9c-1.1-2-2.1-3.9-3.3-6c0.6,0.3,0.9,0.5,1.2,0.6 c-0.6-1.2-1.1-2.3-1.7-3.5c0.2-0.1,0.3-0.2,0.5-0.3c1.2,1.2,2.5,2.3,3.7,3.5c-0.8-1.5-1.9-2.7-2.9-4c-0.4-0.5-0.8-1-0.8-1.5 c0-2.1,0.1-4.3,0.3-6.9c0.3,0.8,0.4,1.2,0.6,1.7c0.1-0.6,0.2-0.9,0.4-1.6c0.5,2.7,0.8,4.9,1.2,7.1c0.1,0,0.2,0,0.3,0 c-0.3-3.2-0.6-6.5-0.9-9.7c0.1,0,0.1,0,0.2,0c0.3,0.9,0.5,1.9,0.8,2.8c0.1,0,0.2,0,0.3,0c-0.4-3.2-0.8-6.3-1.2-9.5 c0.1,0,0.2,0,0.3-0.1c0.9,3.6,1.8,7.2,2.6,10.8c0.1,0,0.2,0,0.2,0c-0.3-1.7-0.5-3.4-0.8-5.1c0.1,0,0.1,0,0.2,0 c0.4,1,0.7,1.9,1.1,2.9c0.1,0,0.2,0,0.3-0.1c-0.3-1.9-0.6-3.9-0.9-5.8c0.1,0,0.2,0,0.3-0.1c0.6,2.2,1.2,4.4,1.9,6.7 c0.1,0,0.1,0,0.2,0c-0.1-0.8-0.2-1.7-0.3-2.5c0.1,0,0.2,0,0.2,0c0.2,0.5,0.5,1.1,0.9,2c-0.1-1.3-0.2-2.3-0.3-3.2c0.1,0,0.1,0,0.2,0 c0.4,0.9,0.7,1.8,1.2,3c0.1-0.8,0.1-1.2,0.2-1.6c1.8,1.4,1.5,2.7,0.2,4.2c-0.8,0.9-1.5,2-2.2,3c0.1,0.1,0.2,0.1,0.3,0.2 c2-2.1,4-4.2,6-6.4c0.1,0.1,0.1,0.1,0.2,0.2c-2.9,4.1-5.8,8.1-8.7,12.2c3.7-4.5,7.2-9.2,12.1-12.6c-2.6,3.9-5.4,7.7-8,11.6 c-1.3,1.9-2.1,4.1-3.1,6.2c0.1,0,0.1,0.1,0.2,0.1c3.4-3.9,6.8-7.9,10.3-11.8c-1.2,2.3-2.6,4.3-4.1,6.4c-3.4,4.8-3.4,4.8-3.3,6.7 c2.1-2.3,4.2-4.6,6.2-6.9c0.1,0.1,0.2,0.2,0.3,0.3c-1.8,2.5-3.5,4.9-5.3,7.4c0.1,0.1,0.2,0.1,0.3,0.2c2.9-3.4,5.8-6.9,8.7-10.3 c0.1,0.1,0.3,0.2,0.4,0.3c-2.6,4.3-5.2,8.6-7.8,12.9c0.1,0.1,0.2,0.1,0.3,0.2c0.7-0.8,1.3-1.6,2-2.3c0.1,0.1,0.1,0.1,0.2,0.2 c-0.8,1.3-1.6,2.6-2.3,3.9c0.1,0.1,0.2,0.1,0.3,0.2c2.9-4,5.7-8,8.6-12c0.1,0.1,0.3,0.1,0.4,0.2c-2.2,4.3-4.4,8.6-6.5,12.9 c0.1,0.1,0.3,0.2,0.4,0.2c2.2-3.8,4.4-7.5,6.6-11.3c0.1,0,0.2,0.1,0.3,0.1c-1.1,3.3-2.2,6.6-3.4,9.9c0.1,0,0.2,0.1,0.3,0.1 c1.8-4.1,3.6-8.3,5.4-12.5c1.7,2.4-1.1,3.9-0.9,6.1c0.5-0.6,0.9-1.1,1.3-1.7c0.1,0.1,0.2,0.1,0.3,0.2c-2.4,4.8-4.8,9.5-7.2,14.3 c0.1,0,0.2,0.1,0.3,0.1c1.4-2.3,2.8-4.7,4.2-7c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,1.4-1.4,2.9-2.1,4.3c0.1,0,0.2,0.1,0.3,0.1 c0.9-1.5,1.7-3,2.6-4.5c0.2,0.1,0.3,0.1,0.5,0.2c-0.4,1.8-0.8,3.5-1.2,5.5c0.5-0.8,0.9-1.4,1.1-1.9c0.4,0.3,0.7,0.6,1.1,0.9 c-0.6,1.3-1.2,2.7-1.8,4c0.1,0,0.2,0.1,0.3,0.1c1.5-2.5,3-5.1,4.6-7.6c0.1,0.1,0.2,0.1,0.4,0.2c-1.1,2.5-2.2,4.9-3.2,7.4 c0.1,0,0.1,0.1,0.2,0.1c0.6-0.9,1.3-1.7,1.9-2.6c0.1,0.1,0.2,0.1,0.3,0.2c-1.1,2.1-2.2,4.3-3.4,6.5c1.3-1.3,2.5-2.5,3.7-3.6 c0.1,0.1,0.3,0.2,0.4,0.3c-0.4,0.8-0.8,1.6-1.2,2.3c0.1,0,0.1,0.1,0.2,0.1c0.4-0.5,0.8-0.9,1.2-1.4c0.1,0.1,0.2,0.1,0.2,0.2 c-0.6,1.2-1.1,2.3-1.7,3.5c0.1,0,0.2,0.1,0.3,0.1c0.5-0.7,1-1.4,1.7-2.3c-0.2,1.7-0.4,3.2-0.6,4.8c0.5-0.6,0.9-1.1,1.4-1.6 c0.1,0.1,0.3,0.2,0.4,0.2c-1,1.9-2,3.7-3.1,5.9c0.6-0.4,0.8-0.6,1.5-1.1c-0.6,1.2-1,1.9-1.4,2.6c0.1,0.1,0.2,0.1,0.3,0.2 c0.8-1.1,1.6-2.1,2.3-3.2c0.1,0,0.2,0.1,0.3,0.1c-1.2,3.1-2.4,6.1-3.8,9.6c1-1.5,1.8-2.6,2.8-4c-0.8,2.6-1.4,4.8-2.1,6.8 c2.9,0.4,0,3,1.6,3.9c2.8-6,3.2-12.6,4.3-19.4c0.4,0.8,0.7,1.3,1,1.7c1.4-16.9-3.2-32.5-11.4-47c3.4-2.9,6.4-5.6,9.5-8.2 c0.1,0.1,0.2,0.2,0.2,0.3c-1.4,1.5-2.9,3.1-4.3,4.6c0.1,0.1,0.1,0.1,0.2,0.2c1.3-1.2,2.7-2.4,4-3.6c0,0.1,0.1,0.1,0.1,0.2 c-0.6,0.7-1.2,1.5-1.8,2.2c0.1,0.1,0.2,0.2,0.3,0.2c1.9-1.7,3.8-3.5,5.6-5.2c0.1,0.1,0.2,0.2,0.2,0.2c-1.3,1.6-2.6,3.1-3.9,4.7 c0.1,0.1,0.2,0.2,0.3,0.3c0.8-0.7,1.5-1.5,2.3-2.2c0.1,0.1,0.1,0.1,0.2,0.2c-1.3,1.6-2.6,3.3-3.9,4.9c0.1,0.1,0.2,0.1,0.2,0.2 c1.8-2,3.7-4,5.5-6c0.1,0.1,0.2,0.2,0.3,0.3c-0.8,1.2-1.7,2.4-2.5,3.6c0.1,0,0.1,0.1,0.2,0.1c0.4-0.4,0.8-0.7,1.2-1.1 c0.1,0.1,0.1,0.1,0.2,0.2c-0.6,1-1.2,2.1-1.7,3.1c0.2,0.1,0.4,0.3,0.5,0.4c0.8-0.9,1.6-1.9,2.6-2.7c0.7-0.6,1.6-1,2.5-1.5 c0.1,0.1,0.2,0.3,0.3,0.4c-1.1,1.7-2.2,3.3-3.2,5c0.1,0.1,0.2,0.1,0.3,0.2c1.8-2.4,3.6-4.8,5.4-7.2c0.1,0.1,0.3,0.2,0.4,0.3 c-1.2,2.5-2.5,5-3.7,7.5c0.1,0.1,0.2,0.1,0.3,0.2c1.1-1.8,2.3-3.7,3.4-5.5c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,1.6-1.4,3.2-2,4.8 c0.1,0,0.2,0.1,0.2,0.1c0.9-1.6,1.7-3.1,2.6-4.7c0.1,0.1,0.3,0.1,0.4,0.2c-1.4,3.6-2.8,7.1-4.2,10.7c0.1,0,0.2,0.1,0.3,0.1 c2.1-4.5,4.2-9.1,6.2-13.6c0.1,0.1,0.3,0.1,0.4,0.2c-0.5,2.6-0.9,5.2-1.5,8.2c0.8-0.9,1.2-1.4,1.8-2.1c-0.1,1.4-0.3,2.5-0.4,3.6 c0.1,0,0.2,0,0.3,0c0.5-1.7,0.9-3.4,1.5-5.5c0.2,0.8,0.2,1.2,0.4,1.8c0.3-1.1,0.5-1.9,0.8-2.8c0.8,3.3,1.5,6.4,2.4,9.9 c0.2-0.9,0.3-1.4,0.5-2.5c0.6,1.1,0.9,1.8,1.4,2.8c0.3-1,0.4-1.7,0.7-2.7c0.2,2.1,0.4,3.9,0.7,5.9c0.3-1.8,0.5-3.3,0.8-4.8 c0.1,0,0.2,0,0.3,0c0,0.9,0,1.8,0,2.7c0.1,0,0.1,0,0.2,0c0.1-0.5,0.2-1,0.4-1.8c0.3,1.5,0.5,2.7,0.7,4.2c0.3-1.3,0.6-2.2,0.8-3.2 c0.1,0,0.2,0,0.3,0c-0.1,1.4-0.3,2.7-0.4,4.3c0.3-0.4,0.4-0.6,0.7-1c0.1,0.6,0.2,1.1,0.4,2c0.7-1.4,1.2-2.3,1.6-3.1 c1.2,2.3-0.9,5.5,1.7,8c0.4-1,0.7-1.9,1.1-3c0.6,3,1.2,5.7,1.8,8.5c0.1,0,0.2,0,0.2-0.1c0.1-0.5,0.2-1,0.3-2c0.3,1,0.4,1.5,0.6,2 c0.1,0,0.2,0,0.3,0c0.1-1.5,0.2-3,0.3-4.5c0.1,0,0.1,0,0.2,0c0.1,1.9,0.3,3.9,0.4,5.8c0.2,0.1,0.5,0.1,0.7,0.2 c0.9-2.1,1.8-4.3,2.7-6.6c0.1,1.2,0,2.1,0.2,3c0.4,1.6,0.9,3.2,1.2,4.5c0.2-0.5,0.6-1.5,1.3-2.9c0.2,1.6-0.7,3.4,1.2,3.5 c0.5-0.7,0.9-1.3,1.3-2c0.1,0,0.3,0.1,0.4,0.1c0,1.1,0,2.2,0,3.4c0.1,0,0.3,0,0.4,0c0.2-0.3,0.3-0.5,0.4-0.7c0.3,0.9,0.7,1.7,1,2.6 c0.1,0,0.2-0.1,0.4-0.1c0-0.4,0-0.8-0.1-1.2c0.4,0.7,0.3,1.5,0.4,2.3c0.1,0.6,0.1,1.5,0.5,1.7c0.7,0.3,1.6,0.3,2.5,0.4 c0,0.6-0.1,1.7-0.1,2.7c0.1,0,0.3,0,0.4,0c0.3-0.7,0.5-1.3,0.8-2.2c0.6,1.5,1.2,2.9,1.9,4.6c-0.3-1.5-0.6-2.8-0.8-4 c0.1,0,0.3-0.1,0.4-0.1c0.7,2.1,1.4,4.3,2.1,6.4c0.3-0.4,0.5-0.7,0.9-1.3c0.1,1.6,0.2,2.9,0.3,4.3c0.1-1.6,0.2-3,0.3-4.4 c0.1,0,0.2,0,0.3,0c0.6,1.8,1.2,3.6,1.8,5.5c0.1,0,0.1,0,0.2,0c-0.3-1.4-0.5-2.7-0.8-4.1c0.1,0,0.2-0.1,0.3-0.1 c0.5,1,1.1,1.9,1.8,3.2c-0.8-2.7-1.5-5-2-7.3c-0.1-0.4,0.4-1,0.8-1.9c-1.2-3.6-5.2-6.3-5.7-11c2.9,2.9,5.8,5.8,8.7,8.7 c0.1-0.1,0.2-0.1,0.3-0.2c-1.2-1.4-2.4-2.8-3.6-4.2c0.2-0.1,0.3-0.3,0.5-0.4c1.2,1.4,2.4,2.7,3.6,4.1c0.1-0.1,0.1-0.1,0.2-0.2 c-1.3-1.9-2.6-3.7-3.9-5.6c0.1-0.1,0.3-0.3,0.4-0.4c1.2,0.9,2.4,1.7,3.6,2.6c0.1-0.1,0.1-0.2,0.2-0.3c-1.3-1.2-2.6-2.3-3.6-3.2 c0.3-0.8,0.4-1.3,0.6-1.8c0.7,0.3,1.5,0.5,2.2,0.8c-4-2.2-3.7-6.8-6.2-9.7c0.2-0.2,0.4-0.3,0.5-0.5c0.8,1,1.7,2,2.5,3 c0.1-0.1,0.3-0.3,0.4-0.4c-3.4-3.4-6.9-6.8-10.3-10.2c0.1-0.1,0.1-0.2,0.2-0.3c3.3,1.6,6.6,3.3,9.9,4.9c0.1-0.1,0.1-0.2,0.2-0.3 c-2.4-1.4-4.8-2.8-7.3-4.2c0-0.1,0.1-0.2,0.1-0.3c2,0.8,3.9,1.7,5.9,2.5c0.1-0.2,0.2-0.4,0.2-0.5c-2.8-1.3-5.6-2.9-8.6-3.9 c-4.7-1.5-7-5.5-10.2-8.7c1.2,1,2.3,2,3.5,3c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-1-0.4-2-0.5-2.9c0.9,0.8,2,1.7,3,2.5 c0.1-0.1,0.3-0.3,0.4-0.4c-1.1-1.3-2-2.7-3.2-3.8c-2.9-2.4-5.9-4.7-8.8-7.1c-0.7-0.6-1.3-1.4-1.9-2c0.1-0.1,0.2-0.2,0.3-0.4 c3.6,2.3,7.2,4.6,10.8,6.9c-3.4-2.9-7.1-5.3-10.8-7.8c-0.6-0.4-1.1-1.1-1.6-1.6c0.1-0.1,0.2-0.2,0.4-0.3c0.6,0.3,1.1,0.5,1.7,0.8 c0-0.1,0.1-0.1,0.1-0.2c-1.5-1.3-3-2.7-4.4-4c0.1-0.2,0.3-0.4,0.4-0.6c2,1.3,4,2.7,6.1,4.1c-0.4-0.6-0.8-1.1-1.5-2 c3.2,1.6,5.8,2.9,8.4,4.2c-3.7-2.8-8-4.5-11.8-7.1c-0.1,0.2-0.2,0.5-0.3,0.7c-2.1-0.8-4.2-1.7-6.2-2.5c0.1-0.2,0.1-0.4,0.2-0.6 c2.1,0.8,4.2,1.5,6.2,2.3c-0.7-0.4-1.3-0.9-1.9-1.4c-2-1.5-5.2-1.3-7.9-2c-1.2-0.3-2.6-0.6-3.4-1.3c-3.3-3.1-6.5-6.4-9.7-9.5 c-0.8-0.7-1.2-1.2-0.9-2.4c0.5-2.3,0.1-4.4-2-5.7c-1.5-0.9-2-2.2-2.2-3.8c-0.3-2-0.7-3.9-1.2-6c0.3,0.5,0.6,0.8,0.9,1.2 c0.1-0.4,0.2-0.6,0.4-1.3c0.6,2.6,1.1,4.7,1.6,6.7c0.1,0,0.1,0,0.2,0c-0.4-2.5-0.8-5-1.2-7.5c0.2,0,0.3-0.1,0.5-0.1 c0.6,2.6,1.2,5.3,1.7,7.9c0.1,0,0.1,0,0.2,0c0-2.2,0-4.4,0-6.5c0.1,0,0.2-0.1,0.3-0.1c0.7,2,1.3,3.9,2,5.8c0-0.6,0.1-1.3,0.1-2.1 c0.3,0.4,0.6,0.7,1,1.3c0.1-1.3,0.1-2.2,0.2-3.6c0.6,1.7,1,3,1.3,4.2c0.2,0,0.4,0,0.6,0c0.2-1.5,0.3-3.1,0.5-4.5 c0.7,0.9,1.4,1.9,2.2,2.8c0-1.3,0-2.5,0-3.8c2.6,2.7,2.5,6.3,4.2,9.9c-0.7-3.8-1.3-7-1.8-10.2c0.2,0,0.3-0.1,0.5-0.1 c0.2,0.5,0.5,1,0.7,1.5c0.2,0,0.3-0.1,0.5-0.1c-0.5-2-0.9-4-1.4-6.3c0.5,0.6,0.7,1,1.3,1.7c-1-3.1-1-3.1,0.4-3.7 c1.3,2.7,2.7,5.4,3.8,8.2c1.1,2.8,1.7,5.7,2.6,8.5c0.1,0,0.3-0.1,0.4-0.1c-1.2-4.4-2.4-8.9-3.5-13c2.4,2.8,3.2,7.1,5.9,10.1 c0.2-0.1,0.4-0.2,0.7-0.3c-1-2.5-2-5-3.1-7.5c0.1,0,0.2-0.1,0.3-0.1c1.3,2.1,2.6,4.1,3.9,6.2c0.2-0.1,0.4-0.2,0.6-0.3 c-1.1-2.2-2.1-4.4-3.2-6.6c0.1-0.1,0.2-0.1,0.3-0.2c1,1.5,2,3.1,3,4.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.4-0.9-0.8-1.7-1.2-2.6 c0.1,0,0.2-0.1,0.3-0.1c1.3,1.8,2.5,3.7,3.8,5.5c0.1,0,0.2-0.1,0.3-0.1c-0.6-1.4-1.3-2.7-2.1-4.5c1.5,1.7,2.6,3,3.8,4.3 c0.2-0.1,0.3-0.1,0.5-0.2c-1.8-2.1,0.8-2.8,1-4.6c0.7,2.2,1.3,4,2.1,6.2c0.2-1.7,0.4-2.9,0.7-4.6c0.4,1.6,0.6,2.7,0.9,3.8 c0.1-0.3,0.2-0.6,0.4-1.3c0.7,1.3,1.3,2.3,1.8,3.3c0.2-0.5,0.4-0.9,0.7-1.3c0.2-0.4,0.6-0.7,0.9-1c0.1,0.5,0.4,0.9,0.4,1.4 c0.1,1.3,0,2.6,0,3.9c0.2-0.1,0.5-0.2,0.7-0.3c1,1.4,2.1,2.7,3,3.9c0,0,0,0,0,0c0-0.1,0.1-0.2,0.1-0.3c0,0,0.1,0,0.3,0.1 c-0.1,1.3-0.2,2.6-0.4,3.9c0.1,0,0.2,0,0.3,0c0.3-2.1,0.5-4.3,0.8-6.4c0.1,0,0.2,0,0.4,0c0.2,1.8,0.3,3.6,0.5,5.4 c0.1-1.4,0.3-2.8,0.5-4.6c0.7,1.7,1.2,3,1.7,4.3c0.1,0,0.1,0,0.2,0c-0.2-1-0.4-2-0.7-3c1-0.1,1-0.1,0-4.9c1,1.7,1.7,3,2.5,4.3 c0.1,0,0.1-0.1,0.2-0.1c-0.4-1.1-0.7-2.1-1.1-3.1c0.5-0.2,1-0.5,1.4-0.7c-0.4-0.7-0.7-1.3-1.2-2.1c0.7,0.1,1.2,0.1,2.1,0.2 c-1.1-1.4-2-2.5-2.8-3.6c0.1-0.1,0.2-0.2,0.3-0.2c0.9,0.8,1.8,1.6,2.8,2.5c0.2-0.2,0.3-0.4,0.5-0.6c-1.6-1.5-3.2-2.9-4.8-4.4 c0-0.1,0.1-0.1,0.1-0.2c0.6,0.4,1.2,0.7,1.9,1.2c0-0.3,0.1-0.5,0.1-0.7c0-0.2-0.1-0.4-0.3-0.9c1.9,0.5,3.4,0.9,5.4,1.4 c-2.6-1.6-4.8-3-7.1-4.4c0-0.1,0.1-0.2,0.1-0.3c2.2,0.7,4.4,1.5,6.6,2.2c0.1-0.1,0.1-0.2,0.2-0.4c-2.3-1.2-4.5-2.4-6.8-3.6 c0-0.1,0.1-0.2,0.1-0.3c1.2,0.4,2.5,0.8,3.7,1.2c0-0.1,0.1-0.2,0.1-0.3c-2.1-0.9-4.1-1.7-6.2-2.6c0-0.1,0.1-0.2,0.1-0.3 c2.7,0.8,5.4,1.6,8.1,2.5c0-0.1,0.1-0.2,0.1-0.3c-0.9-0.4-1.7-0.8-2.6-1.1c0-0.1,0.1-0.2,0.1-0.2c1.1,0.3,2.1,0.5,3.2,0.8 c0-0.1,0.1-0.2,0.1-0.3c-2.8-1-5.7-2-8.5-3.1c0-0.1,0.1-0.2,0.1-0.4c3.6,1.2,7.3,2.4,10.9,3.6c0-0.1,0.1-0.3,0.1-0.4 c-2.6-1-5.1-2-7.7-2.9c0-0.1,0-0.2,0.1-0.3c1.9,0.4,3.8,0.8,5.6,1.3c0-0.1,0.1-0.2,0.1-0.3c-1.9-0.6-3.8-1.2-5.7-1.8 c0-0.1,0-0.2,0.1-0.3c1.9,0.4,3.9,0.8,5.8,1.1c0-0.1,0.1-0.3,0.1-0.4c-4.2-1-8.3-2-12.5-3c0.1-0.3,0.1-0.5,0.2-0.8 c1.7,0.3,3.4,0.7,5.1,1c0-0.1,0-0.2,0.1-0.2c-1.8-0.6-3.6-1.2-5.4-1.8c0.1-0.2,0.1-0.4,0.2-0.6c0.8,0.2,1.6,0.4,2.9,0.7 c-1.7-1.1-3.6-1.2-3.4-3.4c0-0.1-1-0.5-1.6-0.5c-2.5,0.2-4.6-0.7-5.2-1.9c-1.1-0.4-2-0.5-2.7-1.1c-0.9-0.8-1.5-0.7-2.5-0.2 c-0.9,0.5-2.4,1.2-3,0.8c-1.5-1.1-2.3,0-3.3,0.6c-0.5,0.3-1.3,1-1.5,0.9c-1.6-1.1-2.3,0.4-3.3,1c-1.5,0.8-2.8,1.8-4.2,2.7 c-10.2,6.4-20.5,12.8-30.7,19.3c-0.8,0.5-1.5,1-2.4,1.5c-0.8-1.8-1.5-3.3-2.2-4.9c0.1-0.1,0.2-0.1,0.3-0.2c0.4,0.6,0.9,1.2,1.3,1.8 c-0.5-1.7-0.9-3.5-1.4-5.2c0.1-0.1,0.3-0.1,0.4-0.2c0.7,0.9,1.5,1.9,2.2,2.9c-0.1-0.7-0.2-1.2-0.3-1.9c0.7,0.3,1.1,0.5,1.8,0.8 c-0.2-0.6-0.3-1.2-0.6-2.1c0.7,0.6,1.1,1,1.5,1.3c0.1-0.1,0.1-0.1,0.2-0.2c-0.6-1-1.3-1.9-1.9-2.9c0.1-0.1,0.2-0.1,0.3-0.2 c1.5,1.7,3,3.4,4.5,5.1c0.1-0.1,0.2-0.1,0.2-0.2c-0.6-1-1.2-1.9-1.9-2.9c0.7,0.3,1.1,0.7,1.6,1.1c0.4,0.4,0.8,0.7,1.2,1 c-1.2-1.9-2.4-3.8-3.5-5.7c0.1-0.1,0.2-0.1,0.3-0.2c0.9,0.5,1.7,1.1,2.6,1.6c0.1-0.1,0.2-0.3,0.3-0.4c-1.6-2-3.2-4-4.9-6 c0.1-0.1,0.2-0.2,0.3-0.3c1.4,1,2.8,2.1,4.2,3.1c0.2-0.2,0.4-0.5,0.6-0.7c-1.3-0.9-2.6-1.9-3.9-2.8c0.3-0.3,0.6-0.7,0.9-1 c2.8,1.3,3.7,5.2,7,5.7c-0.8-1.4-1.7-2.8-2.5-4.3c0.3-0.2,0.5-0.3,0.8-0.5c1.4,1.8,2.7,3.7,4.1,5.5c0.1-0.1,0.2-0.1,0.3-0.2 c-1.1-1.9-2.2-3.7-3.5-5.9c0.7,0.4,1,0.6,1.6,1c-0.8-1.2-1.3-1.9-1.9-2.7c0.1-0.1,0.2-0.1,0.2-0.2c1.4,1.2,2.9,2.5,4.4,3.8 c-0.8-1.5-1.5-2.8-2.4-4.5c1.9,0.8,3.4,1.5,5,2.2c-2.3-1.7-5.2-2.6-6.1-5.8c2.5,1.5,4.9,3,7.4,4.6c0.1-0.1,0.1-0.2,0.2-0.3 c-1.4-1-2.7-2-4.1-3c0.1-0.1,0.1-0.2,0.2-0.3c1.7,0.9,3.4,1.8,5.1,2.7c0.1-0.2,0.2-0.3,0.2-0.5c-2.8-1.5-5.6-3-8.5-4.6 c2-0.7,3.8-1.3,5.7-1.9c0-0.1,0-0.2-0.1-0.3c-1.3,0.3-2.7,0.6-4,0.9c0-0.2-0.1-0.3-0.1-0.5c4.5-1.4,9-2.9,13.5-4.3 c0-0.1-0.1-0.2-0.1-0.3c-3.6,0.9-7.2,1.8-10.8,2.6c0-0.1,0-0.1-0.1-0.2c0.9-0.5,1.9-1,2.8-1.5c0-0.1-0.1-0.1-0.1-0.2 c-1.1,0.4-2.2,0.8-3.3,1.1c-0.1-0.1-0.2-0.3-0.3-0.4c0.7-0.6,1.4-1.5,2.2-1.9c3.7-1.7,7.5-3.3,11.6-5c-1.1,0.2-1.9,0.3-2.7,0.4 c0-0.1,0-0.2-0.1-0.3c1.6-0.5,3.3-1,4.9-1.5c-0.4-0.1-0.8-0.2-1.4-0.4c4-1.1,7.8-2,11.1-2.9c-0.7-0.1-1.9-0.3-3.7-0.6 c1-0.3,1.4-0.4,1.6-0.5c-1.1-0.1-2.4-0.2-3.7-0.3c0-0.1,0-0.1,0-0.2c2.5-0.3,5-0.5,7.6-0.8c0,0,0-0.1,0-0.1c-1.7,0-3.3,0-5,0 c0-0.1,0-0.2,0-0.3c2-0.3,4-0.6,5.5-0.8c-0.8,0-2.2-0.1-3.5-0.2c0-0.1,0-0.2,0-0.3c3.5-0.2,7.1-0.5,10.6-0.7c0-1.1,0.2-2.1,2.2-1.6 c1.6,0.4,3.2,0.5,4.8,0.7c-0.4-0.4-0.8-0.7-1.2-1.1c0-0.1,0.1-0.2,0.1-0.3c1.3,0.4,2.7,0.8,4,1.3c0-0.1,0.1-0.2,0.1-0.2 c-0.4-0.2-0.9-0.5-1.4-0.8c0.5-0.1,0.9-0.2,1.2-0.3c-1.9-0.8-3.7-1.5-5.2-2.1c0.1-0.3,0.2-0.8,0.2-0.8c-1.8-0.7-3.6-1.9-5.2-1.8 c-2.3,0.3-2.6-1.7-3.9-2.4c-0.4,0-0.8,0-1.3,0c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.4-0.3 c-1.1,0.5-2.3,1-3.9,1.7c1.3-1.1,2.2-1.9,3-2.7c0-0.1-0.1-0.2-0.1-0.2c-1.6,0.7-3.2,1.3-5,2c0.4-0.6,0.7-1.1,1-1.6 c-0.1,0-0.1-0.1-0.2-0.1c-1.2,1.1-2.4,2.1-3.7,3.2c-0.1-0.1-0.1-0.1-0.2-0.2c0.4-0.6,0.9-1.2,1.3-1.9c0,0-0.1-0.1-0.1-0.1 c-2.6,2.5-5.3,4.9-7.9,7.4c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.7,0.7-1.5,1.2-2.6c-2.2,2.4-3.9,5.1-6.2,6.5c-2.2,1.3-3,3.3-4.4,5 c-3,3.8-6.1,7.5-8.9,11.5c-3,4.1-7,5.9-11.9,6.3c1.2-1,2.4-2.1,3.7-3.2c-0.4-0.2-0.6-0.3-0.9-0.4c1-0.5,1.9-1,2.8-1.5 c0-0.1-0.1-0.2-0.1-0.3c-2.4,1-4.7,2-7.1,3c-0.1-0.2-0.1-0.3-0.2-0.5c3.1-1.6,6.2-3.1,9.4-4.7c0-0.1-0.1-0.2-0.1-0.3 c-1.9,0.8-3.9,1.6-5.8,2.4c0-0.1-0.1-0.1-0.1-0.2c0.4-0.4,0.8-0.7,1.4-1.2c-0.5,0.1-0.9,0.2-1.5,0.3c2.1-1.7,4-3.3,5.9-4.9 c-0.1-0.1-0.2-0.2-0.2-0.3c-1.5,0.8-3,1.6-4.5,2.4c-0.1-0.1-0.1-0.2-0.2-0.3c2.3-1.5,4.6-3,6.8-4.4c-0.1-0.2-0.2-0.5-0.3-0.7 c-2.1,0.9-4.2,1.9-6.6,3c1.7-1.7,4-2.2,5-4c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5,0.1-1.1,0.3-1.6,0.4c0-0.1-0.1-0.1-0.1-0.2 c1-0.6,1.9-1.3,2.9-1.9c-0.1-0.2-0.2-0.4-0.3-0.5c-3.3,1.3-6.7,2.6-10,3.8c0-0.1-0.1-0.2-0.1-0.2c2.2-1.2,4.5-2.3,6.7-3.5 c0-0.1-0.1-0.2-0.1-0.3c-3,1.4-6,2.8-9.1,4.1c-0.1-0.2-0.1-0.3-0.2-0.5c3.7-1.9,7.4-3.9,11.1-5.8c0-0.1-0.1-0.2-0.1-0.3 c-2.5,1.1-4.9,2.2-7.4,3.2c0-0.1-0.1-0.1-0.1-0.2c1-0.6,1.9-1.3,2.9-1.9c-0.1-0.1-0.1-0.2-0.2-0.3c-2,1-4,2-5.9,2.9 c0-0.1-0.1-0.1-0.1-0.2c2.1-1.8,4.2-3.5,6.4-5.3c-2.2-2.3,0.8-2.5,1.1-4.1c-2.3,1-4.5,2-6.6,2.9c-0.1-0.1-0.2-0.2-0.3-0.3 c1.2-1.1,2.3-2.3,3.5-3.4c-0.1-0.1-0.1-0.1-0.2-0.2c-2.2,1.8-4.3,3.6-6.5,5.4c-0.1-0.2-0.2-0.3-0.4-0.5c1.6-1.5,3.2-3,4.7-4.5 c0.5-0.5,0.6-1.3,0.9-1.9c0,0,0,0,0,0c0.1-0.6,0.2-1.2,0.4-1.8l0.1,0c-0.1-0.1-0.3-0.3-0.4-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4c0.1-0.1,0.2-0.2,0.4-0.4c0-0.1,0.1-0.2,0-0.4 c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.4c0.1-0.1,0.2-0.3,0.4-0.4c0-0.1,0-0.2,0-0.4c-0.6,0.3-1.3,0.5-1.9,0.9 c-1.6,1.3-3.1,2.7-4.7,4.1c-0.4-2.5,1.4-3.7,2.7-5.1c1.2-1.4,2.5-2.7,3.8-4.1c-0.2-0.2-0.3-0.3-0.5-0.5c-1.3,1.1-2.6,2.2-4,3.3 c-0.1-0.1-0.1-0.1-0.2-0.2c0.7-0.9,1.3-1.8,2-2.7c-0.1,0-0.1-0.1-0.2-0.1c-0.4,0.3-0.8,0.7-1.2,1c-0.1-0.1-0.3-0.2-0.4-0.3 c0.8-1.3,1.6-2.5,2.4-3.8c-0.3,0.2-0.5,0.3-1.2,0.8c1.7-4.4,3.2-8.3,4.5-12c-0.7-0.4-1.2-0.8-1.8-1.2c-0.2,0.2-0.4,0.6-0.7,0.9 c0.9-1.8,0.1-3.3-1.1-5.3c-0.7,5.6-3.5,9.7-6.7,13.2c0.3-1.3,0.7-2.8,1.1-4.3l0-0.1l-0.1,0c-0.2-0.3-0.4-0.6-0.6-0.9 c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.2-0.2,0.3-0.2c0-0.1,0-0.3,0-0.4c-0.4-0.6-0.9-1.2-1.4-1.9c0.5-1.1,1.2-2.5,1.8-3.8 c-0.1-0.1-0.2-0.1-0.3-0.2c-1.3,2.3-2.6,4.7-3.9,7c-0.1-0.1-0.2-0.1-0.4-0.2c0.8-1.9,1.7-3.8,2.5-5.8c-0.1-0.1-0.3-0.2-0.4-0.2 c-0.8,0.9-1.6,1.8-2.3,2.7c0.3-1.4,0.6-2.9,0.9-4.4c-0.2,0-0.3-0.1-0.5-0.1c-0.8,1.5-1.5,3-2.3,4.6c-0.1,0-0.2-0.1-0.3-0.1 c0.4-1.4,0.8-2.8,1.3-4.1c-0.1,0-0.2-0.1-0.2-0.1c-0.5,0.7-1.1,1.5-1.5,2c-0.3-2.9-0.6-5.8-1-8.8c-0.1,0-0.2,0-0.3,0 c-0.4,1-0.8,2.1-1.1,3.1c-0.1,0-0.2,0-0.3-0.1c0.3-1.7,0.6-3.5,0.9-5.2c0,0-0.1,0-0.1,0c-0.7,1.8-1.3,3.6-2,5.4 c-0.1,0-0.2-0.1-0.3-0.1c0.1-2,0.2-3.9,0.3-5.9c0,0-0.1,0-0.1,0c-0.3,1.5-0.5,3-0.8,4.4c-0.1,0-0.2,0-0.3,0 c-0.1-1.1-0.1-2.2-0.1-2.9c0,0.1-0.1,0.7-0.2,1.2c-0.7-0.6-1.2-1.1-1.5-1.3c-0.3,0.7-0.7,1.3-1.2,2.5c-0.1-1.1-0.2-1.5-0.2-2 c-0.2,0-0.4-0.1-0.6-0.1c-0.7,2.7-1.4,5.4-2,7.9c-0.2-1.6-0.5-3.4-0.7-5.3c-0.1,0-0.2,0-0.3,0c0,1.9,0,3.8,0,6.2 c-0.7-2.8-1.3-5.2-1.8-7.6c-0.1,0-0.2,0-0.3,0.1c0.2,1.7,0.4,3.4,0.6,5.1c-0.1,0-0.2,0-0.3,0.1c-0.5-1.9-1-3.7-1.6-5.9 c-0.1,0.6-0.2,0.8-0.3,1.4c-0.5-1.5-0.8-2.7-1.2-3.9c-0.1,0-0.1,0-0.2,0.1c0.1,0.8,0.2,1.6,0.4,2.4c-0.1,0-0.1,0-0.2,0 c-0.5-1.1-1.1-2.3-1.6-3.4c-0.1,0-0.1,0.1-0.2,0.1c0.4,1.5,0.8,3.1,1.2,4.6c-0.1,0.1-0.2,0.1-0.4,0.2c-1-1.3-1.9-2.6-2.9-3.9 c-0.1,0-0.1,0.1-0.2,0.1c0.6,1.3,1.3,2.5,2,4.1c-1.1-0.7-1.8-1.2-2.9-1.9c1.9,2.2,3.6,4.1,5.2,6c-0.1,0.1-0.3,0.2-0.4,0.4 c-1-0.8-2-1.7-3-2.5c1,1.6,2.1,3.2,3.1,4.9c-0.1,0.1-0.3,0.2-0.4,0.3c-0.5-0.4-1-0.7-2-1.5c0.4,0.8,0.6,1.1,0.9,1.7 c-0.7-0.5-1.2-0.9-1.7-1.3c0.3,1.9,1.1,3.6,1.8,5.3c0.1,0.3,0.1,1-0.1,1.2c-1.1,0.9-0.8,1.9-0.2,2.8c0.6,1.1,1.3,2.2,2,3.3 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7-0.9-1.4-1.8-2.1-2.7c-0.1,0-0.1,0.1-0.2,0.1c0.4,1.1,0.9,2.1,1.4,3.4c-1-0.4-1.7-0.6-2.8-1.1 c1.7,2.1,3.1,3.9,4.4,5.6c-0.1,0.1-0.2,0.1-0.2,0.2c-0.9-0.7-1.7-1.4-2.6-2.1c-0.1,0.1-0.1,0.2-0.2,0.3c0.5,0.6,1,1.3,1.5,1.9 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.7-0.6-1.3-1.2-2-1.8c1.7,3.2,4.6,5.7,4.9,9.8c-1-0.8-1.8-1.4-2.7-2.1c1.8,2.9,1.8,2.9,1.7,6 c-4.8-7-6.2-15.9-11.5-22.8c1.2,2.7,2.4,5.4,3.7,8.2c-0.2,0.1-0.4,0.2-0.6,0.3c-1.4-2.7-2.8-5.5-4.2-8.2c-0.1,0.1-0.2,0.1-0.3,0.2 c0.7,1.6,1.3,3.1,2,4.7c-0.1,0.1-0.2,0.1-0.4,0.2c-0.6-0.9-1.2-1.8-1.8-2.7c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.7,0.5,1.4,0.7,2 c-0.9-0.5-1.7-0.9-3-1.6c1.3,2.7,2.5,4.9,3.6,7.2c-1.7-1.3-3.4-2.5-5.2-3.8c-0.2,0.2-0.4,0.5-0.6,0.7c0.6,0.4,1.3,0.8,1.9,1.2 c-0.1,0.1-0.1,0.1-0.2,0.2c-0.5-0.3-1-0.5-1.4-0.8c0,0.1-0.1,0.1-0.1,0.2c0.6,0.5,1.1,1,2.1,1.9c-1.9-0.8-3.2-1.3-4.6-1.9 c2.1,1.6,4.2,3,6.3,4.4c0.4,0.3,1,0.9,0.9,0.9c-1.4,2.1,0.9,1.9,1.7,2.8c-0.9,0.5-1.9,1-2.9,1.5c0,1.3,0,2.6,0,3.9 c-0.1,0-0.1,0-0.2,0c-0.3-1.4-0.5-2.9-0.8-4.7c-0.1,1.4-0.1,2.4-0.2,3.4c-0.1,0-0.2,0-0.2,0c-0.2-1.3-0.5-2.6-0.7-3.9 c-0.1,0-0.2,0-0.2,0c0,1.5,0,2.9,0,4.4c-0.1,0-0.2,0-0.3,0c-0.4-1.9-0.7-3.8-1.1-5.7c-0.1,0-0.1,0-0.2,0c0,0.5-0.1,1-0.2,2 c-0.3-0.8-0.4-1.1-0.5-1.4c-0.2,0.3-0.3,0.5-0.5,0.8c-0.4-1.5-0.7-2.9-1.1-4.3c-0.1,0-0.2,0-0.3,0c0.4,3,0.8,6,1.3,9.2 c-1.3-3.2-2.5-6.1-3.7-9.1c-0.1,0-0.3,0-0.4,0c0.4,2.4,0.9,4.7,1.3,7.1c-0.1,0-0.1,0-0.2,0c-1.4-4.1-2.8-8.3-4.2-12.4 c-0.2,0-0.3,0.1-0.5,0.1c0.4,1.5,0.8,2.9,1.2,4.4c-0.2,0-0.3,0.1-0.5,0.1c-0.8-1.8-1.6-3.6-2.3-5.4c-0.2,0-0.4,0-0.6,0 c-0.1,0.6-0.3,1.2-0.2,1.8c0.2,1,0.7,1.9,1,2.8c1,3,2,6,2.9,9c-2.1-3.3-2.9-7.2-5.2-10.4c-0.2,0.1-0.3,0.1-0.5,0.2 c0.3,0.9,0.6,1.8,0.9,2.8c-2-2.5-4-5-6.1-7.6c1,2.9,1.9,5.6,2.8,8.4c-0.2,0.1-0.4,0.3-0.6,0.4c-1.7-2.3-3.4-4.7-5.1-7 c0,0-0.1,0-0.1,0c0.9,1.7,1.8,3.3,2.6,5c-0.1,0-0.2,0.1-0.3,0.1c-1.2-1.5-2.3-3-3.5-4.5c-0.1,0.1-0.2,0.2-0.3,0.2 c1.7,2.4,3.3,4.8,5,7.2c-0.1,0.1-0.2,0.1-0.3,0.2c-1.9-2-3.8-4.1-5.6-6.1c-0.2,0.2-0.4,0.3-0.6,0.5c1.1,1.6,2.2,3.2,3.5,5.1 c-3.2-2.4-6-4.5-8.8-6.6c-0.1,0.2-0.2,0.3-0.4,0.5c1.6,1.4,3.2,2.8,4.8,4.2c-0.1,0.2-0.3,0.3-0.4,0.5c-2.1-1.1-4.3-2.2-6.4-3.2 c0,0.1-0.1,0.1-0.1,0.2c1.8,1.2,3.6,2.3,5.2,3.4c-3.6,0-7.1,0-10.1,0c1.2,0.4,3,1.1,5.2,1.9c-4.2,1.1-7.9,2-12,3.1 c1.7-0.1,3-0.1,4-0.2c0.1,0.7,0.1,1.2,0.2,1.7c0.1,0.2,0.3,0.3,0.4,0.5c0,0.1,0,0.3,0,0.4c-0.1,0.1-0.1,0.2-0.1,0.3 c0.1,0.3,0.2,0.7,0.4,1.1c1.9-0.9,3.7-1.8,5.5-2.7c0,0.1,0.1,0.1,0.1,0.2c-1.1,0.8-2.1,1.6-3.2,2.4c0.1,0.2,0.1,0.3,0.2,0.5 c0.8-0.3,1.7-0.5,2.8-0.8c-0.3,0.5-0.4,0.8-0.6,1c3,1.4,5-1.4,8.1-1.8c-1.7,1-3,1.8-4.2,2.6c0,0.2,0.1,0.4,0.1,0.6c2,0,3.9,0,5.7,0 c-0.6,0.3-1.3,0.6-2.1,1c0,0.1,0,0.1,0.1,0.2c2.1-0.5,4.2-1,6.4-1.6c0,0.1,0.1,0.2,0.1,0.3c-2.5,0.9-5,1.8-7.5,2.7 c0,0.1,0,0.2,0.1,0.2c3.7-0.8,7.3-1.6,11-2.4c0,0.1,0,0.2,0.1,0.3c-3.5,1.1-7.1,2.3-10.6,3.4c0,0.1,0.1,0.2,0.1,0.2 c3.1-0.5,6.2-1.1,9.3-1.6c0,0.1,0,0.3,0.1,0.4c-1.8,0.5-3.7,1-5.5,1.5c0,0.1,0,0.2,0.1,0.3c1.3-0.1,2.6-0.3,3.8-0.4 c0,0.1,0,0.2,0,0.3c-1.4,0.4-2.8,0.7-4.2,1.1c0,0.1,0,0.1,0,0.2c2-0.3,4.1-0.6,6.1-0.8c0,0.1,0,0.2,0,0.4c-2.8,0.6-5.7,1.2-8.5,1.8 c0,0.1,0,0.2,0,0.2c2.6-0.3,5.2-0.6,8.3-0.9c-0.6,0.5-0.8,0.6-0.9,0.7c2.5,0,4.9,0,7.9,0c-3.3,0.4-6,0.7-8.7,1.1c0,0,0,0.1,0,0.1 c3.8,0,7.6,0,11.3,0c0,0.1,0,0.1,0,0.2c-4.1,0.4-8.3,0.7-12.4,1.1c0,0.1,0,0.2,0,0.3c4.1,0,8.2,0,12.3,0c0,0,0,0.1,0,0.1 c-5.1,0.4-10.2,0.8-15.3,1.2c0,0.1,0,0.1,0,0.2c4.2,0,8.4,0,12.7,0c0,0.2,0,0.4,0,0.6c-3,0-6.1,0-9.1,0c0,0.3,0,0.5,0,0.8 c4.6,0,9.1,0,13.7,0c0,0.2,0,0.4,0,0.6c-5,0.2-9.9,0.4-14.9,0.7c0,0.1,0,0.1,0,0.2c5,0.2,10,0.4,15,0.6c0,0.1,0,0.1,0,0.2 c-4.8,0.2-9.6,0.5-14,0.7c7.6,0.2,15.6,0.4,23.7,0.7c-7.5,2.4-15.2,2.4-22.9,2.8c2.8,0.2,5.6,0.4,8.4,0.6c0,0.1,0,0.1,0,0.2 c-1.4,0.2-2.8,0.4-4.2,0.6c5.1,0,10.2,0,15.4,0c0,0.1,0,0.2,0,0.3c-4.7,0.6-9.4,1.2-14,1.8c0,0.1,0,0.1,0,0.2c2.6,0,5.3,0,7.9,0 c-3.3,0.6-6.7,0.9-10,1.1c-1,0.1-2.1-0.3-3-0.7c-2.4-1.4-4.7-2.9-7.2-4.5c0.3,1,0.6,1.6,0.8,2.2c-0.8,0-1.6-0.1-2.4-0.1 c0,0.1-0.1,0.2-0.1,0.3c1.4,1,2.8,1.9,4.2,2.9c-0.1,0.1-0.1,0.2-0.2,0.2c-1.7-0.9-3.5-1.7-5.2-2.6c0,0.1-0.1,0.1-0.1,0.2 c0.5,0.3,1,0.7,1.5,1.1c-0.3,0.1-0.5,0.2-0.8,0.4c0.5,0.4,1.1,0.8,1.8,1.4c-1.1-0.3-1.8-0.5-2.6-0.7c0,0.1-0.1,0.2-0.1,0.3 c3,1.4,5.9,2.9,8.9,4.3c0,0.1-0.1,0.2-0.1,0.2c-4.3-1.1-8.5-2.3-12.8-3.4c0,0.2-0.1,0.4-0.1,0.5c2.9,0.9,5.8,1.8,8.7,2.7 c0,0.1-0.1,0.2-0.1,0.3c-2.5-0.4-5.1-0.8-7.6-1.2c0,0.1,0,0.2,0,0.3c2.1,0.5,4.3,1,6.4,1.5c0,0.1,0,0.2-0.1,0.3 c-1.5-0.1-3-0.3-4.5-0.4c0,0,0,0.1,0,0.1c1.4,0.2,2.9,0.5,4.3,0.7c0,0.1,0,0.1,0,0.2c-3.2,0.2-6.4,0.4-9.9,0.7 c3.5,0.2,6.7,0.4,9.8,0.5c0,0.1,0,0.2,0,0.3c-3.2,0.3-6.4,0.7-9.6,1c0,0.1,0,0.2,0,0.3c2.8-0.2,5.7-0.3,8.5-0.5c0,0.1,0,0.3,0,0.4 c-1.3,0.3-2.6,0.7-3.9,1c0,0.1,0,0.2,0.1,0.2c3.2-0.4,6.4-0.8,9.6-1.2c0,0.2,0.1,0.3,0.1,0.5c-2.3,0.9-4.6,1.8-6.8,2.9 c-1.3,0.6-2.3,0.5-3.6-0.2c-3.6-2-7.4-3.9-11.1-5.7c-1.2-0.6-2.4-1-3.6-1.4c0,0.1-0.1,0.2-0.1,0.3c2.9,1.6,5.7,3.1,8.6,4.7 c-0.1,0.1-0.1,0.2-0.2,0.4c-3.4-1.5-6.9-3.1-10.3-4.6c0,0.3,0,0.5,0,0.8c-0.7,0.1-1.4,0.5-2,0.3c-1.9-0.7-3.7-1.5-5.5-2.3 c0,0.1-0.1,0.2-0.1,0.3c3.8,1.9,7.7,3.8,11.5,5.6c-0.1,0.1-0.1,0.3-0.2,0.4c-4.1-1.7-8.2-3.3-12.3-5c0,0.1-0.1,0.2-0.1,0.3 c1.9,0.9,3.8,1.8,6.1,2.9c-4.3-0.8-8.2-1.5-12-2.2c0,0,0,0,0,0.1c5.4,1.4,10.8,2.9,16.2,4.3c-0.1,0.2-0.1,0.4-0.2,0.6 c-6.2-1.3-12.4-2.6-18.6-3.9c0,0.2-0.1,0.3-0.1,0.5c3.4,0.8,6.9,1.6,10.3,2.3c0,0.1,0,0.2-0.1,0.3c-4.4-0.7-8.7-1.4-13.1-2 c0,0.1,0,0.1,0,0.2c3.2,0.6,6.4,1.3,9.6,1.9c0,0.1,0,0.2-0.1,0.3c-3.3-0.3-6.7-0.6-10-0.9c0,0.1,0,0.2,0,0.3c5,0.7,10,1.5,15.1,2.2 c0,0.2,0,0.3,0,0.5c-5.4-0.2-10.9-0.5-16.3-0.7c0,0,0,0.1,0,0.1c0.6,0.1,1.3,0.2,1.9,0.3c0,0.1,0,0.1,0,0.2 c-0.6,0.1-1.2,0.2-1.8,0.3c1.4,0.1,2.8,0.2,4.2,0.2c0,0.1,0,0.1,0,0.2c-1.2,0.1-2.3,0.2-3.5,0.3c0,0.1,0,0.2,0,0.3 c2.1,0,4.2,0,6.3,0c0,0.1,0,0.2,0,0.3c-2.4,0.2-4.8,0.4-7.2,0.6c0,0.1,0,0.1,0,0.2c2.1,0,4.3,0,6.4,0c0,0.1,0,0.2,0,0.3 c-1.2,0.1-2.4,0.2-4.1,0.3c1.1,0.2,1.7,0.3,2.3,0.4c0,0.1,0,0.1,0,0.2c-0.7,0.1-1.5,0.1-2.2,0.2c0,0.1,0,0.2,0,0.3 c0.8,0,1.7,0,2.5,0c0,0.1,0,0.2,0,0.3c-0.4,0.1-0.7,0.2-1.2,0.3c0.4,0.2,0.7,0.3,1.1,0.4c-1.6,0.4-2.9,0.8-4.4,1.3 c0.3,0.7,0.5,1.2,0.7,1.7c-1.2,1.1-2.5,2.2-3.7,3.4c-0.2,0.2,0.1,0.7,0.1,1.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.2-0.4,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.7-0.8,1.4-1.2,2.1c0.7,1.7-1.2,2.5-1.5,3.1c0.2,1.9,0.3,3.3,0.4,4.7 C509.3,112.3,509.7,111.8,510.5,110.9z M550.5,146.2c1.6-1.4,3.3-2.8,5-4.3C555.8,143.4,553.9,145.1,550.5,146.2z M597.1,137.7 c0-1.1,0-1.9,0-2.7c0.2-0.1,0.4-0.2,0.6-0.3c0.5,0.6,1,1.2,1.6,2C598.4,137,597.8,137.3,597.1,137.7z M705.2,164 c1.5,1.7,3,3.5,4.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.3c-1.5-1.8-3-3.5-4.5-5.3C705,164.1,705.1,164.1,705.2,164z M664.1,118.4 c1.5,1.6,3,3.3,4.5,4.9c0,0-0.1,0.1-0.1,0.1c-1.6-1.6-3.1-3.1-4.7-4.7C663.8,118.6,664,118.5,664.1,118.4z M691.2,76.7 c0.4-0.1,1.1,0.5,1.6,0.8c-2.5,0.6-4.5,1-6.5,1.5c0-0.1-0.1-0.2-0.1-0.3C687.8,78,689.5,77.2,691.2,76.7z M654.6,119.4 c0.2,0,0.4,0,0.6,0.1c0.1,0.6,0.5,1.5,0.2,1.8c-0.4,0.4-1.2,0.4-1.9,0.6c-0.1-0.2-0.2-0.3-0.3-0.5 C653.7,120.7,654.1,120,654.6,119.4z M642.1,77.3c0.2,0.3,0.4,0.5,0.6,0.8c-2,1.3-4,2.5-6.1,3.8C637.4,78.9,640.3,78.9,642.1,77.3z  M626.7,108.9c-1.6,0.6-2.5,2.3-4.6,1.4c0.6-1.1,1.1-2.2,1.6-3.3C624.8,107.6,625.6,108.2,626.7,108.9z M618.9,104.7 c1.2-0.4,2.4-0.5,4.3-0.8c-0.9,2.3-1.7,4.3-2.7,6.7c-0.9-1.8-1.7-3.2-2.3-4.6C618.1,105.7,618.5,104.8,618.9,104.7z M605,138.4 c-1.5,0-2.9,0-4.3,0C603,136.3,604.4,136.3,605,138.4z M575.2,81c-0.6,0.1-1.4-0.5-2-0.8c0-0.2,0.1-0.4,0.1-0.6 c4.8-0.4,9.5-0.8,14.3-1.2c0,0.1,0,0.3,0.1,0.4C583.5,79.6,579.4,80.4,575.2,81z M576.4,82.7c0-0.3,0-0.5-0.1-0.8 c2.3-0.5,4.6-1,6.9-1.5C581,81.4,578.9,82.9,576.4,82.7z M578.3,84.1c0-0.3-0.1-0.5-0.1-0.8c2.5-0.5,5.1-1,7.6-1.6 c0.1,0.2,0.1,0.5,0.2,0.7C583.4,82.9,581.1,84.5,578.3,84.1z M586,89.1c0-0.2-0.1-0.3-0.1-0.5c2.2-0.6,4.4-1.2,6.6-1.8 c0.1,0.2,0.1,0.4,0.2,0.6C590.4,87.9,588.2,88.5,586,89.1z M592.5,83.2c-3.5,1.4-6.6,2.6-9.7,3.6c-0.6,0.2-1.5-0.6-2.3-0.9 C584.4,84.4,587.8,82.3,592.5,83.2z M570.6,77.6c6.1,0,12.3,0,18.5,0c-5.3,0.5-10.5,1-15.8,1.4c-0.9,0.1-1.9-0.4-2.8-0.6 C570.5,78.1,570.5,77.9,570.6,77.6z M564.5,85.9c0.2,0.7,0.3,1.1,0.4,1.6c0.5-0.3,1.1-0.7,2-1.3c-0.2,1-0.3,1.6-0.4,2.5 c0.7-1,1.2-1.8,1.7-2.5c0.1,0,0.3,0,0.4,0c0,1.4,0,2.8,0,4.1c0.2-0.4,0.5-0.9,1-1.9c0.2,2.1,0.3,3.6,0.5,5.4 c-3.7-1.2-7.2-2.4-11.1-3.7C560.9,88.6,562.6,87.3,564.5,85.9z M542.3,102.1C542.3,102.1,542.3,102.1,542.3,102.1 C542.4,102.1,542.4,102.1,542.3,102.1C542.3,102.1,542.3,102.1,542.3,102.1z M542.4,101.4c0,0.2,0,0.4,0,0.6 C542.4,101.8,542.4,101.6,542.4,101.4C542.4,101.4,542.4,101.4,542.4,101.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137103246833353630240000008944547814903827391_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.2707,
    y1: 103.2209,
    x2: 541.2707,
    y2: 103.0676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137103246833353630240000008944547814903827391_)"
    },
    d: "M541,103.1c0.1,0,0.3,0.1,0.4,0.1 c0,0,0.1-0.1,0.1-0.1C541.4,103.1,541.2,103.1,541,103.1C541.1,103.1,541,103.1,541,103.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077285555180064968240000005577653649584314297_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.2203,
    y1: 128.7755,
    x2: 683.2203,
    y2: 128.7476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860349,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077285555180064968240000005577653649584314297_)"
    },
    d: "M683.2,128.8 C683.2,128.8,683.2,128.8,683.2,128.8C683.2,128.8,683.2,128.8,683.2,128.8C683.2,128.8,683.2,128.8,683.2,128.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3,161.2h38c5.8,0,11.1,1,16,3.1c4.9,2.1,9.1,4.9,12.6,8.5c3.5,3.6,6.3,7.8,8.4,12.6c2,4.9,3,10,3,15.5 c0,5.5-1,10.7-3,15.6c-2,4.9-4.8,9.1-8.4,12.7c-3.6,3.6-7.8,6.4-12.7,8.5c-4.9,2.1-10.3,3.1-16.1,3.1H34v32H13.3V161.2z M34,180.5 v41.2h15.8c3,0,5.8-0.5,8.4-1.6c2.5-1.1,4.7-2.6,6.5-4.4c1.8-1.9,3.2-4.1,4.3-6.6c1-2.5,1.5-5.2,1.5-8c0-2.9-0.5-5.5-1.5-8 c-1-2.5-2.4-4.7-4.3-6.5c-1.8-1.8-4-3.3-6.5-4.4c-2.5-1.1-5.3-1.6-8.4-1.6H34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,273V161.2h35.6c6.6,0,12.5,0.9,17.6,2.8c5.1,1.9,9.5,4.5,13,8c3.5,3.4,6.3,7.5,8.1,12.3c1.9,4.7,2.8,10,2.8,15.9 c0,6.7-1.6,13-4.8,18.9c-3.2,5.9-7.8,10.4-13.9,13.7l22.2,40.3h-23.6l-17.8-34.2H124V273H103.3z M137,219.7c4.3,0,7.8-0.5,10.7-1.6 s5.2-2.6,7-4.4c1.8-1.9,3-4.1,3.8-6.5c0.8-2.5,1.1-5.1,1.1-7.8c0-5.7-1.8-10.3-5.4-13.6c-3.6-3.4-9.4-5.1-17.3-5.1H124v39.1H137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,161.2h65.9v19.9h-45.2v25.7h45.2v19.9h-45.2v26.3h45.2V273h-65.9V161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.1,273.1c-10,0-18.5-1.9-25.4-5.7c-6.9-3.8-12.9-8.6-18-14.3l18.9-14.3c2.8,4.7,6.3,8.2,10.5,10.7 c4.2,2.5,8.8,3.7,13.8,3.7c5.5,0,9.7-1.5,12.6-4.5s4.3-6.3,4.3-10.1c0-2.3-0.7-4.2-2-5.8c-1.3-1.6-3-3-5.2-4.1 c-2.1-1.1-4.6-2.2-7.4-3c-2.8-0.9-5.7-1.8-8.6-2.7c-3.8-1.2-7.5-2.5-11.3-3.9c-3.8-1.4-7.1-3.2-10.1-5.6c-3-2.3-5.4-5.2-7.3-8.6 c-1.9-3.4-2.8-7.7-2.8-12.9c0-4.4,0.9-8.4,2.7-12.2c1.8-3.8,4.4-7.1,7.7-9.9c3.3-2.8,7.2-5,11.7-6.6c4.5-1.6,9.4-2.4,14.7-2.4 c4.5,0,8.5,0.4,12.1,1.2c3.6,0.8,6.9,1.9,9.9,3.4c3,1.4,5.7,3.1,8.2,5.1c2.5,2,4.8,4.2,7.1,6.5l-17,13.3c-4.8-7.4-11.5-11-20.1-11 c-5.1,0-8.9,1.2-11.6,3.6c-2.6,2.4-4,5.3-4,8.8c0,2.2,0.6,4,1.8,5.5s2.9,2.8,4.9,3.9c2.1,1.1,4.5,2.2,7.2,3.1 c2.7,0.9,5.6,1.8,8.7,2.8c3.8,1.2,7.5,2.6,11.3,4.1c3.8,1.5,7.3,3.5,10.3,6c3.1,2.4,5.6,5.4,7.5,8.9c1.9,3.5,2.9,7.9,2.9,13.2 c0,4.3-0.9,8.4-2.6,12.5c-1.7,4.1-4.2,7.7-7.5,10.8c-3.2,3.1-7.3,5.7-12,7.6C321.6,272.2,316.1,273.1,310.1,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.2,181.1h-29.7v-19.9h80.2v19.9h-29.8V273h-20.7V181.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.4,161.2h20.7V273h-20.7V161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.4,161.2h65.9v19.9h-45.2v25.7h45.2v19.9h-45.2v26.3h45.2V273h-65.9V161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.4,228.7h35.5c-2,7.4-5.8,13.2-11.3,17.6c-5.5,4.4-12.5,6.6-20.8,6.6c-5.4,0-10.3-0.9-14.9-2.8 c-4.6-1.9-8.5-4.4-11.8-7.7c-3.3-3.2-5.9-7-7.7-11.4c-1.8-4.3-2.7-9-2.7-14c0-4.9,0.9-9.5,2.7-13.9c1.8-4.3,4.4-8.1,7.7-11.4 c3.3-3.2,7.2-5.8,11.6-7.7c4.4-1.9,9.2-2.9,14.4-2.9c7.3,0,13.6,1.5,18.9,4.5c3.7,2.1,6.9,4.8,9.7,8.2L576,176 c-3-2.7-6.2-5.1-9.8-7.2c-4.3-2.5-9-4.4-14.1-5.8c-5.1-1.3-10.5-2-16.3-2c-8.2,0-15.8,1.5-22.7,4.4c-6.9,2.9-12.9,6.9-18,12 s-9,11-11.8,17.8c-2.8,6.8-4.3,14.1-4.3,21.9c0,7.6,1.4,14.8,4.1,21.5s6.6,12.7,11.7,17.9c5.1,5.1,11.2,9.2,18.3,12.2 c7.1,3,15,4.5,23.6,4.5c8.3,0,15.8-1.5,22.5-4.5c6.7-3,12.4-7.1,17.1-12.2c4.7-5.1,8.3-11.1,10.9-17.8c2.5-6.8,3.8-14,3.8-21.5 v-8.3h-57.7V228.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109018031099359015700000009647552211041246655_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3674,
    y1: 274.4795,
    x2: 52.3674,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109018031099359015700000009647552211041246655_)"
    },
    d: "M35.5,274.5H11.8V159.7h39.5 c6,0,11.5,1.1,16.6,3.3c5,2.2,9.4,5.1,13.1,8.8c3.7,3.7,6.6,8.1,8.7,13.1c2.1,5,3.2,10.4,3.2,16.1c0,5.7-1.1,11.1-3.2,16.2 c-2.1,5.1-5,9.5-8.7,13.2c-3.7,3.7-8.1,6.7-13.2,8.8c-5.1,2.2-10.7,3.3-16.6,3.3H35.5V274.5z M14.8,271.5h17.7v-32h18.7 c5.6,0,10.8-1,15.5-3c4.7-2,8.8-4.8,12.2-8.2c3.4-3.4,6.1-7.5,8-12.2c1.9-4.7,2.9-9.8,2.9-15c0-5.3-1-10.3-2.9-15 c-1.9-4.6-4.7-8.7-8-12.2c-3.4-3.4-7.5-6.2-12.2-8.2c-4.7-2-9.8-3-15.4-3H14.8V271.5z M49.9,223.2H32.5V179h17.3 c3.2,0,6.2,0.6,9,1.7c2.7,1.1,5.1,2.7,7,4.7c2,2,3.5,4.3,4.6,7c1.1,2.7,1.6,5.6,1.6,8.6c0,3-0.5,5.9-1.6,8.6 c-1.1,2.7-2.6,5-4.6,7.1c-2,2-4.3,3.6-7,4.8C56.1,222.6,53.1,223.2,49.9,223.2z M35.5,220.2h14.3c2.8,0,5.4-0.5,7.8-1.5 c2.3-1,4.4-2.4,6-4.1c1.7-1.7,3-3.8,3.9-6.1c0.9-2.3,1.4-4.8,1.4-7.5c0-2.6-0.5-5.2-1.4-7.5c-0.9-2.3-2.3-4.3-3.9-6 c-1.7-1.7-3.7-3-6.1-4c-2.3-1-5-1.5-7.8-1.5H35.5V220.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104697174508414377330000015553661587151367074_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.1096,
    y1: 274.4795,
    x2: 144.1096,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104697174508414377330000015553661587151367074_)"
    },
    d: "M186.5,274.5h-27l-17.8-34.2h-16.2v34.2 h-23.7V159.7h37.1c6.7,0,12.8,1,18.1,2.9c5.3,2,9.8,4.7,13.5,8.3c3.7,3.6,6.5,7.9,8.5,12.8c1.9,4.9,2.9,10.4,2.9,16.4 c0,7-1.7,13.6-5,19.6c-3.1,5.7-7.5,10.2-13.2,13.6L186.5,274.5z M161.2,271.5h20.1l-21.7-39.4l1.3-0.7c5.8-3.1,10.3-7.5,13.3-13.1 c3.1-5.6,4.6-11.7,4.6-18.2c0-5.6-0.9-10.8-2.7-15.3c-1.8-4.5-4.4-8.5-7.8-11.7c-3.4-3.3-7.6-5.8-12.5-7.6 c-4.9-1.8-10.7-2.7-17.1-2.7h-34.1v108.8h17.7v-34.2h21L161.2,271.5z M137,221.2h-14.6v-42.1H137c8.3,0,14.4,1.8,18.3,5.5 c3.9,3.7,5.9,8.6,5.9,14.7c0,2.9-0.4,5.7-1.2,8.3c-0.8,2.7-2.2,5-4.1,7.1c-1.9,2.1-4.5,3.7-7.6,4.8 C145.3,220.6,141.5,221.2,137,221.2z M125.5,218.2H137c4.1,0,7.5-0.5,10.2-1.5c2.7-1,4.8-2.4,6.4-4.1c1.6-1.7,2.8-3.7,3.5-5.9 c0.7-2.3,1.1-4.8,1.1-7.4c0-5.3-1.6-9.4-4.9-12.5c-3.3-3.1-8.8-4.6-16.2-4.6h-11.6V218.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036220613309486867380000004757777840651109778_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.5952,
    y1: 274.4795,
    x2: 226.5952,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036220613309486867380000004757777840651109778_)"
    },
    d: "M261,274.5h-68.9V159.7H261v22.9h-45.2 v22.7H261v22.9h-45.2v23.3H261V274.5z M195.2,271.5H258v-16.9h-45.2v-29.3H258v-16.9h-45.2v-28.7H258v-16.9h-62.9V271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083796028863302802830000015360346285581727617_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.197,
    y1: 274.6328,
    x2: 307.197,
    y2: 159.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083796028863302802830000015360346285581727617_)"
    },
    d: "M310.1,274.6c-10.3,0-19.1-2-26.1-5.9 c-7-3.9-13.2-8.8-18.3-14.6l-1.1-1.2l21.5-16.3l0.9,1.4c2.7,4.4,6.1,7.9,10,10.2c3.9,2.3,8.3,3.5,13.1,3.5c5,0,8.9-1.3,11.5-4 c2.6-2.7,3.9-5.7,3.9-9.1c0-1.9-0.5-3.5-1.6-4.8c-1.2-1.4-2.8-2.7-4.7-3.7c-2-1.1-4.4-2.1-7.1-2.9c-2.8-0.9-5.6-1.8-8.6-2.7 c-3.8-1.2-7.6-2.5-11.3-3.9c-3.9-1.4-7.4-3.4-10.5-5.8c-3.1-2.4-5.7-5.5-7.7-9.1c-2-3.6-3-8.2-3-13.6c0-4.6,1-8.9,2.9-12.9 c1.9-3.9,4.6-7.4,8.1-10.4c3.4-2.9,7.5-5.3,12.2-6.9c4.7-1.6,9.8-2.5,15.2-2.5c4.5,0,8.7,0.4,12.4,1.3c3.7,0.8,7.1,2,10.2,3.5 c3.1,1.5,5.9,3.3,8.5,5.3c2.5,2,5,4.3,7.2,6.6l1.1,1.2l-19.6,15.4l-0.9-1.4c-4.5-7-10.7-10.4-18.8-10.4c-4.7,0-8.2,1.1-10.6,3.2 c-2.3,2.1-3.5,4.6-3.5,7.7c0,1.8,0.5,3.3,1.5,4.6c1.1,1.3,2.6,2.5,4.5,3.6c2,1.1,4.3,2.1,7,2.9l8.7,2.8c3.8,1.2,7.6,2.6,11.4,4.1 c3.9,1.6,7.5,3.7,10.7,6.2c3.2,2.5,5.9,5.7,7.9,9.4c2,3.7,3.1,8.4,3.1,13.9c0,4.4-0.9,8.8-2.7,13.1c-1.8,4.2-4.4,8-7.8,11.3 c-3.4,3.2-7.6,5.9-12.5,7.9C322,273.6,316.3,274.6,310.1,274.6z M268.9,253.3c4.7,5,10.2,9.3,16.5,12.8c6.6,3.7,14.9,5.6,24.7,5.6 c5.9,0,11.2-0.9,15.7-2.8c4.6-1.9,8.5-4.3,11.5-7.3c3.1-3,5.5-6.4,7.1-10.3c1.6-3.9,2.5-7.9,2.5-11.9c0-5-0.9-9.2-2.7-12.4 c-1.8-3.3-4.2-6.2-7.1-8.5c-3-2.3-6.3-4.3-10-5.7c-3.7-1.5-7.5-2.9-11.2-4.1l-8.7-2.8c-2.8-0.9-5.3-2-7.5-3.2 c-2.2-1.2-4-2.7-5.4-4.3c-1.4-1.8-2.2-3.9-2.2-6.5c0-3.9,1.5-7.2,4.5-9.9c2.9-2.6,7.1-4,12.6-4c8.6,0,15.4,3.5,20.4,10.4l14.5-11.3 c-1.8-1.8-3.8-3.6-5.8-5.2c-2.4-1.9-5-3.6-7.9-5c-2.9-1.4-6.1-2.5-9.6-3.3c-3.5-0.8-7.4-1.2-11.8-1.2c-5.1,0-9.9,0.8-14.2,2.3 c-4.3,1.5-8.1,3.7-11.2,6.3c-3.1,2.7-5.6,5.8-7.3,9.4c-1.7,3.5-2.6,7.4-2.6,11.5c0,4.9,0.9,9,2.6,12.1c1.8,3.2,4.1,6,6.9,8.2 c2.9,2.2,6.1,4,9.7,5.4c3.7,1.4,7.5,2.7,11.2,3.8c2.9,0.9,5.8,1.8,8.6,2.7c2.9,0.9,5.4,2,7.6,3.2c2.3,1.2,4.2,2.7,5.6,4.5 c1.5,1.9,2.3,4.1,2.3,6.8c0,4.2-1.6,7.9-4.8,11.2c-3.2,3.3-7.8,4.9-13.6,4.9c-5.3,0-10.2-1.3-14.6-3.9c-3.9-2.3-7.3-5.6-10.1-9.8 L268.9,253.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111191017103056104690000015617890882305897609_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.6692,
    y1: 274.4795,
    x2: 393.6692,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111191017103056104690000015617890882305897609_)"
    },
    d: "M405.4,274.5h-23.7v-91.9h-29.7v-22.9 h83.2v22.9h-29.8V274.5z M384.7,271.5h17.7v-91.9h29.8v-16.9h-77.2v16.9h29.7V271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137093434539965297980000012513850861662414777_",
    gradientUnits: "userSpaceOnUse",
    x1: 456.7415,
    y1: 274.4795,
    x2: 456.7415,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137093434539965297980000012513850861662414777_)"
    },
    d: "M468.6,274.5h-23.7V159.7h23.7V274.5z  M447.9,271.5h17.7V162.7h-17.7V271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101069252922403853720000012789764915767459494_",
    gradientUnits: "userSpaceOnUse",
    x1: 635.3064,
    y1: 274.4795,
    x2: 635.3064,
    y2: 159.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101069252922403853720000012789764915767459494_)"
    },
    d: "M669.8,274.5h-68.9V159.7h68.9v22.9h-45.2 v22.7h45.2v22.9h-45.2v23.3h45.2V274.5z M603.9,271.5h62.9v-16.9h-45.2v-29.3h45.2v-16.9h-45.2v-28.7h45.2v-16.9h-62.9V271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170967391448634564470000013784779718901463486_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.1062,
    y1: 274.6328,
    x2: 535.1062,
    y2: 159.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9407E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06860325,
    style: {
      stopColor: "#B9608E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1761,
    style: {
      stopColor: "#9E7FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#8493BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3674,
    style: {
      stopColor: "#6BA1CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4448,
    style: {
      stopColor: "#56A9D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#4DACD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    style: {
      stopColor: "#58A8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    style: {
      stopColor: "#709EC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8C8DB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#A9749D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C74580"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C9407E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170967391448634564470000013784779718901463486_)"
    },
    d: "M536.8,274.6c-8.8,0-16.9-1.5-24.2-4.6 c-7.3-3.1-13.6-7.3-18.7-12.5c-5.2-5.2-9.2-11.4-12-18.4c-2.8-6.9-4.2-14.4-4.2-22.1c0-7.9,1.5-15.5,4.4-22.5 c2.9-7,7-13.1,12.1-18.3c5.1-5.1,11.3-9.3,18.4-12.3c7.1-3,15-4.5,23.3-4.5c5.9,0,11.5,0.7,16.7,2.1c5.2,1.4,10,3.4,14.4,5.9 c3.6,2.1,7,4.6,10.1,7.4l0.9,0.8l-13.2,20.7l-1.3-1.6c-2.7-3.3-5.8-5.9-9.2-7.9c-5.1-2.8-11.2-4.3-18.2-4.3 c-4.9,0-9.6,0.9-13.8,2.8c-4.2,1.8-8,4.3-11.1,7.4c-3.1,3.1-5.6,6.8-7.4,10.9c-1.7,4.1-2.6,8.6-2.6,13.3c0,4.8,0.9,9.3,2.6,13.4 c1.7,4.1,4.2,7.8,7.4,10.9c3.1,3.1,6.9,5.6,11.3,7.3c4.4,1.8,9.2,2.7,14.3,2.7c7.9,0,14.6-2.1,19.8-6.3c4.8-3.8,8.2-8.8,10.2-14.9 h-34.9v-22.9h60.7v9.8c0,7.7-1.3,15.1-3.9,22c-2.6,6.9-6.4,13.1-11.2,18.3c-4.8,5.2-10.8,9.4-17.6,12.5 C553.1,273.1,545.3,274.6,536.8,274.6z M535.9,162.5c-8,0-15.4,1.4-22.2,4.3s-12.6,6.8-17.5,11.6c-4.9,4.9-8.7,10.7-11.5,17.3 c-2.8,6.6-4.1,13.8-4.1,21.3c0,7.3,1.3,14.4,4,21c2.7,6.6,6.5,12.4,11.4,17.4c4.9,5,10.9,9,17.8,11.9c6.9,2.9,14.6,4.4,23,4.4 c8.1,0,15.4-1.5,21.9-4.4c6.5-2.9,12.1-6.9,16.6-11.8c4.6-4.9,8.1-10.8,10.6-17.4c2.5-6.6,3.7-13.7,3.7-21v-6.8h-54.7v16.9h35.9 l-0.5,1.9c-2.1,7.6-6.1,13.8-11.8,18.4c-5.8,4.6-13.1,6.9-21.7,6.9c-5.5,0-10.8-1-15.5-2.9c-4.7-1.9-8.9-4.6-12.3-8 c-3.4-3.4-6.1-7.4-8-11.8c-1.9-4.5-2.9-9.4-2.9-14.6c0-5.1,1-10,2.9-14.4c1.9-4.5,4.6-8.5,8-11.8c3.4-3.4,7.5-6.1,12-8.1 c4.6-2,9.6-3,15-3c7.5,0,14.1,1.6,19.7,4.7c3.2,1.8,6.2,4.2,8.8,7l9.6-15.2c-2.7-2.3-5.6-4.4-8.6-6.2c-4.2-2.4-8.8-4.3-13.7-5.6 C546.8,163.2,541.5,162.5,535.9,162.5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M498.9,209.6c0.6,0.6,1.1,1.3,1.4,2.1c0.3,0.8,0.2,2.7-0.3,5.9c-0.5,3.2-1.7,7.2-3.5,12.2c-1.8,4.9-4.9,12.3-9.3,22 c-4.3,9.7-9.8,21.1-16.5,34.2c-12.1,23.9-23.9,46.2-35.4,66.8c-0.3,0.5-0.7,0.9-1.4,1.1c-0.7,0.2-1.3,0.2-1.9-0.2 c-0.6-0.4-1-0.9-1.2-1.5c-0.2-0.7-0.2-1.3,0.2-1.8c18-32.4,33.5-62.2,46.6-89.5c13-27.3,19-43.2,17.9-47.7 c-0.2,0.1-0.4,0.2-0.5,0.3c-2.5,1.2-5.7,3.5-9.7,7.2c-3.9,3.6-8.8,8.7-14.5,15.3c-5.8,6.6-10.6,12.2-14.5,16.8 c-3.9,4.6-9.4,11.2-16.5,19.8c-15.8,19.2-26.8,32.2-33.1,38.7c-6.3,6.6-10.9,9.5-13.7,8.8c-1.7-0.4-2.7-1.7-3-3.9 c-0.4-2.3,0-5.3,1.1-9c1.1-3.7,3-8.2,5.8-13.6c2.8-5.4,5.2-10,7.2-13.6c2-3.7,5-8.8,9-15.4c7.8-13.5,12.3-21.8,13.4-25 c-3.3,1.7-7.9,5.1-13.6,10.1c-5.7,5-12.4,11.8-20.1,20.4c-7.7,8.6-15.5,18-23.5,28.5s-16.2,22.5-24.8,36.4 c-8.6,13.8-16.3,27.9-23.1,42.1l-0.9,1.9l-2-0.7c-1.1-0.3-1.8-0.9-2.2-2c-1.1-2.8,1.4-9.9,7.3-21.3c5.9-11.5,16.9-30.8,32.8-58.1 c20.5-34.9,31.3-54.5,32.2-58.6c-0.4-0.4-0.5-0.9-0.5-1.5c0-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.7-0.7c1.2,0,2.1,0.5,2.7,1.5 c1,1.8-0.5,6.6-4.5,14.4c-4,7.8-13.3,24.2-28,49.2c-3.2,5.4-5.6,9.6-7.3,12.4c14.1-20.5,28.2-37.9,42.2-52.2 c14-14.3,24.1-22.7,30.3-25.2c2.3-0.8,4-0.6,5.1,0.7c1.3,1.5,1,4.3-0.7,8.3c-1.8,4-6.1,11.9-12.9,23.7c-3.4,5.8-6.1,10.4-8,13.8 c-1.9,3.4-4.2,7.7-7,12.8c-2.8,5.2-4.7,9.5-5.9,13c-1.2,3.5-1.8,6.3-1.7,8.4c1.4-0.6,3.6-2.3,6.4-5.1c2.8-2.8,6.4-6.7,10.9-11.9 c4.5-5.2,8.2-9.6,11.2-13.2c3-3.6,7.2-8.7,12.6-15.3c5.9-7.2,10.4-12.7,13.5-16.5c3.2-3.8,7.3-8.7,12.4-14.7 c5.1-6,9.3-10.6,12.4-13.9c3.2-3.3,6.5-6.4,9.9-9.4c3.5-3,6.3-5,8.6-6.1C495.4,207.8,497.5,208,498.9,209.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485.6,285.1c0.7,0,1.2-0.2,1.7-0.7c0.5-0.5,0.7-1.1,0.7-1.7c0-0.7-0.2-1.2-0.7-1.7c-0.5-0.4-1-0.7-1.7-0.7 s-1.3,0.2-1.8,0.7c-0.5,0.4-0.7,1-0.7,1.7c0,0.7,0.2,1.2,0.7,1.7C484.4,284.9,485,285.1,485.6,285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.7,285.1c0.7,0,1.2-0.2,1.7-0.7c0.5-0.5,0.7-1.1,0.7-1.7c0-0.7-0.2-1.2-0.7-1.7c-0.5-0.4-1-0.7-1.7-0.7 s-1.3,0.2-1.8,0.7c-0.5,0.4-0.7,1-0.7,1.7c0,0.7,0.2,1.2,0.7,1.7C712.4,284.9,713,285.1,713.7,285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.8,296.7c-0.2-0.7-0.7-1.2-1.3-1.5c-0.6-0.3-1.3-0.3-1.9-0.1c-12.7,4.3-24.6,8-35.6,11.2c-11,3.2-17.5,4.7-19.5,4.6 c-0.4-1-0.1-3.2,0.9-6.6c0.9-3.4,2.2-6.9,3.9-10.4c0.3-0.6,0.3-1.2,0.1-1.9c-0.2-0.6-0.7-1.1-1.3-1.4c-0.6-0.3-1.3-0.3-2-0.1 c-0.7,0.3-1.1,0.7-1.4,1.3c-0.6,1.3-1.1,2.5-1.6,3.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.7,1-3.2,2.6-7.5,4.9c-4.3,2.3-10,4.7-17,7.2 c-7.1,2.5-13.8,4.2-20.1,4.9c-3.2,0.4-5.6-0.1-7.2-1.3c-1.8-1.6-2.7-5.4-2.7-11.5c0-1.6,0-2.8-0.1-3.5c0-0.8-0.2-1.6-0.6-2.4 c-0.4-0.8-0.9-1.5-1.6-1.9c-1.4-0.7-2.9-0.5-4.7,0.7c-2.6,1.8-5.1,3.9-7.4,6.4c0.8-3.8,0.3-6.4-1.5-7.8c-1.1-0.9-2.3-1-3.8-0.3 c-1.7,0.8-5,4.1-10,9.9c-3.4,3.9-5.9,6.6-7.4,8c1.6-4,4.4-9.1,8.4-15.4c0.4-0.5,0.4-1.1,0.3-1.8c-0.2-0.7-0.6-1.2-1.1-1.5 c-0.6-0.4-1.2-0.5-1.9-0.3s-1.2,0.5-1.6,1c-0.9,1.4-1.7,2.7-2.4,3.9c-0.1,0-0.3,0.1-0.4,0.1c-5.1,1.7-10.5,3.2-16.1,4.5 c-5.6,1.3-11,2.4-16.4,3.1c-5.3,0.7-9.9,0.9-13.9,0.5c-3.9-0.4-6.5-1.5-7.6-3.3l-0.1-0.4l-0.4-0.3c-1.3-1-2.6-1.6-4-1.7 c-1.4-0.2-2.9,0-4.5,0.6c-1.6,0.6-2.9,1.1-3.9,1.7c-1,0.5-2.3,1.3-4.1,2.4c-3.2,2-5.4,3.1-6.8,3.5c-1.4,0.4-2.5,0.2-3.4-0.7 c-0.5-0.6-0.7-1.2-0.5-1.7c0.4-1.3,2.3-2.7,5.5-4.1c3.2-1.4,6.5-2.5,9.8-3.3c0.6-0.1,1.1-0.4,1.5-1c0.4-0.6,0.5-1.2,0.4-1.9 c-0.1-0.4-0.2-0.7-0.5-0.9c-0.2-0.3-0.5-0.5-0.7-0.6c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1,0c-1.2,0.3-2.5,0.6-3.9,1.1 c-1.4,0.4-3.3,1.1-5.5,2c-0.8,0.3-1.5,0.6-2.2,1c-0.5-0.1-1-0.1-1.5,0.1c-12.7,4.3-24.6,8-35.6,11.2c-11,3.2-17.5,4.7-19.5,4.6 c-0.4-1-0.1-3.2,0.9-6.6c0.9-3.4,2.2-6.9,3.9-10.4c0.3-0.6,0.3-1.2,0.1-1.9c-0.2-0.6-0.7-1.1-1.3-1.4c-0.6-0.3-1.3-0.3-2-0.1 c-0.7,0.3-1.1,0.7-1.4,1.3c-4.8,10.4-6.4,17.5-4.7,21.1c0.6,1.3,1.6,2.2,2.8,2.5c0.4,0.1,0.8,0.1,1.4,0.1 c5.9,0,22.4-4.5,49.6-13.4c-0.5,2,0,3.9,1.6,5.8c1.6,2,3.6,2.9,5.8,2.9c2.3,0,5.9-1.5,10.8-4.5c2.9-1.8,5.1-3,6.6-3.6 c1.5-0.6,2.8-0.6,3.9,0.1c1.7,2.3,4.7,3.9,9,4.7c4.3,0.8,8.7,1,13.2,0.5c4.5-0.4,9.7-1.3,15.3-2.5c5.7-1.2,10.1-2.3,13.2-3.2 c1.4-0.4,2.7-0.8,4-1.2c-3.3,6.3-4.4,10.5-3.5,12.5c0.5,1.1,1.4,1.7,2.6,2c1.5,0.3,3.2-0.4,5.1-2.1c1.9-1.6,4.9-4.8,8.9-9.4 c3.3-3.8,5.6-6.3,6.9-7.5c-0.2,0.7-0.4,1.7-0.7,2.9c-0.5,1.3-0.7,2.7-0.7,4s0.5,2.4,1.5,3.1c0.6,0.4,1.2,0.7,1.8,0.7 c0.6,0,1.2-0.2,1.8-0.6c0.6-0.4,1.1-0.8,1.6-1.2c0.4-0.4,0.9-0.9,1.6-1.6c2.5-2.9,4.9-5,7.2-6.6c0,0.5,0,1.3,0,2.4 c0,2.2,0,4,0.1,5.4c0.1,1.4,0.5,3.1,1.2,5c0.7,2,1.8,3.6,3.1,4.8c2.1,1.8,4.9,2.7,8.4,2.7c0.8,0,1.7,0,2.7-0.1 c9.4-1.2,19.2-3.9,29.5-8.4c4.9-2.1,8.9-4,11.9-5.7c-1.1,4.1-1.2,7.2-0.3,9.2c0.6,1.3,1.6,2.2,2.8,2.5c0.4,0.1,0.8,0.1,1.4,0.1 c6.4,0,25.5-5.3,57.2-15.9c0.6-0.3,1.1-0.7,1.4-1.3C767,298,767,297.4,766.8,296.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3,286.9h16.4v2.2H12.6v11.2h14.1v2.2H12.6v13.4h-2.3V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,286.9h2.3v29h-2.3V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,289h-9.1v-2.1h20.4v2.1h-9.1v26.9H57V289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,286.9h2.5l18.7,25.4v-25.4h2.3v29h-2.5l-18.7-25.5v25.5h-2.3V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,286.9h17.7v2.2h-15.4v11.2h15.4v2.1h-15.4v11.3h15.4v2.2h-17.7V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,316c-2.1,0-4-0.4-5.6-1.3c-1.6-0.8-2.9-2-4-3.4l1.9-1.4c0.9,1.3,2,2.3,3.3,3c1.3,0.7,2.8,1,4.4,1 c1,0,1.9-0.1,2.7-0.4c0.8-0.3,1.6-0.7,2.2-1.2c0.6-0.5,1.1-1.1,1.5-1.9s0.5-1.6,0.5-2.5c0-1-0.2-1.8-0.6-2.4 c-0.4-0.7-1-1.2-1.6-1.7s-1.5-0.9-2.4-1.2c-0.9-0.3-1.8-0.6-2.8-0.9c-1-0.3-2-0.7-3-1c-1-0.4-1.8-0.9-2.6-1.4 c-0.8-0.6-1.4-1.3-1.9-2.1s-0.7-1.8-0.7-3.1c0-1,0.2-2,0.7-2.9c0.4-0.9,1.1-1.6,1.8-2.3c0.8-0.6,1.7-1.1,2.7-1.5 c1-0.4,2.2-0.5,3.4-0.5c2,0,3.6,0.4,5,1.1s2.6,1.7,3.5,2.9l-1.8,1.3c-0.8-1.1-1.7-1.9-2.8-2.5c-1.1-0.6-2.4-0.8-4-0.8 c-0.9,0-1.7,0.1-2.5,0.4c-0.8,0.3-1.4,0.6-2,1.1c-0.6,0.5-1,1-1.3,1.6c-0.3,0.6-0.5,1.3-0.5,2.1c0,0.9,0.2,1.7,0.6,2.3 s0.9,1.1,1.6,1.6c0.7,0.4,1.4,0.8,2.3,1.1c0.9,0.3,1.8,0.6,2.7,0.9c1,0.3,2,0.7,3,1.1c1,0.4,1.9,0.9,2.7,1.5 c0.8,0.6,1.4,1.3,1.9,2.2c0.5,0.9,0.7,1.9,0.7,3.2c0,1.1-0.2,2.1-0.7,3.1c-0.5,1-1.1,1.8-1.9,2.5c-0.8,0.7-1.8,1.3-2.9,1.7 C148.2,315.7,147,316,145.6,316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,316c-2.1,0-4-0.4-5.6-1.3c-1.6-0.8-2.9-2-4-3.4l1.9-1.4c0.9,1.3,2,2.3,3.3,3c1.3,0.7,2.8,1,4.4,1 c1,0,1.9-0.1,2.7-0.4c0.8-0.3,1.6-0.7,2.2-1.2c0.6-0.5,1.1-1.1,1.5-1.9s0.5-1.6,0.5-2.5c0-1-0.2-1.8-0.6-2.4 c-0.4-0.7-1-1.2-1.6-1.7s-1.5-0.9-2.4-1.2c-0.9-0.3-1.8-0.6-2.8-0.9c-1-0.3-2-0.7-3-1c-1-0.4-1.8-0.9-2.6-1.4 c-0.8-0.6-1.4-1.3-1.9-2.1s-0.7-1.8-0.7-3.1c0-1,0.2-2,0.7-2.9c0.4-0.9,1.1-1.6,1.8-2.3c0.8-0.6,1.7-1.1,2.7-1.5 c1-0.4,2.2-0.5,3.4-0.5c2,0,3.6,0.4,5,1.1s2.6,1.7,3.5,2.9l-1.8,1.3c-0.8-1.1-1.7-1.9-2.8-2.5c-1.1-0.6-2.4-0.8-4-0.8 c-0.9,0-1.7,0.1-2.5,0.4c-0.8,0.3-1.4,0.6-2,1.1c-0.6,0.5-1,1-1.3,1.6c-0.3,0.6-0.5,1.3-0.5,2.1c0,0.9,0.2,1.7,0.6,2.3 s0.9,1.1,1.6,1.6c0.7,0.4,1.4,0.8,2.3,1.1c0.9,0.3,1.8,0.6,2.7,0.9c1,0.3,2,0.7,3,1.1c1,0.4,1.9,0.9,2.7,1.5 c0.8,0.6,1.4,1.3,1.9,2.2c0.5,0.9,0.7,1.9,0.7,3.2c0,1.1-0.2,2.1-0.7,3.1c-0.5,1-1.1,1.8-1.9,2.5c-0.8,0.7-1.8,1.3-2.9,1.7 C174.4,315.7,173.2,316,171.8,316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,316c-2.1,0-4-0.4-5.8-1.1c-1.8-0.8-3.4-1.8-4.7-3.1c-1.4-1.3-2.4-2.9-3.2-4.6c-0.8-1.8-1.2-3.6-1.2-5.7 c0-2,0.4-3.9,1.2-5.7c0.8-1.8,1.8-3.3,3.2-4.6c1.4-1.3,2.9-2.4,4.7-3.1c1.8-0.8,3.7-1.1,5.8-1.1c1.4,0,2.7,0.2,3.9,0.5 c1.3,0.4,2.4,0.8,3.5,1.5c1.1,0.6,2.1,1.4,3,2.3c0.9,0.9,1.7,1.9,2.3,2.9l-2,1.1c-1.1-1.8-2.6-3.3-4.4-4.5c-1.9-1.1-4-1.7-6.4-1.7 c-1.8,0-3.4,0.3-4.9,1c-1.5,0.7-2.8,1.5-4,2.7c-1.1,1.1-2,2.4-2.7,3.9c-0.6,1.5-1,3.1-1,4.8c0,1.7,0.3,3.3,1,4.8 c0.6,1.5,1.5,2.8,2.7,3.9c1.1,1.1,2.4,2,4,2.7c1.5,0.7,3.2,1,4.9,1c2.6,0,4.8-0.6,6.7-1.8c1.9-1.2,3.4-2.8,4.4-4.7l2,1 c-0.6,1.1-1.4,2.2-2.3,3.1s-1.9,1.8-3,2.4c-1.1,0.7-2.3,1.2-3.7,1.6C221,315.8,219.6,316,218.1,316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,286.9h2.3v26.8h13.8v2.2h-16.1V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,316c-1.4,0-2.7-0.2-3.9-0.7c-1.2-0.5-2.2-1.2-3.1-2.1s-1.6-1.9-2.1-3.1c-0.5-1.2-0.8-2.5-0.8-3.8v-19.3h2.3v19.4 c0,1,0.2,2,0.6,2.9c0.4,0.9,0.9,1.7,1.6,2.4c0.7,0.7,1.5,1.2,2.4,1.6c0.9,0.4,1.9,0.6,3,0.6c1.1,0,2.1-0.2,3-0.6 c0.9-0.4,1.7-0.9,2.4-1.6c0.7-0.7,1.2-1.5,1.6-2.4s0.6-1.9,0.6-2.9v-19.4h2.3v19.3c0,1.4-0.3,2.6-0.8,3.8c-0.5,1.2-1.2,2.2-2.1,3.1 c-0.9,0.9-1.9,1.6-3.1,2.1C276.1,315.7,274.7,316,273.3,316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,286.9h11.1c1.2,0,2.4,0.2,3.4,0.6c1,0.4,1.9,0.9,2.7,1.5c0.8,0.7,1.3,1.4,1.7,2.4c0.4,0.9,0.6,1.9,0.6,3 c0,1.5-0.4,2.8-1.1,3.9c-0.7,1.1-1.7,2-3,2.5c1.5,0.6,2.7,1.4,3.5,2.7c0.8,1.2,1.3,2.7,1.3,4.4c0,1.2-0.2,2.3-0.6,3.3 c-0.4,1-1,1.8-1.8,2.5c-0.8,0.7-1.7,1.2-2.7,1.6c-1,0.4-2.2,0.6-3.5,0.6H293V286.9z M295.3,289v10.9h9.1c0.9,0,1.7-0.1,2.4-0.4 s1.3-0.7,1.8-1.2c0.5-0.5,0.9-1.1,1.2-1.7c0.3-0.7,0.4-1.4,0.4-2.2s-0.2-1.5-0.5-2.1c-0.3-0.7-0.7-1.2-1.3-1.7 c-0.6-0.5-1.2-0.9-2-1.1c-0.8-0.3-1.6-0.4-2.5-0.4H295.3z M295.3,302v11.8h9.3c0.9,0,1.8-0.2,2.6-0.5c0.8-0.3,1.4-0.7,2-1.2 c0.6-0.5,1-1.1,1.3-1.9c0.3-0.7,0.5-1.5,0.5-2.3c0-0.8-0.1-1.6-0.4-2.4c-0.3-0.7-0.7-1.4-1.3-1.9c-0.6-0.5-1.2-0.9-2-1.2 c-0.8-0.3-1.7-0.4-2.7-0.4H295.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfcLogoSli);
export default __webpack_public_path__ + "static/media/pfc-Logo-sli.48d7a553b9e3e636bfa699f3a8627948.svg";
export { ForwardRef as ReactComponent };